import React from 'react';
import Select, {
    components,
} from 'react-select';
// import AdlForm from './integration_forms/Azure/adl';
// import AzureForm from './integration_forms/Azure/azure';
// import AdlGen2Form from './integration_forms/Azure/adl_gen2';
// import DatabricksTableForm from './integration_forms/Azure/AzuredatabricksTable';
// import S3Form from  './integration_forms/AWS/s3';
// import Redshift from  './integration_forms/AWS/AWS_redshift';
// import AthenaForm from './integration_forms/AWS/athena';
// import BigQueryForm  from  './integration_forms/GCS/big_query';
// import SnowflakeIntegration from './integration_forms/Snowflake/snowflake_integration_form';
// import PostgresForm from './integration_forms/postgres/postgres';
// import MySqlForm from './integration_forms/MYSQL/mysql_form';
// import AzureSynapseDSForm from './integration_forms/Azure/azure_synapse_ds';
import TestConnection from './testConnection';
// import AzureMicrosoftFabric from './integration_forms/Azure/azure_microsoft_fabric'
// import MicrosoftPurview from './integration_forms/Azure/microsoft_purview'
// import UnityCatalog from './integration_forms/Azure/unity_catalog'
import { helpContent, get_document_link, getSupportedDatasourceOptions } from "../../utils/common_utils";
// import AzureSQL  from  './integration_forms/Azure/azureSQL';
// import PowerBi  from  './integration_forms/PowerBi/PowerBi';
// import GcpSQL from './integration_forms/GCS/gcp_sql';
// import GcsForm from './integration_forms/GCS/gcs';
import { getIntegrationDetail, getQualdoIps } from "../../utils/event_handling"
import Load from '../../components/loadAction';
import Form from 'react-bootstrap/Form';
import { HardDrive, LockKeyhole, Check, Database, Eye, EyeOff, Layers2, FolderOpen, FolderTree, Plus, Trash2, TriangleAlert, Layers, Layers3, TextSearch, SquarePen, CircleCheck, Pencil } from "lucide-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import RcTooltip from 'rc-tooltip';
// import Alert from 'react-bootstrap/Alert';
import Modal from "react-bootstrap/Modal";
import $ from 'jquery';
import {
    POWER_BI_CONNECTOR, QUALDO_DOCUMENTATION,
    AZURE_SYNAPSE_DS_CONNECTOR
} from "../../utils/constant";
// import { FormGroup } from 'react-bootstrap';
import DynamicDatasourceForm from './DynamicDatasourceForm';
import datasourceConfig from './datasourceConfig.json';
import { testDataSource, createDataSource, editIntegrationById, updateIntegrationById, editDataSource } from '../../utils/configureEventHandling';
import { getDatasourceStatus } from '../../utils/configure_utils';

const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
};
const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
};

const customSelectDatasource = ({ children, ...props }) => (
    <components.Control {...props} className="has-icon">
        <svg width="18" height="18" viewBox="0 0 147 140" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1563_1485)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M134.806 60.0962L118.336 69.5862L134.806 78.9962C135.791 79.5655 136.654 80.3232 137.346 81.226C138.038 82.1289 138.546 83.1592 138.84 84.2582C139.134 85.3572 139.208 86.5033 139.059 87.6311C138.91 88.7589 138.541 89.8463 137.971 90.8312C137.402 91.8161 136.644 92.6793 135.741 93.3713C134.839 94.0634 133.808 94.5709 132.709 94.8648C131.61 95.1587 130.464 95.2333 129.336 95.0842C128.209 94.9352 127.121 94.5655 126.136 93.9962L96.6262 76.9962C95.2737 76.2137 94.1576 75.0807 93.3955 73.7166C92.6334 72.3526 92.2536 70.8081 92.2962 69.2462C92.3193 68.5695 92.4234 67.8981 92.6062 67.2462C93.2103 65.06 94.646 63.1972 96.6062 62.0562L126.116 45.1162C127.105 44.5445 128.198 44.1736 129.33 44.0245C130.463 43.8755 131.614 43.9513 132.718 44.2476C133.821 44.5439 134.855 45.0548 135.761 45.7513C136.667 46.4477 137.426 47.3159 137.996 48.3062C138.568 49.2879 138.94 50.3734 139.089 51.4999C139.239 52.6263 139.163 53.7712 138.866 54.868C138.569 55.9649 138.057 56.9919 137.361 57.8894C136.664 58.7869 135.795 59.537 134.806 60.0962ZM119.216 106.096L89.7162 89.1262C88.3964 88.3687 86.9013 87.9699 85.3796 87.9692C83.8579 87.9686 82.3625 88.3661 81.042 89.1224C79.7215 89.8787 78.6219 90.9674 77.8525 92.2803C77.0831 93.5932 76.6707 95.0845 76.6562 96.6062V130.506C76.7327 132.759 77.6812 134.893 79.3016 136.46C80.922 138.026 83.0875 138.901 85.3412 138.901C87.5949 138.901 89.7605 138.026 91.3809 136.46C93.0013 134.893 93.9498 132.759 94.0262 130.506V111.506L110.536 120.996C111.521 121.566 112.609 121.936 113.737 122.086C114.865 122.236 116.011 122.162 117.111 121.868C118.21 121.575 119.241 121.068 120.144 120.376C121.048 119.684 121.806 118.821 122.376 117.836C122.946 116.851 123.317 115.764 123.466 114.636C123.616 113.508 123.542 112.361 123.248 111.262C122.955 110.162 122.448 109.131 121.756 108.228C121.064 107.324 120.201 106.566 119.216 105.996V106.096ZM85.2162 72.9362L72.9162 85.0862C72.4954 85.4774 71.9501 85.7076 71.3762 85.7362H67.7662C67.1937 85.7018 66.6502 85.4724 66.2262 85.0862L53.9962 72.8962C53.6136 72.4787 53.3875 71.9416 53.3562 71.3762V67.7762C53.3892 67.2082 53.615 66.6685 53.9962 66.2462L66.2262 54.0562C66.6512 53.6729 67.1948 53.447 67.7662 53.4162H71.3762C71.9486 53.4429 72.4935 53.6693 72.9162 54.0562L85.1762 66.2462C85.5545 66.6695 85.7767 67.2093 85.8062 67.7762V71.3762C85.7785 71.9405 85.5559 72.4778 85.1762 72.8962L85.2162 72.9362ZM75.4162 69.5562C75.369 68.9732 75.1258 68.4234 74.7262 67.9962L71.1762 64.4862C70.7508 64.1036 70.2075 63.8778 69.6362 63.8462H69.5062C68.9375 63.876 68.3968 64.1022 67.9762 64.4862L64.4262 67.9962C64.0451 68.4256 63.8228 68.9727 63.7962 69.5462V69.6762C63.8214 70.2411 64.0444 70.7791 64.4262 71.1962L67.9962 74.6962C68.4177 75.0788 68.9579 75.3048 69.5262 75.3362H69.6562C70.2275 75.3046 70.7708 75.0788 71.1962 74.6962L74.7462 71.1662C75.1297 70.7483 75.359 70.2121 75.3962 69.6462L75.4162 69.5562ZM19.9262 33.0762L49.4362 49.9962C50.7575 50.7533 52.2539 51.1517 53.7768 51.1516C55.2996 51.1516 56.796 50.7532 58.1173 49.9961C59.4386 49.2389 60.5388 48.1492 61.3087 46.8353C62.0786 45.5214 62.4915 44.029 62.5062 42.5062V8.63619C62.4298 6.38379 61.4813 4.24919 59.8609 2.68284C58.2405 1.1165 56.0749 0.240938 53.8212 0.240938C51.5675 0.240938 49.402 1.1165 47.7816 2.68284C46.1612 4.24919 45.2127 6.38379 45.1362 8.63619V27.6362L28.6062 18.1362C27.6213 17.5663 26.5338 17.1959 25.4057 17.0462C24.2777 16.8966 23.1312 16.9706 22.0318 17.264C20.9323 17.5575 19.9014 18.0646 18.998 18.7564C18.0945 19.4483 17.3361 20.3113 16.7662 21.2962C16.1963 22.2811 15.8259 23.3686 15.6763 24.4967C15.5266 25.6247 15.6006 26.7712 15.8941 27.8706C16.1875 28.9701 16.6946 30.001 17.3864 30.9044C18.0783 31.8079 18.9413 32.5663 19.9262 33.1362V33.0762ZM84.6862 51.1562C86.4288 51.294 88.1722 50.9 89.6862 50.0262L119.186 33.0262C120.171 32.4563 121.034 31.6979 121.726 30.7944C122.418 29.891 122.925 28.8601 123.218 27.7606C123.512 26.6612 123.586 25.5147 123.436 24.3867C123.287 23.2586 122.916 22.1711 122.346 21.1862C121.776 20.2013 121.018 19.3383 120.114 18.6464C119.211 17.9546 118.18 17.4475 117.081 17.154C114.86 16.5614 112.495 16.8752 110.506 18.0262L93.9962 27.6062V8.60619C93.9198 6.35379 92.9713 4.21919 91.3509 2.65284C89.7305 1.0865 87.5649 0.210938 85.3112 0.210938C83.0575 0.210938 80.892 1.0865 79.2716 2.65284C77.6512 4.21919 76.7026 6.35379 76.6262 8.60619V42.5062C76.6235 44.701 77.4542 46.8149 78.9504 48.4207C80.4466 50.0264 82.4967 51.0041 84.6862 51.1562ZM54.4762 87.9962C52.7333 87.8546 50.9888 88.2488 49.4762 89.1262L19.9262 106.056C17.9371 107.207 16.4867 109.101 15.8941 111.322C15.3015 113.542 15.6152 115.907 16.7662 117.896C17.9173 119.885 19.8113 121.336 22.0318 121.928C24.2522 122.521 26.6171 122.207 28.6062 121.056L45.1362 111.566V130.566C45.2127 132.819 46.1612 134.953 47.7816 136.52C49.402 138.086 51.5675 138.961 53.8212 138.961C56.0749 138.961 58.2405 138.086 59.8609 136.52C61.4813 134.953 62.4298 132.819 62.5062 130.566V96.6062C62.5017 94.4225 61.6715 92.3212 60.1821 90.7243C58.6926 89.1273 56.6543 88.1527 54.4762 87.9962ZM46.4762 72.1262C47.0459 70.2529 46.96 68.2415 46.2328 66.4235C45.5057 64.6056 44.1806 63.0898 42.4762 62.1262L12.9962 45.1362C11.0053 43.9958 8.64409 43.6891 6.42786 44.283C4.21163 44.8768 2.32019 46.3231 1.16621 48.3062C0.594906 49.2876 0.223871 50.3726 0.0745668 51.4983C-0.074737 52.6241 0.000654668 53.7682 0.296381 54.8647C0.592107 55.9611 1.1023 56.988 1.79744 57.886C2.49258 58.7839 3.35887 59.5352 4.34621 60.0962L20.8162 69.5862L4.34621 78.9962C3.3613 79.5642 2.4979 80.3206 1.80531 81.2222C1.11272 82.1238 0.604499 83.1531 0.309673 84.2511C0.0148467 85.3492 -0.0608148 86.4946 0.0870081 87.6218C0.234831 88.7491 0.603243 89.8363 1.17121 90.8212C1.73918 91.8061 2.49558 92.6695 3.39722 93.3621C4.29886 94.0547 5.32809 94.5629 6.42615 94.8577C7.5242 95.1526 8.66957 95.2282 9.79686 95.0804C10.9242 94.9326 12.0113 94.5642 12.9962 93.9962L42.4762 76.9962C44.3746 75.9363 45.8005 74.196 46.4662 72.1262H46.4762ZM139.626 15.9062H138.296V17.5362H139.616C140.226 17.5362 140.616 17.2562 140.616 16.7362C140.616 16.2162 140.256 15.9062 139.616 15.9062H139.626ZM136.686 14.4062H139.686C141.306 14.4062 142.386 15.2962 142.386 16.6762C142.391 17.0603 142.294 17.4389 142.104 17.7729C141.914 18.1068 141.639 18.3841 141.306 18.5762L142.476 20.2562V20.5962H140.786L139.616 18.9962H138.296V20.5962H136.676L136.686 14.4062ZM144.986 17.6262C145.035 16.8692 144.926 16.1103 144.666 15.3976C144.406 14.6849 144.001 14.034 143.476 13.4859C142.952 12.9379 142.319 12.5047 141.619 12.2139C140.918 11.923 140.165 11.7808 139.406 11.7962C136.096 11.7962 133.896 14.1862 133.896 17.6262C133.896 20.9062 136.096 23.4462 139.406 23.4462C140.165 23.4644 140.919 23.3245 141.621 23.0354C142.323 22.7463 142.957 22.3143 143.483 21.7669C144.008 21.2195 144.414 20.5687 144.675 19.8558C144.936 19.1429 145.045 18.3836 144.996 17.6262H144.986ZM146.366 17.6262C146.366 21.5162 143.766 24.7662 139.366 24.7662C134.966 24.7662 132.476 21.4862 132.476 17.6262C132.476 13.7662 135.046 10.4862 139.366 10.4862C143.686 10.4862 146.356 13.7262 146.356 17.6262H146.366Z" fill="#29B5E8" />
            </g>
            <defs>
                <clipPath id="clip0_1563_1485">
                    <rect width="146.36" height="139.16" fill="white" />
                </clipPath>
            </defs>
        </svg>
        {children}
    </components.Control>
);
const customSelectSchema = ({ children, ...props }) => (
    <components.Control {...props} className="has-icon">
        <FolderTree size={18} color="#A4A7AE" />
        {children}
    </components.Control>
);
const customSelectDataset = ({ children, ...props }) => (
    <components.Control {...props} className="has-icon">
        <Layers3 size={18} color="#A4A7AE" />
        {children}
    </components.Control>
);

const formatGroupLabel = data => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
);


class Integration extends React.Component {
    constructor(props) {
        super(props);
        this.setForm = this.setForm.bind(this);
        this.closeTestConnection = this.closeTestConnection.bind(this);
        this.setIntegrationData = this.setIntegrationData.bind(this);
        this.setSubmitButton = this.setSubmitButton.bind(this);
        this.setData = this.setData.bind(this);
        this.fill_details = this.fill_details.bind(this);
        this.changeHelpContent = this.changeHelpContent.bind(this);
        this.getIntegrationDetail = getIntegrationDetail.bind(this);
        // this.renderForm = this.renderForm.bind(this);
        this.getQualdoIps = getQualdoIps.bind(this);
        this.editDatasourceDetails = this.editDatasourceDetails.bind(this);
        this.editSchemaAndModeSelection = this.editSchemaAndModeSelection.bind(this);
        this.handleContinueSchemaSelection = this.handleContinueSchemaSelection.bind(this);
        this.handleCreateDatasource = this.handleCreateDatasource.bind(this);
        const supportedDatasourceOptions = getSupportedDatasourceOptions();

        let formType = "";
        if (supportedDatasourceOptions.length > 0) {

            formType = supportedDatasourceOptions[0].options[0].value;
            // formType = supportedDatasourceOptions[4].options[0].value;
            // formType = supportedDatasourceOptions[3].options[0].value;

        }



        this.state = {
            submit_button: false,
            testConnection: null,
            data_source_options: supportedDatasourceOptions,
            formType: formType,
            //  formType_option:{"label":"Azure Blob", "value":'azure_blob'},
            formType_option: { "label": 'Snowflake', "value": 'snowflake' },
            helpContentKey: formType,
            integration_data: {
                integration_type: formType,
                data_store_type: "filesystem"
            },
            ex_edit_integration_details: null,
            ip_address: null,

            selected: true, // All Schemas selected by default
            specificSelect: false,
            expandIncrementalData: null,
            partitionData: null,
            showSchemeModal: false,
            schemeModalLoading: false, // Track if modal is in loading state
            configurationMode: 'autoconfig', // Autoconfig selected by default
            schemaModeSelection: 'allSchemas', // Track selected schema mode
            showSchemaConfigInfo: null, // Show schema configuration info after clicking Next
            showTestConnectionInfo: false, // Control visibility of test connection info panel
            schemaSearchText: '', // Search text for filtering schemas in modal

            // For DynamicDatasourceForm
            isTestingConnection: false,
            testConnectionSuccess: null,
            testConnectionResponse: null, // Store API response (schemas, stages, etc.)
            testConnectionFormData: null, // Store form data used for test connection
            selectedSchemas: [], // Store selected schemas
            formResetKey: 0, // Key to force form reset
            isCreatingDatasource: false, // Track datasource creation status
            testConnectionError: null, // Store error message when connection fails

            // Manual configuration mode state
            integrationConfigurations: [], // Array of integration configurations
            integrationDetailsMap: {}, // Map integrationName -> integration detail object
            datasetToBeProcessed: 'allDatasets', // 'allDatasets' or 'specifiedDatasets'
            storeDataIssues: false, // Checkbox state for storing data issues
            manualNextClicked: false, // Track if Next button in manual mode was clicked
            editingIntegrationId: null,
            editingIntegrationName: "",
            integrationValidationErrors: {}, // { [configId]: { schema?: string, datasets?: { [itemId]: string } } }
            datasourceLevelIntegrations: [], // Authoritative list of ALL integrations from GET /datasource

            // Confirm-before-remove modal state (for edit mode sub-items)
            confirmRemoveModal: null, // { type: 'integration'|'incremental'|'partition', configId, itemId, label }
            confirmRemoveName: '',
        };
    }

    componentDidMount() {
        this.getQualdoIps();
        this.fill_details();
        window.addEventListener('trigger-integration-save', this.handleTriggerSave);
    }

    componentWillUnmount() {
        window.removeEventListener('trigger-integration-save', this.handleTriggerSave);
    }

    handleTriggerSave = () => {
        this.handleSaveIntegration();
    }

    async getIntegrationDetailById(integration_id, env_id) {
        if (integration_id !== undefined && integration_id !== null) {
            let teamId = localStorage.getItem('team_id');
            let userId = localStorage.getItem('user_id');
            let data = { integration_id: integration_id, tenant_id: teamId, user_id: userId, env_id: env_id };

            // Fetch integration details and full datasource details in parallel.
            // The datasource API is the authoritative source for ALL integrations on this datasource.
            const response = await editIntegrationById(data);
            if (response.code === 200) {
                let integration_details = response.integration;
                // console.log("integrationDetails", integration_details?.integration_config);

                // Get datasource type from response (could be datasource_type or connector_type)
                const datasourceType = integration_details.datasource_type || integration_details.connector_type;

                // Map the response to form data format for pre-filling
                const formData = this.mapDatasourceResponseToFormData(integration_details, datasourceType);

                // Support both nested datasource_config and root-level integration config payloads
                const integrationPayload = integration_details.datasource_config || integration_details;

                // Determine configuration mode from response
                const configMode = integration_details.mode === 'manualConfig' ? 'manual' : 'autoconfig';

                // Fetch the full datasource to get the authoritative integration_names list.
                // This is needed because the GET /integration response only contains the single
                // integration_config for the record being fetched, not all sibling integrations.
                let datasourceLevelIntegrations = [];
                if (configMode === 'manual' && integration_details.datasource_id) {
                    try {
                        const dsResponse = await editDataSource({
                            datasource_id: integration_details.datasource_id,
                            tenant_id: teamId,
                            user_id: userId,
                            env_id: env_id
                        });
                        if (dsResponse?.code === 200 && dsResponse.datasource) {
                            const dsConfig = dsResponse.datasource.datasource_config || {};
                            const dsIntegrations = dsConfig.integration_names || dsConfig.integration_config || [];
                            datasourceLevelIntegrations = Array.isArray(dsIntegrations)
                                ? dsIntegrations
                                : (dsIntegrations ? [dsIntegrations] : []);
                            // console.log('Datasource-level integrations (authoritative):', datasourceLevelIntegrations);
                        }
                    } catch (e) {
                        console.warn('Could not fetch datasource details, falling back to integration response:', e);
                    }
                }

                // Extract schemas — prefer datasource-level schema_names (most complete)
                let schemas = [];
                const configData = integrationPayload.integration_config || integrationPayload;
                if (configData.schema_names || configData.buckets) {
                    schemas = configData.schema_names || configData.buckets;
                } else if (datasourceLevelIntegrations.length > 0) {
                    schemas = [...new Set(
                        datasourceLevelIntegrations
                            .map(config => config.bucket || config.schema || config.schema_name)
                            .filter(Boolean)
                    )];
                } else if (configData.bucket) {
                    schemas = [configData.bucket];
                } else if (configData.schema) {
                    schemas = [configData.schema];
                }

                // Determine schema mode selection
                let schemaToBeProcessed = configData.schemaToBeProcessed || configData.auto_config_type || integrationPayload.schemaToBeProcessed || integrationPayload.auto_config_type;
                if (configMode === 'manual') {
                    schemaToBeProcessed = 'specifiedSchema';
                }
                const schemaModeSelection = (schemaToBeProcessed === 'specifiedSchema' || schemaToBeProcessed === 'specifiedBucket' || schemaToBeProcessed === 'specificSchemas' || schemaToBeProcessed === 'specificBuckets' || schemaToBeProcessed === 'specifiedDataset') ? 'specificSchemas' : 'allSchemas';
                const isAllSchemas = schemaModeSelection === 'allSchemas';
                const isSpecificSchemas = schemaModeSelection === 'specificSchemas';

                // Build a lookup of integration_name to details object
                const integrationDetailsMap = {
                    [integration_details.integration_name]: integration_details
                };

                // For manualConfig: load only the single integration being edited into the UI.
                // datasourceLevelIntegrations is stored separately as the authoritative list for save.
                let rawIntegrationConfigs =
                    integrationPayload.integration_config ||
                    integrationPayload.integration_names ||
                    [];

                // integration_config from the GET /integration response is the single integration
                // being edited. Normalize to array for mapIntegrationConfigToState.
                if (rawIntegrationConfigs && !Array.isArray(rawIntegrationConfigs)) {
                    rawIntegrationConfigs = [rawIntegrationConfigs];
                } else if (Array.isArray(rawIntegrationConfigs)) {
                    // If backend returns an array, find the specific integration being edited
                    const match = rawIntegrationConfigs.find(
                        c => c.integration_name === integration_details.integration_name
                    );
                    if (match) {
                        rawIntegrationConfigs = [match];
                    }
                }

                const integrationConfigs = this.mapIntegrationConfigToState(
                    rawIntegrationConfigs,
                    integrationDetailsMap,
                    integration_details.integration_name
                );

                // For edit mode, set test connection as successful since connection was already validated
                const testConnectionResponse = {
                    message: "Connection already validated",
                    schemas: schemas
                };

                this.setState({
                    ex_edit_integration_details: integration_details,
                    datasourceLevelIntegrations: datasourceLevelIntegrations,
                    testConnectionFormData: formData,
                    formType: this.mapApiDatasourceTypeToFormType(datasourceType),
                    formType_option: this.getFormTypeOption(datasourceType),
                    testConnectionSuccess: true,
                    testConnectionResponse: testConnectionResponse,
                    showTestConnectionInfo: true,
                    selectedSchemas: schemas,
                    configurationMode: configMode,
                    schemaModeSelection: schemaModeSelection,
                    selected: isAllSchemas,
                    specificSelect: isSpecificSchemas,
                    showSchemaConfigInfo: true,
                    manualNextClicked: configMode === 'manual',
                    integrationConfigurations: integrationConfigs,
                    integrationDetailsMap: integrationDetailsMap
                });
            }
        }
    }

    // Map API datasource type to form type
    mapApiDatasourceTypeToFormType = (apiType) => {
        // Safety check for undefined/null
        if (!apiType) {
            console.warn('mapApiDatasourceTypeToFormType: apiType is undefined or null');
            return 'snowflake'; // Default fallback
        }

        const mapping = {
            'MySQL': 'mysql',
            'PostgreSQL': 'postgresql',
            'Snowflake': 'snowflake',
            'snow_flake': 'snowflake', // Handle API format
            'Azure Blob': 'azure_blob',
            'Azure Data Lake Gen2': 'azure_data_lake_gen2',
            'AWS S3': 's3',
            'Google Cloud Storage': 'google_cloud_storage',
            'BigQuery': 'bigquery',
            'Redshift': 'redshift',
            'Azure Synapse': 'azure_synapse',
            'Azure SQL': 'azure_sql',
            'Databricks': 'databricks',
            'Neo4j': 'neo4j',
            'Amazon Neptune': 'amazon_neptune',
            'Azure Cosmos DB (Gremlin API)': 'azure_cosmos_gremlin',
            'Google Cloud Spanner Graph': 'spanner_graph',
            'Pinecone': 'pinecone',
            'Elasticsearch': 'elasticsearch',
            'Postgres Vector': 'postgres_vector',
            'Azure Microsoft Fabric': 'azure_microsoft_fabric',
            'Microsoft Purview': 'microsoft_purview',
            'Databricks Unity Catalog': 'unity_catalog'
        };
        return mapping[apiType] || apiType.toLowerCase().replace(/\s+/g, '_');
    }

    // Get form type option object
    getFormTypeOption = (apiType) => {
        if (!apiType) {
            return { label: 'Snowflake', value: 'snowflake' }; // Default fallback
        }

        const formType = this.mapApiDatasourceTypeToFormType(apiType);

        // Map back to display label
        const labelMapping = {
            'snowflake': 'Snowflake',
            'snow_flake': 'Snowflake',
            'mysql': 'MySQL',
            'postgresql': 'PostgreSQL',
            'azure_blob': 'Azure Blob',
            'azure_data_lake_gen2': 'Azure Data Lake Gen2',
            's3': 'AWS S3',
            'aws_s3': 'AWS S3',
            'google_cloud_storage': 'Google Cloud Storage',
            'bigquery': 'BigQuery',
            'redshift': 'Redshift',
            'azure_synapse': 'Azure Synapse',
            'azure_sql': 'Azure SQL',
            'databricks': 'Databricks',
            'neo4j': 'Neo4j',
            'amazon_neptune': 'Amazon Neptune',
            'azure_cosmos_gremlin': 'Azure Cosmos DB (Gremlin API)',
            'spanner_graph': 'Google Cloud Spanner Graph',
            'pinecone': 'Pinecone',
            'elasticsearch': 'Elasticsearch',
            'postgres_vector': 'Postgres Vector',
            'azure_microsoft_fabric': 'Azure Microsoft Fabric',
            'microsoft_purview': 'Microsoft Purview',
            'unity_catalog': 'Databricks Unity Catalog'
        };

        return {
            label: labelMapping[formType] || apiType,
            value: formType
        };
    }

    // Map datasource response to form data format
    mapDatasourceResponseToFormData = (datasource, datasourceType) => {
        const config = datasource.datasource_config || datasource.integration_config || {};
        const authConfig = datasource.auth_config || {};

        // Normalize datasource type (could be from datasource_type or connector_type)
        const normalizedType = this.mapApiDatasourceTypeToFormType(datasourceType);

        // Base form data
        const formData = {
            datasource_name: datasource.datasource_name || '',
        };

        // Map based on normalized datasource type
        if (normalizedType === 'snowflake') {
            // Snowflake mapping
            const hostValue = config.host_url || config.url || config.host || config.account || '';
            const databaseValue = config.database_name || config.database || '';
            formData.host_url = hostValue;
            formData.host = hostValue;
            formData.warehouse = config.ware_house || config.warehouse || '';
            formData.database_name = databaseValue;
            formData.database = databaseValue;
            formData.schema = config.schema || '';
            formData.username = authConfig.user || authConfig.username || '';
            formData.user_name = authConfig.user_name || authConfig.user || authConfig.username || '';
            formData.password = authConfig.password || '';
            formData.role = config.role || '';

            // Set auth method based on available credentials
            if (authConfig.private_key && authConfig.private_key.trim() !== '') {
                formData.authMethod = 'Private Key';
                formData.privateKey = authConfig.private_key || '';
                formData.privateKeyPassphrase = authConfig.private_key_pwd || '';
            } else {
                formData.authMethod = 'Username & Password';
            }
        } else if (normalizedType === 'mysql' || normalizedType === 'postgresql') {
            // MySQL/PostgreSQL mapping
            formData.host = config.host || config.host_url || config.url || '';
            formData.database = config.database || config.database_name || '';
            formData.schema = config.schema || config.schema_name || '';
            formData.schema_name = config.schema_name || config.schema || '';
            formData.username = authConfig.user || authConfig.username || authConfig.user_name || '';
            formData.user_name = authConfig.user_name || authConfig.user || authConfig.username || '';
            formData.password = authConfig.password || '';
            formData.ssl_mode = config.ssl_mode || 'disable';
        } else if (normalizedType === 'azure_blob') {
            // Azure Blob integration mapping — reads from integration_config
            const intConfig = datasource.integration_config || config;
            formData.storage_name = intConfig.storage_name || config.storage_name || '';
            formData.fileType = intConfig.filetype || intConfig.fileType || config.filetype || config.fileType || '';
            formData.refreshType = intConfig.refresh_type || config.refresh_type || 'file_replace';

            const rawVersionFormat = intConfig.version_format || config.version_format || '';
            if (rawVersionFormat === 'none' || rawVersionFormat === '') {
                formData.versionFormat = '';
                formData.versionFormatRegex = '';
            } else if (['dd-mm-yyyy', 'yyyy-mm-dd', 'dd-mm-yy'].includes(rawVersionFormat)) {
                formData.versionFormat = rawVersionFormat;
                formData.versionFormatRegex = '';
            } else {
                formData.versionFormat = 'custom';
                formData.versionFormatRegex = rawVersionFormat;
            }
            formData.versionOccurence = intConfig.version_occurence || config.version_occurence || 'prefix';
            formData.blob_secret = authConfig.secret_key || authConfig.blob_secret || '';
            // Store per-integration fields so the card pre-fills correctly
            formData.bucket = intConfig.bucket || '';
            formData.sub_path = intConfig.sub_path || '';
            formData.integration_name_field = intConfig.integration_name || datasource.integration_name || '';
        } else if (normalizedType === 'azure_data_lake_gen2') {
            // Azure Blob integration mapping — reads from integration_config
            const intConfig = datasource.integration_config || config;
            formData.storage_name = intConfig.storage_name || config.storage_name || '';
            formData.fileType = intConfig.filetype || intConfig.fileType || config.filetype || config.fileType || '';
            formData.refreshType = intConfig.refresh_type || config.refresh_type || 'file_replace';

            const rawVersionFormat = intConfig.version_format || config.version_format || '';
            if (rawVersionFormat === 'none' || rawVersionFormat === '') {
                formData.versionFormat = '';
                formData.versionFormatRegex = '';
            } else if (['dd-mm-yyyy', 'yyyy-mm-dd', 'dd-mm-yy'].includes(rawVersionFormat)) {
                formData.versionFormat = rawVersionFormat;
                formData.versionFormatRegex = '';
            } else {
                formData.versionFormat = 'custom';
                formData.versionFormatRegex = rawVersionFormat;
            }
            formData.versionOccurence = intConfig.version_occurence || config.version_occurence || 'prefix';
            formData.blob_secret = authConfig.secret_key || authConfig.blob_secret || '';
            // Store per-integration fields so the card pre-fills correctly
            formData.bucket = intConfig.bucket || '';
            formData.sub_path = intConfig.sub_path || '';
            formData.integration_name_field = intConfig.integration_name || datasource.integration_name || '';
        }else if (normalizedType === 's3' || normalizedType === 'aws_s3') {
            // AWS S3 mapping
            const intConfig = datasource.integration_config || config;
            formData.fileType = intConfig.filetype || intConfig.fileType || config.filetype || config.fileType || '';
            formData.refreshType = intConfig.refresh_type || config.refresh_type || 'file_replace';

            const rawVersionFormat = intConfig.version_format || config.version_format || '';
            if (rawVersionFormat === 'none' || rawVersionFormat === '') {
                formData.versionFormat = '';
                formData.versionFormatRegex = '';
            } else {
                formData.versionFormat = rawVersionFormat;
                formData.versionFormatRegex = '';
            }

            formData.versionOccurence = intConfig.version_occurence || config.version_occurence || 'prefix';
            formData.accessKey = authConfig.access_key || authConfig.accessKey || authConfig.access_key_id || '';
            formData.secretAccessKey = authConfig.secret_access_key || authConfig.secretAccessKey || '';
            formData.bucket = intConfig.bucket || '';
            formData.sub_path = intConfig.sub_path || '';
            formData.integration_name_field = intConfig.integration_name || datasource.integration_name || '';
        } else if (normalizedType === 'google_cloud_storage') {
            // Google Cloud Storage mapping
            formData.bucket_name = config.bucket_name || '';
            formData.project_id = config.project_id || '';
            formData.credentials_json = authConfig.credentials_json || '';
        } else if (normalizedType === 'bigquery') {
            // BigQuery mapping
            formData.project_id = config.project_id || '';
            formData.dataset_id = config.dataset_id || '';
            formData.credentials_json = authConfig.credentials_json || '';
            // ==================== GRAPH DB TYPES ====================
        } else if (normalizedType === 'neo4j') {
            // Neo4j mapping
            formData.graph_db_type = config.graph_db_type || 'neo4j';

            // Connection details
            formData.host = config.host || config.host_url || config.url || '';
            formData.port = config.port || '';
            formData.protocol = config.protocol || '';
            formData.database = config.database || config.database_name || '';

            // Authentication
            formData.user_name = authConfig.user_name || authConfig.user || authConfig.username || '';
            formData.user = authConfig.user || authConfig.user_name || authConfig.username || '';
            formData.password = authConfig.password || authConfig.pwd || '';
            formData.pwd = authConfig.pwd || authConfig.password || '';

            // Error handling
            formData.created_time = config.created_time || '';
            formData.error_storage = config.error_storage || '';
        } else if (normalizedType === 'amazon_neptune') {
            // Amazon Neptune mapping
            formData.graph_db_type = config.graph_db_type || 'amazon_neptune';

            // Connection details
            formData.host = config.host || config.host_url || config.url || '';
            formData.port = config.port || '';
            formData.database = config.database || config.database_name || '';
            formData.aws_region = authConfig.aws_region || config.aws_region || '';
            
            // Authentication
            formData.aws_access_key = authConfig.aws_access_key || '';
            formData.aws_secret_key = authConfig.aws_secret_key || '';
            
            // Error handling
            formData.created_time = config.created_time || '';
            formData.error_storage = config.error_storage || '';

        } else if (normalizedType === 'azure_cosmos_gremlin') {
            // Azure Cosmos DB (Gremlin API) mapping
            formData.graph_db_type = config.graph_db_type || 'azure_cosmos_gremlin';
            
            // Connection details
            formData.host = config.host || config.host_url || config.url || '';
            formData.port = config.port || '';
            formData.database = config.database || config.database_name || '';
            formData.graph = config.graph || '';
            
            // Authentication
            formData.primary_key = authConfig.primary_key || authConfig.access_key || '';
            
            // Error handling
            formData.created_time = config.created_time || '';
            formData.error_storage = config.error_storage || '';

        } else if (normalizedType === 'spanner_graph') {
            // Google Cloud Spanner Graph mapping
            formData.graph_db_type = config.graph_db_type || 'spanner_graph';
            
            // Connection details
            formData.project_id = config.project_id || '';
            formData.instance_id = config.instance_id || '';
            formData.database = config.database || config.database_name || '';
            formData.graph_name = config.graph_name || config.graph || '';
            
            // Authentication
            formData.service_account_key_file = authConfig.service_account_key_file || authConfig.service_account_key || '';
            
            // Error handling
            formData.created_time = config.created_time || '';
            formData.error_storage = config.error_storage || '';

        // ==================== VECTOR DB TYPES ====================

        } else if (normalizedType === 'pinecone') {
            // Pinecone mapping
            formData.vector_db_type = config.vector_db_type || 'pinecone';
            
            // Connection details
            formData.host = config.host || config.host_url || config.url || '';
            formData.port = config.port || '';
            formData.protocol = config.protocol || '';
            formData.index_name = config.index_name || config.index || '';
            formData.namespace = config.namespace || '';
            formData.environment = config.environment || '';
            
            // Authentication
            formData.api_key = authConfig.api_key || config.api_key || '';
            
            // Error handling
            formData.created_time = config.created_time || '';
            formData.error_storage = config.error_storage || '';

        } else if (normalizedType === 'elasticsearch') {
            // Elasticsearch mapping
            formData.vector_db_type = config.vector_db_type || 'elasticsearch';
            
            // Connection details
            formData.host = config.host || config.host_url || config.url || '';
            formData.port = config.port || '';
            formData.protocol = config.protocol || '';
            formData.index_name = config.index_name || config.index || '';
            
            // Authentication
            formData.api_key = authConfig.api_key || config.api_key || '';
            formData.user_name = authConfig.user_name || authConfig.user || authConfig.username || '';
            formData.user = authConfig.user || authConfig.user_name || authConfig.username || '';
            formData.password = authConfig.password || authConfig.pwd || '';
            
            // Dynamic metadata
            formData.region = config.region || '';
            
            // Error handling
            formData.created_time = config.created_time || '';
            formData.error_storage = config.error_storage || '';

        } else if (normalizedType === 'postgres_vector') {
            // PostgreSQL Vector mapping
            formData.vector_db_type = config.vector_db_type || 'postgres_vector';
            
            // Connection details
            formData.host = config.host || config.host_url || config.url || '';
            formData.port = config.port || '';
            formData.database = config.database || config.database_name || '';
            formData.table_name = config.table_name || config.table || '';
            
            // Authentication
            formData.user_name = authConfig.user_name || authConfig.user || authConfig.username || '';
            formData.user = authConfig.user || authConfig.user_name || authConfig.username || '';
            formData.password = authConfig.password || authConfig.pwd || '';
            
            // Schema
            formData.schema = config.schema || '';
            
            // Error handling
            formData.created_time = config.created_time || '';
            formData.error_storage = config.error_storage || '';

        } else if (normalizedType === 'redshift') {
            // Redshift mapping
            formData.host = config.host || '';
            formData.port = config.port || '';
            formData.database = config.database || '';
            formData.username = authConfig.user || authConfig.username || '';
            formData.password = authConfig.password || '';
            formData.cluster_identifier = config.cluster_identifier || '';
        } else if (normalizedType === 'azure_synapse') {
            // Azure Synapse mapping
            formData.server = config.server || '';
            formData.database = config.database || '';
            formData.username = authConfig.user || authConfig.username || '';
            formData.password = authConfig.password || '';
            formData.authentication_method = authConfig.authentication_method || 'SQL';
        } else if (normalizedType === 'azure_sql') {
            // Azure SQL mapping
            formData.server = config.server || '';
            formData.database = config.database || '';
            formData.port = config.port || '';
            formData.username = authConfig.user || authConfig.username || '';
            formData.password = authConfig.password || '';
            formData.driver = config.driver || '';
        } else if (normalizedType === 'databricks') {
            // Databricks mapping
            formData.host = config.host || '';
            formData.http_path = config.http_path || '';
            formData.catalog = config.catalog || '';
            formData.schema = config.schema || '';
            formData.access_token = authConfig.access_token || '';
         } else if (normalizedType === 'azure_microsoft_fabric') {
            // Databricks mapping
            formData.host = config.host || '';
            formData.http_path = config.http_path || '';
            formData.catalog = config.catalog || '';
            formData.schema = config.schema || '';
            formData.access_token = authConfig.access_token || '';
        } else if (normalizedType === 'microsoft_purview' || normalizedType === 'purview') {
            // Microsoft Purview mapping
            formData.purview_url = config.purview_url || '';
            formData.collection_id = config.collection_id || '';
            formData.asset_type = config.asset_type || '';
            formData.qualified_name_prefix = config.qualified_name_prefix || '';
            formData.tenant_id = authConfig.tenant_id || config.tenant_id || '';
            formData.client_id = authConfig.client_id || '';
            formData.client_secret = authConfig.client_secret || '';

        } else if (normalizedType === 'unity_catalog') {
            // Databricks Unity Catalog mapping
            formData.database_type = config.database_type || '';
            formData.host = config.host || '';
            formData.database = config.database || '';
            formData.sfWarehouse = config.sfWarehouse || '';
            formData.sfRole = config.sfRole || '';
            formData.project_id = config.project_id || '';
            formData.aws_region = config.aws_region || '';
            formData.s3_staging_dir = config.s3_staging_dir || '';
            formData.user_name = authConfig.user_name || authConfig.user || '';
            formData.password = authConfig.password || '';
            formData.json_file = authConfig.json_file || authConfig.credentials_json || '';
            formData.access_key_id = authConfig.access_key_id || '';
            formData.secret_access_key = authConfig.secret_access_key || '';

        }
        else {
            // Generic mapping for other datasource types
            Object.keys(config).forEach(key => {
                if (key !== 'error_storage' && key !== 'default_error_storage' && key !== 'schemaToBeProcessed' && key !== 'integration_config') {
                    formData[key] = config[key];
                }
            });
            Object.keys(authConfig).forEach(key => {
                // Map common auth field names
                if (key === 'user') {
                    formData.username = authConfig[key];
                } else {
                    formData[key] = authConfig[key];
                }
            });
        }

        return formData;
    }

    // Map integration_config from API response to component state format
    mapIntegrationConfigToState = (integrationConfigArray, integrationDetailsMap = {}, fallbackIntegrationName = '') => {
        if (!Array.isArray(integrationConfigArray) || integrationConfigArray.length === 0) {
            return [];
        }

        // console.log('mapIntegrationConfigToState - Input:', integrationConfigArray);

        return integrationConfigArray.map((apiConfig, index) => {
            // For azure_blob the schema key is 'bucket'; for others it's 'schema_name' or 'schema'
            const schemaValue = apiConfig.bucket || apiConfig.schema_name || apiConfig.schema || null;
            const tableNamesValue = Array.isArray(apiConfig.table_names) ? apiConfig.table_names : [];

            // Map table_names to incrementalData format, always include all required fields with defaults
            const incrementalData = tableNamesValue.map((tableItem, tableIndex) => {
                const mapped = {
                    id: Date.now() + index * 1000 + tableIndex,
                    datasetName: tableItem.table || '',
                    identifier: tableItem.identifier || tableItem.created_time || '',
                    startingIndexCheckbox:
                        tableItem.start_index_check_box === 'true' ||
                        tableItem.start_index_check_box === true ||
                        tableItem.start_index_check_box === 'match_exact',
                    startingIndexType: tableItem.start_index_type || 'incremental data identifier',
                    startingIndexValue: tableItem.start_with || '',
                    startingIndexQuery: tableItem.start_with_query || '',
                    exactMatch: tableItem.match_exact === 'match_exact' || tableItem.match_exact === true,
                    isNew: false,
                    originalDatasetName: tableItem.table || '',
                    originalIdentifier: tableItem.identifier || tableItem.created_time || '',
                    originalStartingIndexCheckbox:
                        tableItem.start_index_check_box === 'true' ||
                        tableItem.start_index_check_box === true ||
                        tableItem.start_index_check_box === 'match_exact',
                    originalStartingIndexType: tableItem.start_index_type || 'incremental data identifier',
                    originalStartingIndexValue: tableItem.start_with || '',
                    originalStartingIndexQuery: tableItem.start_with_query || '',
                    created_time: tableItem.created_time || '',
                    match_exact: tableItem.match_exact || '',
                    partition_type: tableItem.partition_type || 'column',
                    start_index_check_box: tableItem.start_index_check_box || '',
                    start_index_type: tableItem.start_index_type || 'incremental data identifier',
                    start_with: tableItem.start_with || '',
                    start_with_query: tableItem.start_with_query || '',
                    table: tableItem.table || ''
                };
                return mapped;
            });

            // Map partitions to component format
            const partitions = (apiConfig.partitions || []).map((partitionItem, partitionIndex) => ({
                id: Date.now() + index * 1000 + 500 + partitionIndex, // Generate unique ID
                datasetName: partitionItem.dataset_name || '',
                partitionName: partitionItem.partition_name || '',
                partitionBy: partitionItem.partition_type === 'custom_query' ? 'Custom Query' : 'Column',
                partitionIdentifier: partitionItem.column_name || '',
                customQuery: partitionItem.custom_query || partitionItem.partition_query || '',
                isNew: false
            }));

            // Map datasetToBeProcessed to datasetScope
            let datasetScope = 'allDatasets';
            if (apiConfig.datasetToBeProcessed === 'specifiedDataset') {
                datasetScope = 'specifiedDatasets';
            } else if (apiConfig.datasetToBeProcessed === 'allDataset') {
                datasetScope = 'allDatasets';
            }

            const integrationName = apiConfig.integration_name || apiConfig.integrationName || fallbackIntegrationName;

            const result = {
                id: Date.now() + index * 10000,
                schema: schemaValue,
                schema_name: schemaValue,
                bucket: apiConfig.bucket || null,
                sub_path: apiConfig.sub_path || '',
                table_names: tableNamesValue,
                database: apiConfig.database || null,
                integrationName: integrationName,
                integrationDetails: integrationDetailsMap[integrationName] || null,
                datasetScope: datasetScope,
                incrementalData: incrementalData,
                partitions: partitions,
                errorStorage: apiConfig.error_storage || apiConfig.errorStorage || '',
                defaultErrorStorage: apiConfig.default_error_storage !== false
            };

            // console.log(`Mapped Integration Config [${index}]:`, result);
            return result;
        });
    }

    getDatasetsAdded = (config) => [...new Set(
        (config.incrementalData || [])
            .filter(item => {
                const datasetName = (item.datasetName || '').trim();
                if (!datasetName) return false;

                return item.isNew ||
                    datasetName !== (item.originalDatasetName || '').trim() ||
                    (item.identifier || '').trim() !== (item.originalIdentifier || '').trim() ||
                    Boolean(item.startingIndexCheckbox) !== Boolean(item.originalStartingIndexCheckbox) ||
                    (item.startingIndexType || 'incremental data identifier') !== (item.originalStartingIndexType || 'incremental data identifier') ||
                    (item.startingIndexValue || '').trim() !== (item.originalStartingIndexValue || '').trim() ||
                    (item.startingIndexQuery || '').trim() !== (item.originalStartingIndexQuery || '').trim();
            })
            .map(item => item.datasetName.trim())
    )];


    editDatasourceDetails() {
        this.setState({
            testConnectionSuccess: null,
            testConnectionError: null, // Clear error when editing
            testConnectionResponse: null, // Clear test connection response and stages
            isTestingConnection: false, // Reset testing state
            showTestConnectionInfo: false, // Hide test connection info panel to show datasource form again
            showSchemaConfigInfo: null, // Hide schema & mode selection panel
            // Note: Don't reset formResetKey - keep the form fields as they are
            // Keep testConnectionFormData for form refilling
        });
    }

    handleContinueSchemaSelection = () => {
        this.setState({
            showTestConnectionInfo: true,
            showSchemaConfigInfo: true,
        });
    }

    editSchemaAndModeSelection() {
        this.setState({
            showSchemaConfigInfo: null,
            showTestConnectionInfo: false,
        });
    }


    handleSchemaModeSelectionNext = (event) => {
        // Show the schema configuration info section
        // Initialize first integration configuration if manual mode and no configurations exist
        const { configurationMode, integrationConfigurations, schemaModeSelection, selectedSchemas } = this.state;
        const updates = { showSchemaConfigInfo: true, manualNextClicked: true };

        if (configurationMode === 'manual' && integrationConfigurations.length === 0) {
            const canCreateConfig = schemaModeSelection === 'allSchemas' || selectedSchemas.length > 0;
            if (canCreateConfig) {
                updates.integrationConfigurations = [{
                    id: Date.now(),
                    schema: null,
                    datasetScope: 'allDatasets',
                    incrementalData: [],
                    partitions: []
                }];
            }
        }

        this.setState(updates);
    }

    handleSchemaModeSelection = (event) => {
        const value = event.target.value;
        if (value === 'allSchemas') {
            this.setState(prevState => ({
                selected: true,
                specificSelect: false,
                schemaModeSelection: value,
                configurationMode: prevState.configurationMode === 'autoconfig' ? 'autoconfig' : 'autoconfig'
            }));
        } else if (value === 'specificSchemas') {
            this.setState({
                selected: false,
                specificSelect: true,
                schemaModeSelection: value
            });
        }
    }

    handleConfigurationModeChange = (event) => {
        const mode = event.target.value;
        // If in Specified Schemas mode and switching to autoconfig, deselect all schemas
        if (mode === 'autoconfig' && this.state.specificSelect) {
            this.setState({ configurationMode: mode, selectedSchemas: [] });
        } else {
            this.setState({ configurationMode: mode });
        }
    }

    handleExpandIncrementalData = (id) => {
        this.setState({ expandIncrementalData: id });
    }
    handleAddPartition = (id) => {
        this.setState({ partitionData: id });
    }
    handleCloseSchemeModal = () => {
        this.setState({ showSchemeModal: false, schemeModalLoading: false });
    }
    handleShowSchemeModal = () => {
        this.setState({ showSchemeModal: true, schemeModalLoading: true });
        // Switch to success state after 5 seconds
        setTimeout(() => {
            this.setState({ schemeModalLoading: false });
        }, 5000);
    }

    handleSchemaSelect = (schemaName) => {
        const { selectedSchemas } = this.state;
        if (selectedSchemas.includes(schemaName)) {
            // Remove schema if already selected
            this.setState({
                selectedSchemas: selectedSchemas.filter(s => s !== schemaName)
            });
        } else {
            // Add schema if not selected
            this.setState({
                selectedSchemas: [...selectedSchemas, schemaName]
            });
        }
    }

    handleSelectAllSchemas = () => {
        const schemas = this.state.testConnectionResponse?.schemas || [];
        const { selectedSchemas } = this.state;

        if (selectedSchemas.length === schemas.length) {
            // Deselect all if all are selected
            this.setState({ selectedSchemas: [] });
        } else {
            // Select all
            this.setState({ selectedSchemas: [...schemas] });
        }
    }

    handleAddIntegration = () => {
        const newIntegration = {
            id: Date.now(), // Unique ID for each integration
            schema: null,
            datasetScope: 'allDatasets',
            incrementalData: [],
            partitions: []
        };

        this.setState({
            integrationConfigurations: [...this.state.integrationConfigurations, newIntegration]
        });
    }

    handleRemoveIntegration = (integrationId) => {
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.filter(
                config => config.id !== integrationId
            )
        });
    }

    // --- Confirm-before-remove modal handlers (edit mode) ---
    openConfirmRemove = ({ type, configId, itemId = null, label = '' }) => {
        const config = this.state.integrationConfigurations.find(item => item.id === configId);
        const item = type === 'incremental'
            ? config?.incrementalData?.find(data => data.id === itemId)
            : type === 'partition'
                ? config?.partitions?.find(partition => partition.id === itemId)
                : null;
        if (item?.isNew) {
            if (type === 'incremental') this.removePersistedIncrementalData(configId, itemId);
            if (type === 'partition') this.removePersistedPartition(configId, itemId);
            return;
        }
        this.setState({
            confirmRemoveModal: { type, configId, itemId, label },
            confirmRemoveName: '',
        });
    }

    closeConfirmRemove = () => {
        this.setState({ confirmRemoveModal: null, confirmRemoveName: '' });
    }

    confirmRemove = () => {
        const { confirmRemoveModal, confirmRemoveName } = this.state;
        if (!confirmRemoveModal) return;
        if (confirmRemoveName !== confirmRemoveModal.label) return;
        const { type, configId, itemId } = confirmRemoveModal;
        if (type === 'integration') {
            this.handleRemoveIntegration(configId);
        } else if (type === 'incremental') {
            this.removePersistedIncrementalData(configId, itemId);
        } else if (type === 'partition') {
            this.removePersistedPartition(configId, itemId);
        }
        this.setState({ confirmRemoveModal: null, confirmRemoveName: '' });
    }

    removePersistedIncrementalData = (integrationId, incrementalDataId) => {
        const config = this.state.integrationConfigurations.find(item => item.id === integrationId);
        const removedItem = config?.incrementalData?.find(item => item.id === incrementalDataId);
        const removedDatasetName = removedItem?.datasetName || null;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(item => {
                if (item.id !== integrationId) return item;
                const incrementalData = item.incrementalData.filter(data => data.id !== incrementalDataId);
                const partitions = item.datasetScope !== 'allDatasets' && removedDatasetName
                    ? item.partitions.filter(partition => partition.datasetName !== removedDatasetName)
                    : item.partitions;
                return { ...item, incrementalData, partitions };
            })
        });
    }

    handleAddIncrementalData = (integrationId) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        // Find the configuration
        const config = this.state.integrationConfigurations.find(c => c.id === integrationId);

        if (!config) return;

        // Validate existing incremental data rows
        if (config.incrementalData.length > 0) {
            const lastItem = config.incrementalData[config.incrementalData.length - 1];
            let hasError = false;
            // let errorMessage = '';

            // Check required fields
            if (!lastItem.datasetName || lastItem.datasetName.trim() === '') {
                hasError = true;
                // errorMessage = 'Please fill Dataset Name in the previous row';
            } else if (lastItem.startingIndexCheckbox) {
                // If starting index is enabled, validate based on type
                if (lastItem.startingIndexType === 'incremental data identifier') {
                    if (!lastItem.startingIndexValue || lastItem.startingIndexValue.trim() === '') {
                        hasError = true;
                        //errorMessage = 'Please fill Starting Index Value in the previous row';
                    }
                } else if (lastItem.startingIndexType === 'custom query') {
                    if (!lastItem.startingIndexQuery || lastItem.startingIndexQuery.trim() === '') {
                        hasError = true;
                        // errorMessage = 'Please fill Starting Index Query in the previous row';
                    }
                }
            }

            if (hasError) {
                return;
            }
        }

        const newIncrementalData = {
            id: Date.now(),
            datasetName: '',
            identifier: '',
            startingIndexCheckbox: false,
            startingIndexType: 'incremental data identifier',
            startingIndexValue: '',
            startingIndexQuery: '',
            exactMatch: true,
            isNew: true
        };

        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? { ...config, incrementalData: [...config.incrementalData, newIncrementalData] }
                    : config
            )
        });
    }

    handleRemoveIncrementalData = (integrationId, incrementalDataId) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (!__cfg) return;
        const item = (__cfg.incrementalData || []).find(data => data.id === incrementalDataId);
        if (item && !item.isNew) {
            this.openConfirmRemove({
                type: 'incremental',
                configId: integrationId,
                itemId: incrementalDataId,
                label: item.datasetName || 'Dataset'
            });
            return;
        }
        const canRemove = __cfg.datasetScope === 'allDatasets' || (__cfg.incrementalData || []).length > 1;
        if (__cfg.isExisting && !canRemove) return;

        // Find the dataset name of the item being removed so we can also clean up its partitions
        const removedItem = __cfg?.incrementalData?.find(d => d.id === incrementalDataId);
        const removedDatasetName = removedItem?.datasetName || null;

        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config => {
                if (config.id !== integrationId) return config;

                const updatedIncrementalData = config.incrementalData.filter(
                    data => data.id !== incrementalDataId
                );

                // All-datasets identifiers can be removed independently of partitions.
                const updatedPartitions = config.datasetScope !== 'allDatasets' && removedDatasetName
                    ? config.partitions.filter(p => p.datasetName !== removedDatasetName)
                    : config.partitions;

                return { ...config, incrementalData: updatedIncrementalData, partitions: updatedPartitions };
            })
        });
    }

    handleStartingIndexCheckbox = (integrationId, incrementalDataId, checked) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        incrementalData: config.incrementalData.map(data =>
                            data.id === incrementalDataId
                                ? { ...data, startingIndexCheckbox: checked }
                                : data
                        )
                    }
                    : config
            )
        });
    }

    handleStartingIndexTypeChange = (integrationId, incrementalDataId, type) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        incrementalData: config.incrementalData.map(data =>
                            data.id === incrementalDataId
                                ? { ...data, startingIndexType: type }
                                : data
                        )
                    }
                    : config
            )
        });
    }

    handleExactMatchChange = (integrationId, incrementalDataId, checked) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        incrementalData: config.incrementalData.map(data =>
                            data.id === incrementalDataId
                                ? { ...data, exactMatch: checked }
                                : data
                        )
                    }
                    : config
            )
        });
    }

    handleIncrementalDataFieldChange = (integrationId, incrementalDataId, fieldName, value) => {
        this.setState(prevState => {
            const updatedConfigs = prevState.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        incrementalData: config.incrementalData.map(data =>
                            data.id === incrementalDataId
                                ? { ...data, [fieldName]: value }
                                : data
                        )
                    }
                    : config
            );
            // Clear dataset-level validation error when user changes datasetName
            let updatedErrors = prevState.integrationValidationErrors;
            if (fieldName === 'datasetName') {
                const cfgErrors = updatedErrors[integrationId];
                if (cfgErrors && cfgErrors.datasets && cfgErrors.datasets[incrementalDataId]) {
                    const newDatasets = { ...cfgErrors.datasets };
                    delete newDatasets[incrementalDataId];
                    updatedErrors = {
                        ...updatedErrors,
                        [integrationId]: { ...cfgErrors, datasets: newDatasets }
                    };
                }
            }
            return {
                integrationConfigurations: updatedConfigs,
                integrationValidationErrors: updatedErrors
            };
        });
    }

    handleDatasetScopeChange = (integrationId, scope) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config => {
                if (config.id === integrationId) {
                    // If changing to "Specified Datasets" and no incremental data exists, add one
                    if (scope === 'specifiedDatasets' && config.incrementalData.length === 0) {
                        const newIncrementalData = {
                            id: Date.now(),
                            datasetName: '',
                            identifier: '',
                            startingIndexCheckbox: false,
                            startingIndexType: 'incremental data identifier',
                            startingIndexValue: '',
                            startingIndexQuery: '',
                            exactMatch: true,
                            isNew: true
                        };
                        return { ...config, datasetScope: scope, incrementalData: [newIncrementalData] };
                    }
                    return { ...config, datasetScope: scope };
                }
                return config;
            })
        });
    }

    handleSchemaSelectForConfig = (integrationId, selectedOption) => {
        this.setState(prevState => {
            // Clear schema-level validation error when user picks a new schema
            const updatedErrors = { ...prevState.integrationValidationErrors };
            if (updatedErrors[integrationId]) {
                const { schema: _removed, ...rest } = updatedErrors[integrationId];
                if (Object.keys(rest).length === 0) {
                    delete updatedErrors[integrationId];
                } else {
                    updatedErrors[integrationId] = rest;
                }
            }
            return {
                integrationConfigurations: prevState.integrationConfigurations.map(config =>
                    config.id === integrationId
                        ? { ...config, schema: selectedOption?.value || null }
                        : config
                ),
                integrationValidationErrors: updatedErrors
            };
        });
    }

    handleEditIntegrationName = (id, name) => {
        this.setState({
            editingIntegrationId: id,
            editingIntegrationName: name || ""
        });
    };

    handleSaveIntegrationName = (id) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === id);
        
        if (__cfg && (!__cfg.integrationName || __cfg.integrationName.trim() === '' || this.isDuplicateIntegrationName(__cfg.integrationName, id))) {
            return;
        }

        this.setState({
            editingIntegrationId: null,
            editingIntegrationName: ""
        });
    };

    handleIntegrationNameChange = (integrationId, value) => {
        this.setState(prevState => ({
            integrationConfigurations: prevState.integrationConfigurations.map(config =>
                config.id === integrationId ? { ...config, integrationName: value } : config
            ),
            editingIntegrationName: value,
            editingIntegrationId: integrationId
        }));
    }

    isDuplicateIntegrationName = (value, configId) => {
        const integrationName = String(value || "").trim().toLowerCase();
        if (!integrationName) return false;

        const existingIntegrations = Array.isArray(this.props.existingIntegrations) ? this.props.existingIntegrations : [];
        const isDuplicateInApi = existingIntegrations.some((integration) => {
            const existingName = String(integration.integration_name || "").trim().toLowerCase();
            return existingName === integrationName;
        });

        if (isDuplicateInApi) {
            const config = this.state.integrationConfigurations.find(c => c.id === configId);
            if (config && config.integrationDetails && String(config.integrationDetails.integration_name || "").trim().toLowerCase() === integrationName) {
                // it is the same as its original name, not a duplicate
            } else {
                return true;
            }
        }

        const duplicateInForm = this.state.integrationConfigurations.some(config => {
            if (config.id === configId) return false;
            return String(config.integrationName || "").trim().toLowerCase() === integrationName;
        });

        return duplicateInForm;
    }

    normalizeUniqueValue = (value) => String(value || '').trim().toLowerCase();

    getEditEntityId = () => this.state.ex_edit_integration_details?.integration_id;

    getIntegrationConfigsFromPayload = (integration) => {
        const payload = integration?.datasource_config || integration || {};
        // Prefer integration_names (all datasource integrations) over integration_config (single entry)
        const configs = payload.integration_names || payload.integration_config || [];
        return Array.isArray(configs) ? configs : (configs ? [configs] : []);
    }

    isExistingIntegrationBeingEdited = (integration) => {
        const editId = this.getEditEntityId();
        return Boolean(editId && integration?.integration_id && String(integration.integration_id) === String(editId));
    }

    getSchemasWithAllDatasetsIntegration = (currentConfigId = null) => {
        const existingIntegrations = Array.isArray(this.props.existingIntegrations)
            ? this.props.existingIntegrations : [];
        const schemas = new Set();
        existingIntegrations.forEach(integration => {
            if (this.isExistingIntegrationBeingEdited(integration)) return;
            this.getIntegrationConfigsFromPayload(integration).forEach(cfg => {
                if (cfg.datasetToBeProcessed === 'allDataset') {
                    const schemaName = cfg.schema_name || cfg.schema;
                    if (schemaName) schemas.add(schemaName);
                }
            });
        });
        this.state.integrationConfigurations.forEach(config => {
            if (currentConfigId !== null && config.id === currentConfigId) return;
            if (config.datasetScope === 'allDatasets' && config.schema) {
                schemas.add(config.schema);
            }
        });
        return schemas;
    }

    schemaHasSpecifiedDatasetsIntegration = (schemaName, currentConfigId = null) => {
        if (!schemaName) return false;
        const existingIntegrations = Array.isArray(this.props.existingIntegrations)
            ? this.props.existingIntegrations : [];

        const hasExistingSpecified = existingIntegrations.some(integration => {
            if (this.isExistingIntegrationBeingEdited(integration)) return false;
            return this.getIntegrationConfigsFromPayload(integration).some(cfg => {
                const cfgSchema = cfg.schema_name || cfg.schema;
                return cfgSchema === schemaName && cfg.datasetToBeProcessed !== 'allDataset' && (cfg.table_names || []).length > 0;
            });
        });
        if (hasExistingSpecified) return true;

        return this.state.integrationConfigurations.some(config => {
            if (currentConfigId !== null && config.id === currentConfigId) return false;
            return config.schema === schemaName &&
                config.datasetScope === 'specifiedDatasets' &&
                (config.incrementalData || []).some(item => (item.datasetName || '').trim());
        });
    }

    getUsedDatasetsForSchema = (schemaName, currentConfigId = null, currentRowId = null) => {
        if (!schemaName) return [];
        const existingIntegrations = Array.isArray(this.props.existingIntegrations)
            ? this.props.existingIntegrations : [];
        const used = new Set();
        existingIntegrations.forEach(integration => {
            if (this.isExistingIntegrationBeingEdited(integration)) return;
            this.getIntegrationConfigsFromPayload(integration).forEach(cfg => {
                const cfgSchema = cfg.schema_name || cfg.schema;
                if (cfgSchema !== schemaName) return;
                (cfg.table_names || []).forEach(t => {
                    if (t.table) used.add(this.normalizeUniqueValue(t.table));
                });
            });
        });
        this.state.integrationConfigurations.forEach(config => {
            if (config.schema !== schemaName) return;
            if (config.id === currentConfigId && currentRowId === null) return;
            (config.incrementalData || []).forEach(item => {
                if (config.id === currentConfigId && item.id === currentRowId) return;
                if (item.datasetName) used.add(this.normalizeUniqueValue(item.datasetName));
            });
        });
        return Array.from(used);
    }

    isDatasetAssignedToAnotherIntegration = (config, item) => {
        const datasetName = (item?.datasetName || '').trim();
        if (!datasetName) return false;
        return this.getUsedDatasetsForSchema(config.schema, config.id, item.id)
            .includes(this.normalizeUniqueValue(datasetName));
    }

    getDatasetsForPartitionOptions = (config, currentPartition = null) => {
        const usedDatasets = new Set(this.getUsedDatasetsForSchema(config.schema, config.id, null));
        const currentDataset = this.normalizeUniqueValue(currentPartition?.datasetName);
        return (config.incrementalData || [])
            .map(item => item.datasetName)
            .filter(Boolean)
            .filter(datasetName => {
                const normalized = this.normalizeUniqueValue(datasetName);
                return normalized === currentDataset || !usedDatasets.has(normalized);
            })
            .map(ds => ({ label: ds, value: ds }));
    }

    // Validates dataset assignment rules for schema/integration combinations.
    validateSchemaDatasetUniqueness = () => {
        const { integrationConfigurations } = this.state;
        // Build a structured error map: { [configId]: { schema?: string, datasets?: { [itemId]: string } } }
        const errorMap = {};
        let hasErrors = false;

        integrationConfigurations.forEach((config) => {
            const schema = config.schema;
            if (!schema) return;

            const configErrors = {};

            // Rule: schema already has an All Datasets integration — no more allowed
            if (this.getSchemasWithAllDatasetsIntegration(config.id).has(schema)) {
                configErrors.schema = `Schema "${schema}" already has an All Datasets integration. No additional integrations can be created for this schema.`;
                hasErrors = true;
            } else if (config.datasetScope === 'allDatasets' && this.schemaHasSpecifiedDatasetsIntegration(schema, config.id)) {
                configErrors.schema = `Schema "${schema}" already has Specified Datasets integrations. All Datasets cannot be combined with Specified Datasets.`;
                hasErrors = true;
            } else if (config.datasetScope !== 'allDatasets') {
                const datasetErrors = {};
                (config.incrementalData || []).forEach((item) => {
                    const dsName = (item.datasetName || '').trim();
                    if (dsName && this.isDatasetAssignedToAnotherIntegration(config, item)) {
                        datasetErrors[item.id] = `Dataset Name "${dsName}" is already associated with another integration in schema "${schema}".`;
                        hasErrors = true;
                    }
                });
                if (Object.keys(datasetErrors).length > 0) {
                    configErrors.datasets = datasetErrors;
                }
            }

            if (Object.keys(configErrors).length > 0) {
                errorMap[config.id] = configErrors;
            }
        });

        this.setState({ integrationValidationErrors: errorMap }, () => {
            if (hasErrors) {
                setTimeout(() => {
                    const firstError = document.querySelector('.error-text');
                    if (firstError) {
                        firstError.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                }, 100);
            }
        });
        return hasErrors;
    }

    isCreateDatasourceEnabled = () => {
        const { configurationMode, selected, specificSelect, selectedSchemas, testConnectionSuccess, isCreatingDatasource, showSchemaConfigInfo, showTestConnectionInfo } = this.state;
        // Must have successful test connection and not be in the process of creating
        if (!testConnectionSuccess || isCreatingDatasource) {
            return false;
        }

        if (showSchemaConfigInfo === null || showTestConnectionInfo === false) {
            return false;
        }

        // Only enable if autoconfig is selected OR manual config with schema selection completed
        if (configurationMode === 'autoconfig') {
            // All Schemas mode: enable if selected
            if ((selected && configurationMode === 'autoconfig') || configurationMode === 'manual') {
                return true;
            }
            // Specified Schemas mode: enable only if at least one schema is selected
            if ((specificSelect && configurationMode === 'autoconfig' && selectedSchemas.length > 0) || (specificSelect && configurationMode === 'manual' && selectedSchemas.length > 0)) {
                return true;
            }
        } else if (configurationMode === 'manual' && this.isContinueSchemaSelectionEnabled() && showSchemaConfigInfo && showTestConnectionInfo) {
            // Manual configuration: enable only if continue schema selection conditions were met AND it was clicked
            return true;
        }
        return false;
    }

    isContinueSchemaSelectionEnabled = () => {
        const { configurationMode, testConnectionFormData, testConnectionSuccess, schemaModeSelection, selectedSchemas } = this.state;

        // Only enable for manual configuration mode
        if (configurationMode !== 'manual') {
            return false;
        }

        if (schemaModeSelection === null) {
            return false;
        }

        // Must have form data (form submitted) and successful test connection
        if (!testConnectionFormData || !testConnectionSuccess) {
            return false;
        }

        // Must have schema mode selected
        if (!schemaModeSelection) {
            return false;
        }

        // Check if schemas are selected when in specified schemas mode
        if (schemaModeSelection === 'specificSchemas' && selectedSchemas.length === 0) {
            return false;
        }

        return true;
    }

    handleAddPartitionToConfig = (integrationId) => {
        // Find the configuration
        const config = this.state.integrationConfigurations.find(c => c.id === integrationId);

        if (!config) return;

        // Validate existing partition rows
        if (config.partitions.length > 0) {
            const lastPartition = config.partitions[config.partitions.length - 1];
            let hasError = false;
            let errorMessage = '';

            // Check required fields
            if (!lastPartition.datasetName || lastPartition.datasetName.trim() === '') {
                hasError = true;
                errorMessage = 'Please fill Dataset Name in the previous partition row';
            } else if (!lastPartition.partitionName || lastPartition.partitionName.trim() === '') {
                hasError = true;
                errorMessage = 'Please fill Partition Name in the previous partition row';
            } else if (lastPartition.partitionBy === 'Column' || lastPartition.partitionBy === undefined) {
                // If partition by Column, check partition identifier
                if (!lastPartition.partitionIdentifier || lastPartition.partitionIdentifier.trim() === '') {
                    hasError = true;
                    errorMessage = 'Please fill Partition Identifier in the previous partition row';
                }
            } else if (lastPartition.partitionBy === 'Custom Query') {
                // If partition by Custom Query, check custom query
                if (!lastPartition.customQuery || lastPartition.customQuery.trim() === '') {
                    hasError = true;
                    errorMessage = 'Please fill Custom Query in the previous partition row';
                }
            }

            if (hasError) {
                this.props.showToast && this.props.showToast('error', errorMessage);
                return;
            }
        }

        const newPartition = {
            id: Date.now(),
            datasetName: '',
            partitionName: '',
            partitionBy: 'Column',
            partitionIdentifier: '',
            customQuery: '',
            isNew: true
        };

        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? { ...config, partitions: [...config.partitions, newPartition] }
                    : config
            )
        });
    }

    handleRemovePartition = (integrationId, partitionId) => {
        const config = this.state.integrationConfigurations.find(c => c.id === integrationId);
        const partition = config?.partitions?.find(item => item.id === partitionId);
        if (partition && !partition.isNew) {
            this.openConfirmRemove({
                type: 'partition',
                configId: integrationId,
                itemId: partitionId,
                label: partition.partitionName || 'Partition'
            });
            return;
        }
        this.removePersistedPartition(integrationId, partitionId);
    }

    removePersistedPartition = (integrationId, partitionId) => {
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? { ...config, partitions: config.partitions.filter(partition => partition.id !== partitionId) }
                    : config
            )
        });
    }

    handlePartitionByChange = (integrationId, partitionId, value) => {
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        partitions: config.partitions.map(partition =>
                            partition.id === partitionId
                                ? { ...partition, partitionBy: value }
                                : partition
                        )
                    }
                    : config
            )
        });
    }

    handlePartitionFieldChange = (integrationId, partitionId, fieldName, value) => {
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        partitions: config.partitions.map(partition =>
                            partition.id === partitionId
                                ? { ...partition, [fieldName]: value }
                                : partition
                        )
                    }
                    : config
            )
        });
    }

    handleCreateDatasource = async () => {
        const { testConnectionFormData, schemaModeSelection, configurationMode, selectedSchemas, integrationConfigurations } = this.state;

        if (!testConnectionFormData) {
            this.props.showToast && this.props.showToast('error', 'Please test the connection first');
            return;
        }

        // Validate manual configuration mode requirements
        if (configurationMode === 'manual') {
            // Check each integration configuration
            for (let i = 0; i < integrationConfigurations.length; i++) {
                const config = integrationConfigurations[i];

                // If dataset scope is "Specified Datasets", incremental data is mandatory
                if (config.datasetScope === 'specifiedDatasets' && config.incrementalData.length === 0) {
                    this.props.showToast && this.props.showToast('error', `Integration configuration ${i + 1}: Add Incremental Data Identification is required for Specified Datasets`);
                    return;
                }

                // Validate all incremental data rows have required fields
                for (let j = 0; j < config.incrementalData.length; j++) {
                    const incrementalItem = config.incrementalData[j];
                    if (!incrementalItem.datasetName || incrementalItem.datasetName.trim() === '') {
                        this.props.showToast && this.props.showToast('error', `Integration configuration ${i + 1}, Incremental Data ${j + 1}: Dataset Name is required`);
                        return;
                    }
                }
            }

            // Validate uniqueness of dataset names, identifiers, and partition fields
            const hasUniquenessErrors = this.validateSchemaDatasetUniqueness();
            if (hasUniquenessErrors) {
                return;
            }
        }

        // Determine schemaToBeProcessed based on schema mode selection
        let schemaToBeProcessed = 'allSchema';
        let schemaList = [];

        if (schemaModeSelection === 'specificSchemas') {
            if (selectedSchemas.length === 0) {
                this.props.showToast && this.props.showToast('error', 'Please select at least one schema');
                return;
            }
            schemaToBeProcessed = 'specifiedSchema';
            schemaList = selectedSchemas;
        }

        // Determine config_type based on configuration mode
        const configType = configurationMode === 'autoconfig' ? 'autoConfig' : 'manualConfig';

        // Build datasource_config based on configuration mode
        let datasourceConfig = {
            ...this.buildDatasourceConfig(testConnectionFormData, this.state.formType),
            error_storage: "",
            default_error_storage: true,
            schemaToBeProcessed: schemaToBeProcessed
        };

        // Add schema_names for specified schemas
        if (schemaToBeProcessed === 'specifiedSchema') {
            datasourceConfig.schema_names = schemaList;

            // Calculate added and removed schemas for edit mode
            const existingDetails = this.state.ex_edit_integration_details || this.props.ex_integration_details || {};
            if (existingDetails.integration_id) {
                let originalSchemas = [];
                const originalPayload = existingDetails.datasource_config || existingDetails;
                if (originalPayload.schema_names) {
                    originalSchemas = originalPayload.schema_names;
                } else if (originalPayload.integration_config) {
                    const rawConfigs = Array.isArray(originalPayload.integration_config)
                        ? originalPayload.integration_config
                        : [originalPayload.integration_config];
                    originalSchemas = [...new Set(
                        rawConfigs
                            .map(config => config.schema || config.schema_name)
                            .filter(schema => schema)
                    )];
                } else if (originalPayload.schema) {
                    originalSchemas = [originalPayload.schema];
                }

                const addedSchemas = schemaList.filter(s => !originalSchemas.includes(s));
                const removedSchemas = originalSchemas.filter(s => !schemaList.includes(s));
                if (addedSchemas.length > 0) {
                    if (this.state.formType === 'azure_blob' || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2') {
                        datasourceConfig.added_buckets = addedSchemas;
                    } else {
                        datasourceConfig.added_schemas = addedSchemas;
                    }
                }
                if (removedSchemas.length > 0) {
                    if (this.state.formType === 'azure_blob' || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2') {
                        datasourceConfig.removed_buckets = removedSchemas;
                    } else {
                        datasourceConfig.removed_schemas = removedSchemas;
                    }
                }
            }
        }

        // Add integration_config for manual config
        if (configType === 'manualConfig') {
            const isSchemaNameType = ['snowflake', 'postgresql', 'redshift'].includes(this.state.formType);
            datasourceConfig.integration_names = integrationConfigurations.map((config, index) => {
                // Build table_names (incremental data) array
                const tableNames = config.incrementalData.map(item => ({
                    table: item.datasetName || "",
                    created_time: item.identifier || "",
                    start_with: item.startingIndexCheckbox && item.startingIndexType === 'incremental data identifier' ? item.startingIndexValue : "",
                    match_exact: item.exactMatch ? "match_exact" : "",
                    start_with_query: item.startingIndexCheckbox && item.startingIndexType === 'custom query' ? item.startingIndexQuery : "",
                    start_index_check_box: item.startingIndexCheckbox ? "true" : "false",
                    start_index_type: item.startingIndexType || "incremental data identifier",
                    partition_type: "column"
                }));

                // Build partitions array
                const partitions = config.partitions.map(partition => {
                    const partitionObj = {
                        dataset_name: partition.datasetName || "",
                        partition_type: partition.partitionBy === 'Custom Query' ? "custom_query" : "column",
                        partition_name: partition.partitionName || ""
                    };

                    if (partition.partitionBy === 'Column' || partition.partitionBy === undefined) {
                        partitionObj.column_name = partition.partitionIdentifier || "";
                    } else if (partition.partitionBy === 'Custom Query') {
                        partitionObj.custom_query = partition.customQuery || "";
                    }

                    return partitionObj;
                });

                return {
                    ...this.buildDatasourceConfig(testConnectionFormData, this.state.formType),
                    integration_name: config.integrationName || `integration${integrationConfigurations.length - index}`,
                    [isSchemaNameType ? 'schema_name' : 'schema']: config.schema || "",
                    partitions: partitions,
                    table_names: tableNames,
                    datasetToBeProcessed: config.datasetScope === 'allDatasets' ? 'allDataset' : 'specifiedDataset'
                };
            });

            // Calculate added and removed integrations for edit mode
            const existingDetails = this.state.ex_edit_integration_details || this.props.ex_integration_details || {};
            if (existingDetails.integration_id) {
                const originalPayload = existingDetails.datasource_config || existingDetails;
                
                // const addedSchemas = datasourceConfig.added_schemas || datasourceConfig.added_buckets || [];
                // const removedSchemas = datasourceConfig.removed_schemas || datasourceConfig.removed_buckets || [];

                let originalIntegrationObjs = [];
                if (originalPayload.integration_config) {
                    originalIntegrationObjs = Array.isArray(originalPayload.integration_config)
                        ? originalPayload.integration_config
                        : [originalPayload.integration_config];
                }

                let newIntegrationObjs = [];
                if (datasourceConfig.integration_names) {
                    newIntegrationObjs = datasourceConfig.integration_names;
                }

                const originalIntegrationNames = originalIntegrationObjs.map(i => i.integration_name).filter(Boolean);
                const newIntegrationNames = newIntegrationObjs.map(i => i.integration_name).filter(Boolean);

                const addedIntegrations = newIntegrationNames.filter(name => !originalIntegrationNames.includes(name));
                const removedIntegrations = originalIntegrationNames.filter(name => !newIntegrationNames.includes(name));
                
                if (addedIntegrations.length > 0) {
                    datasourceConfig.added_integrations = addedIntegrations;
                }
                if (removedIntegrations.length > 0) {
                    datasourceConfig.removed_integrations = removedIntegrations;
                }
            }
        }

        // Build the request payload
        const requestPayload = {
            datasource_name: testConnectionFormData.datasource_name || testConnectionFormData.integration_name || "New Datasource",
            tenant_id: localStorage.getItem('team_id'), // You may want to get this from props or auth
            env_id: this.props.env_id || 69,
            datasource_type: this.mapDatasourceType(this.state.formType),
            data_store_type: this.getDatasourceStoreType(this.state.formType),
            config_type: configType,
            datasource_config: datasourceConfig,
            auth_config: this.buildAuthConfig(testConnectionFormData, this.state.formType)
        };

        //  alert(JSON.stringify(requestPayload));

        // console.log('Creating datasource with payload:', requestPayload);

        // Set creating state
        this.setState({ isCreatingDatasource: true });

        try {
            // Call the createDataSource API
            const response = await createDataSource(requestPayload);

            if (response?.code === 200) {
                // console.log('Integration created successfully:', response);
                //this.props.showToast && this.props.showToast('success', 'Datasource created successfully');

                // Refresh the environment data if callback exists
                //if (this.props.setEnvData) {
                this.props.setEnvData(this.props.env_id);
                //}
                // Close modal if callback exists
                this.props.setPage(false)
            } else {
                console.error('Failed to create datasource:', response);
                // this.props.showToast && this.props.showToast('error', response?.message || 'Failed to create datasource');
            }
        } catch (error) {
            console.error('Error creating datasource:', error);
            this.props.showToast && this.props.showToast('error', 'An error occurred while creating datasource');
        } finally {
            // Reset creating state
            this.setState({ isCreatingDatasource: false });
        }
    }

    handleSaveIntegration = async () => {
        const { testConnectionFormData, schemaModeSelection, configurationMode, selectedSchemas, integrationConfigurations } = this.state;
        const existingIntegrationDetails = this.state.ex_edit_integration_details || this.props.ex_integration_details || {};

        if (!testConnectionFormData) {
            this.props.showToast && this.props.showToast('error', 'Please test the connection first');
            window.dispatchEvent(new Event('save-completed'));
            return;
        }

        if (configurationMode === 'manual') {
            if (integrationConfigurations.length === 0) {
                this.props.showToast && this.props.showToast('error', 'Please add at least one integration configuration');
                window.dispatchEvent(new Event('save-completed'));
                return;
            }

            // Check each integration configuration
            let hasFormErrors = false;
            const formErrors = { ...this.state.integrationValidationErrors };

            for (let i = 0; i < integrationConfigurations.length; i++) {
                const config = integrationConfigurations[i];

                if (formErrors[config.id]) {
                    delete formErrors[config.id].incrementalDataRequired;
                }

                // If dataset scope is "Specified Datasets", incremental data is mandatory
                if (config.datasetScope === 'specifiedDatasets' && config.incrementalData.length === 0) {
                    formErrors[config.id] = {
                        ...(formErrors[config.id] || {}),
                        incrementalDataRequired: 'Add Incremental Data Identification is required for Specified Datasets'
                    };
                    hasFormErrors = true;
                }

                // Validate all incremental data rows have required fields
                for (let j = 0; j < config.incrementalData.length; j++) {
                    const incrementalItem = config.incrementalData[j];
                    if (!incrementalItem.datasetName || incrementalItem.datasetName.trim() === '') {
                        hasFormErrors = true;
                    }
                    if (config.datasetScope !== 'specifiedDatasets' && (!incrementalItem.identifier || incrementalItem.identifier.trim() === '')) {
                        hasFormErrors = true;
                    }
                    if (incrementalItem.startingIndexCheckbox) {
                        if (incrementalItem.startingIndexType === 'incremental data identifier' && (!incrementalItem.startingIndexValue || incrementalItem.startingIndexValue.trim() === '')) {
                            hasFormErrors = true;
                        }
                        if (incrementalItem.startingIndexType === 'custom query' && (!incrementalItem.startingIndexQuery || incrementalItem.startingIndexQuery.trim() === '')) {
                            hasFormErrors = true;
                        }
                    }
                }

                // Validate partition fields
                if (config.partitions && config.partitions.length > 0) {
                    for (let k = 0; k < config.partitions.length; k++) {
                        const partition = config.partitions[k];
                        if (!partition.datasetName || partition.datasetName.trim() === '') {
                            hasFormErrors = true;
                        }
                        if (!partition.partitionName || partition.partitionName.trim() === '') {
                            hasFormErrors = true;
                        }
                        if (partition.partitionBy === 'Column' || partition.partitionBy === undefined) {
                            if (!partition.partitionIdentifier || partition.partitionIdentifier.trim() === '') {
                                hasFormErrors = true;
                            }
                        } else if (partition.partitionBy === 'Custom Query') {
                            if (!partition.customQuery || partition.customQuery.trim() === '') {
                                hasFormErrors = true;
                            }
                        }
                    }
                }
            }

            if (hasFormErrors) {
                this.setState({ integrationValidationErrors: formErrors }, () => {
                    setTimeout(() => {
                        const firstError = document.querySelector('.error-text');
                        if (firstError) {
                            firstError.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                        }
                    }, 100);
                });
                window.dispatchEvent(new Event('save-completed'));
                return;
            }

            // Validate uniqueness of dataset names, identifiers, and partition fields
            const hasUniquenessErrors = this.validateSchemaDatasetUniqueness();
            if (hasUniquenessErrors) {
                window.dispatchEvent(new Event('save-completed'));
                return;
            }
        }

        let schemaToBeProcessed = 'allSchema';
        let schemaList = [];

        if (schemaModeSelection === 'specificSchemas') {
            if (selectedSchemas.length === 0) {
                this.props.showToast && this.props.showToast('error', 'Please select at least one schema');
                return;
            }
            schemaToBeProcessed = 'specifiedSchema';
            schemaList = selectedSchemas;
        }

        const configType = configurationMode === 'autoconfig' ? 'autoConfig' : 'manualConfig';

        let datasourceConfig = {
            ...this.buildDatasourceConfig(testConnectionFormData, this.state.formType),
            error_storage: "",
            default_error_storage: true,
            schemaToBeProcessed: schemaToBeProcessed
        };

        if (schemaToBeProcessed === 'specifiedSchema') {
            datasourceConfig.schema_names = schemaList;

            const existingDetails = this.state.ex_edit_integration_details || this.props.ex_integration_details || {};
            if (existingDetails.integration_id) {
                let originalSchemas = [];
                const originalPayload = existingDetails.datasource_config || existingDetails;
                if (originalPayload.schema_names) {
                    originalSchemas = originalPayload.schema_names;
                } else if (originalPayload.integration_config) {
                    const rawConfigs = Array.isArray(originalPayload.integration_config)
                        ? originalPayload.integration_config
                        : [originalPayload.integration_config];
                    originalSchemas = [...new Set(
                        rawConfigs
                            .map(config => config.schema || config.schema_name)
                            .filter(schema => schema)
                    )];
                } else if (originalPayload.schema) {
                    originalSchemas = [originalPayload.schema];
                }

                const addedSchemas = schemaList.filter(s => !originalSchemas.includes(s));
                const removedSchemas = originalSchemas.filter(s => !schemaList.includes(s));
                if (addedSchemas.length > 0) {
                    if (this.state.formType === 'azure_blob' || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2') {
                        // datasourceConfig.added_buckets = addedSchemas;
                    } else {
                        // datasourceConfig.added_schemas = addedSchemas;
                    }
                }
                if (removedSchemas.length > 0) {
                    if (this.state.formType === 'azure_blob' || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2') {
                        // datasourceConfig.removed_buckets = removedSchemas;
                    } else {
                        // datasourceConfig.removed_schemas = removedSchemas;
                    }
                }
            }
        }

        let integrationConfigPayload = [];

        if (configType === 'manualConfig') {
            //eslint-disable-next-line
            const isSchemaNameType = ['snowflake', 'postgresql', 'redshift'].includes(this.state.formType);
            integrationConfigPayload = integrationConfigurations.map((config, index) => {
                const tableNames = config.incrementalData.map(item => ({
                    table: item.datasetName || "",
                    created_time: item.identifier || "",
                    start_with: item.startingIndexCheckbox && item.startingIndexType === 'incremental data identifier' ? item.startingIndexValue : "",
                    match_exact: item.exactMatch ? "match_exact" : "",
                    start_with_query: item.startingIndexCheckbox && item.startingIndexType === 'custom query' ? item.startingIndexQuery : "",
                    start_index_check_box: item.startingIndexCheckbox ? "true" : "false",
                    start_index_type: item.startingIndexType || "incremental data identifier",
                    partition_type: "column"
                }));

                const partitions = config.partitions.map(partition => {
                    const partitionObj = {
                        dataset_name: partition.datasetName || "",
                        partition_type: partition.partitionBy === 'Custom Query' ? "custom_query" : "column",
                        partition_name: partition.partitionName || ""
                    };

                    if (partition.partitionBy === 'Column' || partition.partitionBy === undefined) {
                        partitionObj.column_name = partition.partitionIdentifier || "";
                    } else if (partition.partitionBy === 'Custom Query') {
                        partitionObj.custom_query = partition.customQuery || "";
                    }

                    return partitionObj;
                });

                const isFileBasedConnector = this.state.formType === 'azure_blob' || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2';
                const isSchemaNameType = ['snowflake', 'postgresql', 'redshift'].includes(this.state.formType);

                if (isFileBasedConnector) {
                    return {
                        ...this.buildDatasourceConfig(testConnectionFormData, this.state.formType),
                        integration_name: config.integrationName || `integration${integrationConfigurations.length - index}`,
                        bucket: config.schema || config.bucket || '',
                        sub_path: config.sub_path || ''
                    };
                }

                return {
                    ...this.buildDatasourceConfig(testConnectionFormData, this.state.formType),
                    integration_name: config.integrationName || `integration${integrationConfigurations.length - index}`,
                    [isSchemaNameType ? 'schema_name' : 'schema']: config.schema || '',
                    partitions: partitions,
                    table_names: tableNames,
                    datasetToBeProcessed: config.datasetScope === 'allDatasets' ? 'allDataset' : 'specifiedDataset'
                };
            });
            const existingDetails = this.state.ex_edit_integration_details || this.props.ex_integration_details || {};

            // Use datasourceLevelIntegrations (from GET /datasource fetched on load) as the
            // authoritative list. Replace only the single integration being edited by matching
            // on the original integration_name, keep everything else exactly as-is.
            const datasourceLevelIntegrations = this.state.datasourceLevelIntegrations || [];
            const originalIntegrationName = existingDetails.integration_name;
            // The edited integration payload (always 1 item since UI shows only 1)
            const editedPayload = integrationConfigPayload[0];

            let mergedIntegrations;
            if (datasourceLevelIntegrations.length > 0 && editedPayload) {
                let replaced = false;
                mergedIntegrations = datasourceLevelIntegrations.map(orig => {
                    if (!replaced && orig.integration_name === originalIntegrationName) {
                        replaced = true;
                        return editedPayload;
                    }
                    return orig;
                });
                // If no match found (brand-new integration name), append it
                if (!replaced) {
                    mergedIntegrations = [...mergedIntegrations, editedPayload];
                }
            } else {
                // Fallback: datasource list unavailable
                mergedIntegrations = integrationConfigPayload;
            }

            datasourceConfig.integration_names = mergedIntegrations;

            if (existingDetails.integration_id) {
                const addedSchemas = datasourceConfig.added_schemas || datasourceConfig.added_buckets || [];
                const removedSchemas = datasourceConfig.removed_schemas || datasourceConfig.removed_buckets || [];

                const addedIntegrations = integrationConfigPayload
                    .filter(i => addedSchemas.includes(i.schema || i.schema_name || i.bucket))
                    .map(i => i.integration_name)
                    .filter(Boolean);

                const removedIntegrations = datasourceLevelIntegrations
                    .filter(i => removedSchemas.includes(i.schema || i.schema_name || i.bucket))
                    .map(i => i.integration_name)
                    .filter(Boolean);

                if (addedIntegrations.length > 0) {
                    datasourceConfig.added_integrations = addedIntegrations;
                }
                if (removedIntegrations.length > 0) {
                    datasourceConfig.removed_integrations = removedIntegrations;
                }
            }
        }

        const primaryIntegrationConfig = integrationConfigPayload[0] || {};
        const primaryIntegrationName = primaryIntegrationConfig.integration_name || existingIntegrationDetails.integration_name;
        const integrationConfig = integrationConfigPayload.length === 1
            ? {
                ...primaryIntegrationConfig,
                ...(integrationConfigurations[0].datasetScope === 'specifiedDatasets' && {
                    datasets_added: this.getDatasetsAdded(integrationConfigurations[0])
                })
                }
            : integrationConfigPayload.map((config, index) => ({
                ...config,
                ...(integrationConfigurations[index].datasetScope === 'specifiedDatasets' && {
                    datasets_added: this.getDatasetsAdded(integrationConfigurations[index])
                })
                }));
                
        const requestPayload = {
            integration_id: existingIntegrationDetails.integration_id,
            integration_name: primaryIntegrationName,
            tenant_id: localStorage.getItem('team_id'),
            user_id: localStorage.getItem('user_id'),
            env_id: existingIntegrationDetails.env_id || this.props.env_id,
            datasource_id: existingIntegrationDetails.datasource_id || this.props.datasource_id,
            datasource_name: testConnectionFormData.datasource_name || testConnectionFormData.integration_name || existingIntegrationDetails.datasource_name || "New Datasource",
            connector_type: existingIntegrationDetails.connector_type || this.mapDatasourceType(this.state.formType),
            integration_type: existingIntegrationDetails.integration_type || existingIntegrationDetails.connector_type || this.mapDatasourceType(this.state.formType),
            datasource_type: this.mapDatasourceType(this.state.formType),
            data_store_type: this.getDatasourceStoreType(this.state.formType),
            mode: configType,
            config_type: configType,
            integration_config: integrationConfig,
            datasource_config: datasourceConfig,
            auth_config: this.buildAuthConfig(testConnectionFormData, this.state.formType)
        };

        this.setState({ isCreatingDatasource: true });

        let saveErrorMessage = '';
        try {
            const response = await updateIntegrationById(requestPayload);

            if (response?.code === 200) {
                this.props.showToast && this.props.showToast("alert-success", "Integration saved successfully", null, null, false);
                this.props.onIntegrationSaved && this.props.onIntegrationSaved({
                    ...existingIntegrationDetails,
                    ...(response?.integration || {}),
                    integration_id: requestPayload.integration_id,
                    integration_name: primaryIntegrationName,
                    integration_config: requestPayload.integration_config,
                    datasource_config: requestPayload.datasource_config,
                    datasource_name: requestPayload.datasource_name,
                    mode: configType,
                    config_type: configType
                });
                this.props.setEnvData && this.props.setEnvData(requestPayload.env_id);
                this.props.closeModal ? this.props.closeModal() : this.props.setPage(false);
            } else if (response?.code === 401) {
                const formErrors = { ...this.state.integrationValidationErrors };
                let errorMapped = false;
                const failedIntegrations = response?.response;
                const isInvalidDataset = response?.response?.key === 'invalid_dataset';
                const failedConfig = isInvalidDataset && failedIntegrations && typeof failedIntegrations === 'object'
                    ? integrationConfigurations.find(config => (
                        (config.integrationName || config.integration_name) && Object.prototype.hasOwnProperty.call(failedIntegrations, config.integrationName || config.integration_name)
                    ))
                    : null;
                const failedSchema = failedConfig?.schema || failedConfig?.schema_name || failedConfig?.bucket;
                const errorMessage = isInvalidDataset && failedSchema
                    ? `Specified dataset doesn't exist in "${failedSchema}"`
                    : response?.message || response?.status_message || response?.response?.message || response?.response?.status_message || 'Specified dataset or partition already exists in datasource';
                saveErrorMessage = errorMessage;
                const getValidationMessage = (config) => (
                    isInvalidDataset && (config?.schema || config?.schema_name || config?.bucket)
                        ? `Specified dataset doesn't exist in "${config.schema || config.schema_name || config.bucket}"`
                        : errorMessage
                );

                const addValidationError = (config, field, itemId) => {
                    const validationMessage = getValidationMessage(config);
                    formErrors[config.id] = {
                        ...(formErrors[config.id] || {}),
                        [field]: {
                            ...(formErrors[config.id]?.[field] || {}),
                            [itemId]: validationMessage
                        }
                    };
                    errorMapped = true;
                };

                const findMatchingItem = (items, failedValue) => {
                    const normalizedFailedValue = String(failedValue || '').toLowerCase();
                    return (items || []).find(item => (
                        [item.datasetName, item.partitionName]
                            .filter(Boolean)
                            .some(value => String(value).toLowerCase() === normalizedFailedValue)
                    ));
                };

                if (failedIntegrations && typeof failedIntegrations === 'object' && Object.keys(failedIntegrations).length > 0) {
                    for (let i = 0; i < integrationConfigurations.length; i++) {
                        const config = integrationConfigurations[i];
                        const integrationName = config.integrationName;
                        if (integrationName && failedIntegrations[integrationName]) {
                            const failedItems = Array.isArray(failedIntegrations[integrationName])
                                ? failedIntegrations[integrationName]
                                : [failedIntegrations[integrationName]];
                            for (const failedItem of failedItems) {
                                const datasetItem = findMatchingItem(config.incrementalData, failedItem);
                                if (datasetItem) addValidationError(config, 'datasets', datasetItem.id);

                                const partitionItem = findMatchingItem(config.partitions, failedItem);
                                if (partitionItem) addValidationError(config, 'partitions', partitionItem.id);
                            }
                        }
                    }
                }
                
                if (!errorMapped) {
                    for (let i = 0; i < integrationConfigurations.length; i++) {
                        const config = integrationConfigurations[i];
                        if (config) {
                            const message = response?.message || '';
                            const targetDataset = (config.incrementalData || []).find(item =>
                                item.datasetName && message.includes(item.datasetName)
                            );
                            const targetPartition = (config.partitions || []).find(item =>
                                [item.datasetName, item.partitionName]
                                    .filter(Boolean)
                                    .some(value => message.includes(value))
                            );

                            if (targetDataset) addValidationError(config, 'datasets', targetDataset.id);
                            if (targetPartition) addValidationError(config, 'partitions', targetPartition.id);

                            if (!targetDataset && !targetPartition) {
                                const fallbackDataset = (config.incrementalData || []).find(item => item.isNew) || (config.incrementalData || [])[config.incrementalData?.length - 1];
                                const fallbackPartition = (config.partitions || [])[config.partitions?.length - 1];
                                if (fallbackDataset) addValidationError(config, 'datasets', fallbackDataset.id);
                                else if (fallbackPartition) addValidationError(config, 'partitions', fallbackPartition.id);
                            }
                        }
                    }
                }

                if (errorMapped) {
                    this.setState({ integrationValidationErrors: formErrors }, () => {
                        setTimeout(() => {
                            const firstError = document.querySelector('.error-text');
                            if (firstError) {
                                firstError.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center'
                                });
                            }
                        }, 100);
                    });
                } else {
                    this.props.showToast && this.props.showToast('alert-danger', response?.message || 'Specified dataset already exists in datasource', '', undefined, false);
                }
            } else {
                console.error('Failed to save integration:', response);
                saveErrorMessage = response?.message || response?.status_message || response?.response?.message || response?.response?.status_message || 'Failed to save integration';
                this.props.showToast && this.props.showToast('alert-danger', saveErrorMessage, '', undefined, false);
            }
        } catch (error) {
            console.error('Error saving integration:', error);
            saveErrorMessage = error?.message || 'An error occurred while saving integration';
            this.props.showToast && this.props.showToast('alert-danger', saveErrorMessage, '', undefined, false);
        } finally {
            this.setState({ isCreatingDatasource: false });
            window.dispatchEvent(new CustomEvent('save-completed', { detail: { errorMessage: saveErrorMessage } }));
        }
    }

    fill_details() {
        // Removed defaultValues as we given default value directly inside the state variable
        if (this.props.ex_integration_details !== undefined) {
            let values = this.FillFormDetails(this.props.ex_integration_details);
            //eslint-disable-next-line
            this.state.formType = values[1];
            //eslint-disable-next-line
            this.state.formType_option = values[0];
        }
    }

    setForm = (selectedOption) => {
        this.setState({
            formType: selectedOption["value"],
            helpContentKey: selectedOption["value"]
        });
        this.closeTestConnection();
    }

    closeTestConnection() {
        this.setState({
            testConnection: null
        });
    }

    setIntegrationData(data) {
        this.setState({
            integration_data: data
        });
    }

    setData(integration_data, testConnection_data) {
        this.setState({
            testConnection: testConnection_data,
            integration_data: integration_data,
        });
    }

    setSubmitButton(value) {
        this.setState({ submit_button: value });
    }

    // Handler methods for manual configuration mode
    handleDatasetChange = (event) => {
        this.setState({ datasetToBeProcessed: event.target.value });
    };

    handleStoreDataIssuesChange = (e) => {
        this.setState({ storeDataIssues: e.target.checked });
    }

    addIntegrationConfiguration = () => {
        const newConfig = {
            id: Date.now(),
            integrationName: `Integration ${this.state.integrationConfigurations.length + 1}`,
            specificDatasets: [],
            incrementalData: [],
            partitions: []
        };
        this.setState({
            integrationConfigurations: [...this.state.integrationConfigurations, newConfig]
        });
    }

    removeIntegrationConfiguration = (id) => {
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.filter(config => config.id !== id)
        });
    }

    addSpecificDataset = (configId) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    specificDatasets: [...config.specificDatasets, '']
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    removeSpecificDataset = (configId, index) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    specificDatasets: config.specificDatasets.filter((_, i) => i !== index)
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changeDatasetText = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newDatasets = [...config.specificDatasets];
                newDatasets[index] = value;
                return {
                    ...config,
                    specificDatasets: newDatasets
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    addIncrementalData = (configId) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    incrementalData: [...config.incrementalData, { column: '', startDate: '', endDate: '' }]
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    removeIncrementalData = (configId, index) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    incrementalData: config.incrementalData.filter((_, i) => i !== index)
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changeIncrementalColumn = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newIncremental = [...config.incrementalData];
                newIncremental[index] = { ...newIncremental[index], column: value };
                return {
                    ...config,
                    incrementalData: newIncremental
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changeIncrementalStartDate = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newIncremental = [...config.incrementalData];
                newIncremental[index] = { ...newIncremental[index], startDate: value };
                return {
                    ...config,
                    incrementalData: newIncremental
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changeIncrementalEndDate = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newIncremental = [...config.incrementalData];
                newIncremental[index] = { ...newIncremental[index], endDate: value };
                return {
                    ...config,
                    incrementalData: newIncremental
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    addPartition = (configId) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    partitions: [...config.partitions, { dataset: '', partitionName: '', partitionBy: '' }]
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    removePartition = (configId, index) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    partitions: config.partitions.filter((_, i) => i !== index)
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changePartitionDataset = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newPartitions = [...config.partitions];
                newPartitions[index] = { ...newPartitions[index], dataset: value };
                return {
                    ...config,
                    partitions: newPartitions
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changePartitionName = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newPartitions = [...config.partitions];
                newPartitions[index] = { ...newPartitions[index], partitionName: value };
                return {
                    ...config,
                    partitions: newPartitions
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changePartitionBy = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newPartitions = [...config.partitions];
                newPartitions[index] = { ...newPartitions[index], partitionBy: value };
                return {
                    ...config,
                    partitions: newPartitions
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    handleFormSubmit = (formData) => {
        // console.log('Form submitted:', formData);
        // Add your form submission logic here
        // You can call your API to save the datasource configuration
    }

    handleTestConnection = async (formData) => {
        // Set testing state and save form data
        this.setState({
            isTestingConnection: true,
            testConnectionSuccess: null,
            testConnectionResponse: null,
            testConnectionError: null, // Clear previous errors
            testConnectionFormData: formData // Save form data for display
        });
        // console.log('Testing connection with data:', formData);
        // Prepare request payload based on datasource type
        const requestPayload = {
            datasource_name: formData.datasource_name || "Test Dataset",
            tenant_id: localStorage.getItem('team_id'), // You may want to get this from props or auth
            env_id: this.props.env_id || 69,
            datasource_type: this.mapDatasourceType(this.state.formType),
            data_store_type: this.getDatasourceStoreType(this.state.formType),
            datasource_config: this.buildDatasourceConfig(formData, this.state.formType),
            auth_config: this.buildAuthConfig(formData, this.state.formType),
            ...(formData.check_type && { check_type: formData.check_type }),
            ...(formData.datasource_id && { datasource_id: formData.datasource_id })
        };
        const testDataSourceResponse = await testDataSource(requestPayload);
        if (testDataSourceResponse?.status_code) {
            // console.log('Test connection response:', testDataSourceResponse);
            // Check if connection was successful
            const success = testDataSourceResponse.status_code === 200;

            // Automatically select all schemas by default
            // eslint-disable-next-line
            const allSchemas = testDataSourceResponse?.schemas || [];

            this.setState({
                isTestingConnection: false,
                testConnectionSuccess: success,
                testConnectionResponse: testDataSourceResponse, // Store full response for further use
                //   selectedSchemas: allSchemas, // Auto-select all schemas by default
                testConnectionError: null // Clear any previous errors
            });

        }

        else {
            console.error('Test connection error:', testDataSourceResponse);
            // Extract error message from response
            const errorMessage = testDataSourceResponse?.message || testDataSourceResponse?.status_message || 'Connection Failed. Please check your credentials.';

            this.setState({
                isTestingConnection: false,
                testConnectionSuccess: false,
                testConnectionResponse: testDataSourceResponse?.response || testDataSourceResponse || null,
                testConnectionError: errorMessage // Store error message
            });

            if (testDataSourceResponse?.code === 401) {
                this.props.showToast && this.props.showToast('error', errorMessage);
            }
        }
    }

    // Map form type to API datasource_type
    mapDatasourceType = (formType) => {
        const typeMap = {
            'snowflake': 'snow_flake',
            'mysql': 'mysql',
            'postgresql': 'postgresql'
            // Add more mappings as needed
        };
        return typeMap[formType] || formType;
    }

    // Get data store type based on datasource
    getDatasourceStoreType = (formType) => {
        const dbTypes = ['snowflake', 'mysql', 'postgresql'];
        return dbTypes.includes(formType) ? 'database' : 'filesystem';
    }

    normalizeHostUrl = (host) => {
        return host ? host.replace(/^https?:\/\//, '') : '';
    }

    // Build datasource_config from form data
    buildDatasourceConfig = (formData, formType) => {
        if (formType === 'snowflake') {
            return {
                url: formData.host_url || formData.host || "",
                database: formData.database_name || formData.database || "",
                schema: formData.schema || "",
                ware_house: formData.warehouse || "",
                table_name: ""
            };
        } else if (formType === 'postgresql') {
            return {
                host_url: this.normalizeHostUrl(formData.host || formData.host_url || ""),
                database_name: formData.database || formData.database_name || "",
                schema_name: formData.schema_name || formData.schema || ""
            };
        } else if (formType === 'mysql') {
            return {
                host: this.normalizeHostUrl(formData.host || ""),
                database: formData.database || "",
                schema: formData.schema || ""
            };
        } else if (formType === 'azure_blob') {
            return {
                storage_name: formData.storage_name || '',
                filetype: formData.fileType || '',
                refresh_type: formData.refreshType || 'file_replace',
                version_format: formData.versionFormat === 'custom'
                    ? (formData.versionFormatRegex || 'none')
                    : (formData.versionFormat || 'none'),
                version_occurence: formData.versionOccurence || 'prefix'
            };
        }
        else if (formType === 'azure_data_lake_gen2') {
                    return {
                        storage_name: formData.storage_name || '',
                        filetype: formData.fileType || '',
                        refresh_type: formData.refreshType || 'file_replace',
                        version_format: formData.versionFormat === 'custom'
                            ? (formData.versionFormatRegex || 'none')
                            : (formData.versionFormat || 'none'),
                        version_occurence: formData.versionOccurence || 'prefix'
                    };
                }        
        else if (formType === 's3') {
            const refreshType = formData.refreshType || 'file_replace';
            return {
                auto_config_type: 'allBuckets',
                filetype: formData.fileType || '',
                error_storage: formData.error_storage || '',
                refresh_type: refreshType,
                version_format: formData.versionFormat === 'custom'
                    ? (formData.versionFormatRegex || 'none')
                    : (formData.versionFormat || 'none'),
                version_occurence: refreshType === 'file_replace'
                    ? 'default'
                    : (formData.versionOccurence || 'prefix'),
                default_error_storage: typeof formData.storeDataIssues === 'boolean'
                    ? !formData.storeDataIssues
                    : true
            };
        }
        return {};
    }

    // Build auth_config from form data
    buildAuthConfig = (formData, formType) => {
        if (formType === 'azure_blob') {
            return {
                secret_key: formData.blob_secret || formData.secret_key || ''
            };
        }
        if (formType === 'azure_data_lake_gen2') {
            return {
                secret_key: formData.blob_secret || formData.secret_key || ''
            };
        }
        if (formType === 's3') {
            return {
                tenant_id: localStorage.getItem('team_id') || '',
                access_key: formData.accessKey || formData.access_key || formData.access_key_id || '',
                secret_access_key: formData.secretAccessKey || formData.secret_access_key || ''
            };
        }
        if (formType === 'postgresql') {
            return {
                tenant_id: localStorage.getItem('team_id') || '',
                user_name: formData.user_name || formData.username || '',
                password: formData.password || ''
            };
        }
        return {
            tenant_id: localStorage.getItem('team_id') || '',
            user: formData.username || '',
            password: formData.password || '',
            private_key: formData.privateKey || '',
            private_key_pwd: formData.privateKeyPassphrase || formData.privateKeyPassword || ''
        };
    }

    // Get datasource label for display
    getDatasourceLabel = (formType) => {
        const labelMap = {
            'snowflake': 'Snowflake',
            'mysql': 'MySQL',
            'postgresql': 'PostgreSQL',
            'azure_blob': 'Azure Blob',
            'azure_data_lake_gen2': 'Azure Data Lake Gen2',
            's3': 'AWS S3',
            'aws_s3': 'AWS S3',
            'google_cloud_storage': 'Google Cloud Storage',
            'bigquery': 'BigQuery',
            'redshift': 'Redshift',
            'azure_synapse': 'Azure Synapse',
            'azure_sql': 'Azure SQL',
            'databricks': 'Databricks'
        };
        return labelMap[formType] || formType;
    }

    toggleSecretVisibility = (fieldKey) => {
        this.setState(prevState => {
            const currentSecrets = prevState.showSecret || {};
            return {
                showSecret: {
                    ...currentSecrets,
                    [fieldKey]: !currentSecrets[fieldKey]
                }
            };
        });
    };

    // Render icon dynamically based on icon name from config
    renderDynamicIcon = (iconName, size = 16) => {
        const IconComponent = require('lucide-react')[iconName];
        return IconComponent ? <IconComponent size={size} color="#A4A7AE" /> : null;
    }

    matchesFieldCondition = (actualValue, expectedValue) => {
        const normalizeValue = value =>
            typeof value === 'string' ? value.toLowerCase() : value;
        const normalizedActualValue = normalizeValue(actualValue);

        return Array.isArray(expectedValue)
            ? expectedValue.some(value => normalizeValue(value) === normalizedActualValue)
            : normalizeValue(expectedValue) === normalizedActualValue;
    }

    shouldShowIntegrationInfoField = (field, formData) => {
        if (!field.showWhen) return true;

        if (Array.isArray(field.showWhen)) {
            return field.showWhen.every(condition =>
                this.matchesFieldCondition(
                    formData[condition.field],
                    condition.value
                )
            );
        }

        return Object.entries(field.showWhen).every(([fieldName, expectedValue]) =>
            this.matchesFieldCondition(formData[fieldName], expectedValue)
        );
    }

    // Dynamically render integration info fields based on datasourceConfig
    renderIntegrationInfoFields = () => {
        const { formType, testConnectionFormData } = this.state;
        const datasourceConfig = require('./datasourceConfig.json');
        const config = datasourceConfig.datasourceTypes[formType];

        if (!config || !testConnectionFormData) return null;

        const renderedGroups = [];

        config.fieldGroups.forEach((group, groupIndex) => {
            const groupFields = [];

            // Skip credential groups - they will be rendered separately with Auth Method
            const isCredentialGroup = group.fields.some(field =>
                field.name === 'username' || field.name === 'password' || field.name === 'privateKey' || field.input === 'radio' || field.input === 'password'
            );

            if (isCredentialGroup) return;

            group.fields.forEach((field) => {
                // Skip datasource_name - it's rendered in the same row as Type
                if (field.name === 'datasource_name') return;

                // Skip fields that shouldn't be shown based on showWhen condition
                if (!this.shouldShowIntegrationInfoField(field, testConnectionFormData)) return;

                // Skip if value doesn't exist
                const value = testConnectionFormData[field.name];
                if (!value) return;

                groupFields.push(
                    <div key={field.name} className="qd-configure-integration-info__item">
                        <label className='qd-configure-integration-info__label'>{field.label}</label>
                        <span className="qd-configure-integration-info__value">
                            <i>{this.renderDynamicIcon(field.icon)}</i>
                            <RcTooltip
                                placement="top"
                                overlay={<span>{value}</span>}
                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                                <span>{value}</span>
                            </RcTooltip>
                        </span>
                    </div>
                );
            });

            if (groupFields.length > 0) {
                // Add separator before group if it has separator property and it's not the first group
                if (group.separator && renderedGroups.length > 0) {
                    renderedGroups.push(<hr key={`separator-${groupIndex}`} />);
                }

                renderedGroups.push(
                    <>
                        <hr className='tw-block tw-my-3' />
                        <div key={`group-${groupIndex}`} className="qd-configure-integration-info__list">
                            {groupFields}
                        </div>
                    </>
                );
            }
        });

        return renderedGroups;
    }

    // Render credential fields with Auth Method
    renderCredentialFields = () => {
        const { formType, testConnectionFormData } = this.state;
        const datasourceConfig = require('./datasourceConfig.json');
        const config = datasourceConfig.datasourceTypes[formType];

        if (!config || !testConnectionFormData) return null;

        const credentialFields = [];

        // Find the credential group
        const credentialGroup = config.fieldGroups.find(group =>
            group.fields.some(field => field.name === 'username' || field.name === 'password' || field.name === 'privateKey' || field.input === 'password')
        );

        if (!credentialGroup) return null;

        // Add Auth Method first (for Snowflake with authMethod)
        if (testConnectionFormData.authMethod) {
            credentialFields.push(
                <div key="authMethod" className="qd-configure-integration-info__item">
                    <label className='qd-configure-integration-info__label'>Auth Method</label>
                    <span className="qd-configure-integration-info__value">
                        <i><LockKeyhole size={16} color="#A4A7AE" /></i>
                        <span>{testConnectionFormData.authMethod}</span>
                    </span>
                </div>
            );
        }

        // Add credential fields based on config
        credentialGroup.fields.forEach((field) => {
            // Skip radio button field itself
            if (field.input === 'radio') return;

            // Skip fields that shouldn't be shown based on showWhen condition
            if (field.showWhen) {
                const key = Object.keys(field.showWhen)[0];
                if (testConnectionFormData[key] !== field.showWhen[key]) {
                    return;
                }
            }

            // Skip if value doesn't exist
            const value = testConnectionFormData[field.name];
            if (!value) return;

            // Handle password fields
            if (field.input === 'password' || field.name === 'password') {
                const isVisible = this.state.showSecret?.[field.name];
                credentialFields.push(
                    <div key={field.name} className="qd-configure-integration-info__item">
                        <label className='qd-configure-integration-info__label'>{field.label}</label>
                        <span className="qd-configure-integration-info__value">
                            <i>{this.renderDynamicIcon(field.icon)}</i>
                            {isVisible ? (
                                <RcTooltip placement="top" overlay={<span>{value}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                    <span>{value}</span>
                                </RcTooltip>
                            ) : (
                                <span>••••••••</span>
                            )}
                            <i className='cursor-pointer' onClick={() => this.toggleSecretVisibility(field.name)}>
                                {isVisible ? <EyeOff size={16} color="#A4A7AE" /> : <Eye size={16} color="#A4A7AE" />}
                            </i>
                        </span>
                    </div>
                );
                return;
            }

            // Handle privateKey field
            if (field.name === 'privateKey') {
                credentialFields.push(
                    <div key={field.name} className="qd-configure-integration-info__item">
                        <label className='qd-configure-integration-info__label'>{field.label}</label>
                        <span className="qd-configure-integration-info__value">
                            <i>{this.renderDynamicIcon(field.icon)}</i>
                            <span>Configured</span>
                        </span>
                    </div>
                );
                return;
            }

            // Regular fields (username, etc.)
            credentialFields.push(
                <div key={field.name} className="qd-configure-integration-info__item">
                    <label className='qd-configure-integration-info__label'>{field.label}</label>
                    <span className="qd-configure-integration-info__value">
                        <i>{this.renderDynamicIcon(field.icon)}</i>
                        <RcTooltip
                            placement="top"
                            overlay={<span>{value}</span>}
                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                        >
                            <span>{value}</span>
                        </RcTooltip>
                    </span>
                </div>
            );
        });

        if (credentialFields.length === 0) return null;

        return (
            <>
                <hr className='tw-block tw-my-3' />
                <div className="qd-configure-integration-info__list">
                    {credentialFields}
                </div>
            </>
        );
    }



    renderTest() {
        if (this.state.testConnection != null) {
            return <TestConnection integration_data={this.state.integration_data}
                testConnection_data={this.state.testConnection}
                submit_button={this.state.submit_button}
                closeTestConnection={this.closeTestConnection}
                src_page={this.props.src_page}
                setPage={this.props.setPage}
                showToast={this.props.showToast}
                closeModal={this.props.closeModal}
                existingIntegrations={this.props.existingIntegrations}
                setEnvData={this.props.setEnvData}
                env_id={this.props.env_id}
                ip_address={this.state.ip_address}
            />;
        }
    }


    FillFormDetails(integration_details) {
        let defaultValue, formType = null;
        const integration_type = integration_details["integration_type"];
        if (integration_type === undefined) {
            return [null, null];
        }
        if (integration_type === "azure_blob") {
            formType = "azure_blob";
            defaultValue = { "label": "Azure Blob", "value": 'azure_blob' };
        } else if (integration_type === "azure_data_lake_gen2") {
            formType = "azure_data_lake_gen2";
            defaultValue = { "label": "Azure Data Lake Gen2", "value": 'azure_data_lake_gen2' };
        } else if (integration_type === "azure_data_lake") {
            formType = "azure_data_lake";
            defaultValue = { "label": 'Azure Data Lake', "value": 'azure_data_lake' };
        } else if (integration_type === "azure_databricks_table") {
            formType = "azure_databricks_table";
            defaultValue = { "label": 'Azure Databricks Table', "value": 'azure_databricks_table' };
        } else if (integration_type === "azure_microsoft_fabric") {
            formType = "azure_databricks_table";
            defaultValue = { "label": 'Azure Microsoft Fabric', "value": 'azure_microsoft_fabric' };
        } else if (integration_type === "microsoft_purview") {
            formType = "microsoft_purview";
            defaultValue = { "label": 'Microsoft Purview', "value": 'microsoft_purview' };
        } else if (integration_type === "unity_catalog") {
            formType = "unity_catalog";
            defaultValue = { "label": 'Databricks Unity Catalog', "value": 'unity_catalog' };
        } else if (integration_type.includes("snow_flake")) {
            formType = "snowflake";
            defaultValue = { "label": 'Snowflake', "value": 'snowflake' };
        } else if (integration_type.includes("s3")) {
            formType = "s3";
            defaultValue = { "label": 'AWS S3', "value": 's3' };
        } else if (integration_type.includes("azure_sql")) {
            formType = "azure_sql";
            defaultValue = { "label": "Azure SQLServer", "value": 'azure_sql' };
        } else if (integration_type.includes("gcp_sql")) {
            formType = "gcp_sql";
            defaultValue = { "label": "GCP SQLServer", "value": 'gcp_sql' };
        } else if (integration_type.includes("big_query")) {
            formType = "big_query";
            defaultValue = { "label": "Google BigQuery", "value": 'big_query' };
        } else if (integration_type.includes("postgresql")) {
            formType = "postgresql";
            defaultValue = { "label": "Postgres", "value": 'postgresql' };
        } else if (integration_type.includes("mysql")) {
            formType = "mysql";
            defaultValue = { "label": "MySQL", "value": 'mysql' };
        }  // Graph DB Types
        else if (integration_type.includes("neo4j")) {
            formType = "neo4j";
            defaultValue = {"label": 'Neo4j', "value": 'neo4j'};
        }
        else if (integration_type.includes("amazon_neptune")) {
            formType = "amazon_neptune";
            defaultValue = {"label": 'Amazon Neptune', "value": 'amazon_neptune'};
        }
        else if (integration_type.includes("azure_cosmos_db")) {
            formType = "azure_cosmos_db";
            defaultValue = {"label": 'Azure Cosmos DB', "value": 'azure_cosmos_db'};
        }
        else if (integration_type.includes("google_cloud_spanner")) {
            formType = "google_cloud_spanner";
            defaultValue = {"label": 'Google Cloud Spanner', "value": 'google_cloud_spanner'};
        }  // Vector DB Types
        else if (integration_type.includes("pinecone")) {
            formType = "pinecone";
            defaultValue = {"label": 'Pinecone', "value": 'pinecone'};
        }
        else if (integration_type.includes("elasticsearch")) {
            formType = "elasticsearch";
            defaultValue = {"label": 'Elasticsearch', "value": 'elasticsearch'};
        }
        else if (integration_type.includes("postgres_vector")) {
            formType = "postgres_vector";
            defaultValue = {"label": 'Postgres Vector', "value": 'postgres_vector'};
        } else if (integration_type.includes("gcs")) {
            formType = "gcs";
            defaultValue = { "label": "GCS", "value": 'gcs' };
        } else if (integration_type.includes("redshift")) {
            formType = "redshift";
            defaultValue = { "label": 'AWS redshift', "value": 'redshift' };
        } else if (integration_type.includes("athena")) {
            formType = "athena";
            defaultValue = { "label": 'Athena', "value": 'AWS Athena' };
        }
        else if (integration_type.includes(POWER_BI_CONNECTOR)) {
            formType = POWER_BI_CONNECTOR;
            defaultValue = { "label": 'Power Bi', "value": POWER_BI_CONNECTOR };
        }
        else if (integration_type === AZURE_SYNAPSE_DS_CONNECTOR) {
            formType = AZURE_SYNAPSE_DS_CONNECTOR;
            defaultValue = { "label": 'Azure Synapse', "value": AZURE_SYNAPSE_DS_CONNECTOR };
        }
        else {
            formType = "AWS";
            defaultValue = { "label": 'AWS', "value": 'AWS' };
        }
        return [defaultValue, formType];
    }

    changeHelpContent(key) {
        this.setState({ helpContentKey: key });
    }

    renderHelpContent() {
        let content = [];
        let info = [];
        if (this.state.formType === "AWS") {
            info = helpContent["aws"];
        } else if (this.state.formType === "snowflake") {
            info = helpContent["snowflake"];
        } else if (this.state.helpContentKey === "azure_blob") {
            info = helpContent["azure_blob"];
        } else if (this.state.helpContentKey === "azure_data_lake") {
            info = helpContent["azure_data_lake"];
        } else if (this.state.helpContentKey === "azure_databricks_table") {
            info = helpContent["azure_databricks_table"];
        // Graph DB Types
        } else if(this.state.helpContentKey === "neo4j") {
            info = helpContent["neo4j"];
        } else if(this.state.helpContentKey === "amazon_neptune") {
            info = helpContent["amazon_neptune"];
        } else if(this.state.helpContentKey === "azure_cosmos_db") {
            info = helpContent["azure_cosmos_db"];
        } else if(this.state.helpContentKey === "google_cloud_spanner") {
            info = helpContent["google_cloud_spanner"];
        // Vector DB Types
        } else if(this.state.helpContentKey === "pinecone") {
            info = helpContent["pinecone"];
        } else if(this.state.helpContentKey === "elasticsearch") {
            info = helpContent["elasticsearch"];
        } else if(this.state.helpContentKey === "postgres_vector") {
            info = helpContent["postgres_vector"];  
        } else if (this.state.formType === "s3") {
            info = helpContent["aws"];
        } else if (this.state.formType === "redshift") {
            info = helpContent["redshift"];
        } else if (this.state.formType === "athena") {
            info = helpContent["athena"];
        } else if (this.state.formType === "azure_sql") {
            info = helpContent["azure_sql"];
        } else if (this.state.formType === "gcp_sql") {
            info = helpContent["gcp_sql"];
        } else if (this.state.formType === "big_query") {
            info = helpContent["big_query"];
        } else if (this.state.formType === "postgresql") {
            info = helpContent["postgresql"];
        } else if (this.state.formType === "mysql") {
            info = helpContent["mysql"];
        }
        else if (this.state.formType === "gcs") {
            info = helpContent["gcs"];
        }
        else if (this.state.formType === "azure_synapse_ds") {
            info = helpContent["azure_synapse_ds"];
        }
        else if(this.state.helpContentKey === "azure_microsoft_fabric") {
            info = helpContent["azure_microsoft_fabric"];  
        }
        else if (this.state.formType === "microsoft_purview" || this.state.helpContentKey === "microsoft_purview") {
            info = helpContent["microsoft_purview"];
        }
        else if (this.state.formType === "unity_catalog" || this.state.helpContentKey === "unity_catalog") {
            info = helpContent["unity_catalog"];
        }
        else {
            info = helpContent["azure_blob"];
        }
        let k = 0;
        for (k = 0; k < info.length; k++) {
            if (k === (info.length - 1) && this.state.formType !== 'big_query') {
                content.push(<li>Make sure Qualdo's IP : <strong> {this.state.ip_address} </strong> is added to your authorised network(s).</li>);
                content.push(<li>{info[k]} Refer to the <a href={get_document_link("data_source")} rel="noopener noreferrer" target="_blank">{QUALDO_DOCUMENTATION}</a> for more details.</li>);
            }
            else if (k === (info.length - 1) && this.state.formType === 'big_query') {
                content.push(<li>{info[k]} Refer to the <a href={get_document_link("data_source")} rel="noopener noreferrer" target="_blank">{QUALDO_DOCUMENTATION}</a> for more details.</li>);
                content.push(<li>Make sure Qualdo's IP : <strong> {this.state.ip_address} </strong> is added to your authorised network(s).</li>);

            }
            else {
                if (this.state.formType === 'azure_databricks_table' ||  this.state.formType === 'unity_catalog') {
                    if ((k >= 3 && k <= 6) || (k >= 8 && k <= 11)) {
                        content.push(<ol start="1">{info[k]}</ol>);
                    }
                    else {
                        content.push(<li>{info[k]}</li>);
                    }
                }
                else {
                    content.push(<li>{info[k]}</li>);
                }
            }
        }

        if ($(window).width() > 768) {
            let addheight = $('#add-datasource').height();
            $('#add-datasource_help').height(addheight - 26);
        }
        return content;
    }
    getAddIntegrationContent(data_source_option) {
        return (
            <>
                <div className="portlet portlet-2col" id="add_data_source_panel">
                    <div className="portlet-title">
                        <div className="caption">
                            <span className="text-uppercase font-dark">{this.props.src_page === "setup" ? "Add your first DataSource" : "Add DataSource"}</span>
                            <p className="!tw-text-[#535862] dark:tw-text-[#787B86] mt-1">Manage your team members and their account permissions here.</p>
                        </div>
                        <div className="actions"></div>
                    </div>



                    <div className="portlet-body d-none">
                        <div className="row">
                            <div className={this.props.ex_integration_details !== undefined ? "col-md-12" : "col-md-8"}>
                                <div className="portlet-body" id="add-datasource">
                                    <div className="form-row">

                                        <div className="form-group col-md-6 hello">
                                            <label>Choose a Datasource type </label>
                                            <Select
                                                id="choose_datasource_type_add"
                                                filterOption={({ label }, query) => label.toLowerCase().includes(query.toLowerCase())}
                                                onChange={this.setForm}
                                                defaultValue={this.state.formType_option}
                                                options={data_source_option}
                                                placeholder="Choose Data Source"
                                                classNamePrefix='select-control'
                                                formatGroupLabel={formatGroupLabel}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="portlet border-0 mb-0">
                                    <div className="portlet-title">
                                        <div className="caption">
                                            <span className="text-uppercase">Help</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="portlet-body p-0">
                                    {/* <h4 id="tooltipupdate">
                                            <div>
                                                <code className="highlighter-rouge">Steps to enable access from your storage to Qualdo™: </code>
                                                <a className="anchorjs-link " href="#tooltipupdate"
                                                    aria-label="Anchor" data-anchorjs-icon="#" style={{paddingLeft: "0.375em"}}>
                                                </a>
                                            </div>
                                        </h4> */}
                                    {/* <figure className="highlight" style={{"height": "250px","overflow-y": "auto"}}>
                                            {this.renderHelpContent()}
                                        </figure> */}

                                    <div id="add-datasource_help" class="qd-helpGuide">
                                        <div class="qd-helpGuide__content">
                                            <h4 class="qd-helpGuide__title">Steps to enable access from your storage to Qualdo™: </h4>
                                            <ol class="qd-helpGuide__info">
                                                {this.renderHelpContent()}
                                            </ol>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='portlet-body'>
                        <div className="row">
                            <div class="col-md-8">
                                <div className="d-flex flex-column h-100">
                                    <div class="qd-configure-integration-steps">
                                        <div className="vertical-stepper vertical-stepper-sm w-100 border-0">
                                            <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">
                                                <span className="vs-heading__circle">3</span>
                                                <div className="vs-heading__title">Datasource Details</div>
                                            </div>
                                            <div className="vertical-stepper__content">
                                                {!this.state.showTestConnectionInfo && (
                                                    <div >
                                                        {/* className={this.state.testConnectionSuccess === null ? "" : "d-none"} */}
                                                        <div class="form-row">
                                                            <div class="form-group col-lg-6">
                                                                <label>Choose a Datasource type <span className='text-primary'>*</span></label>
                                                                <Select
                                                                    id="choose_datasource_type_add"
                                                                    filterOption={({ label }, query) => label.toLowerCase().includes(query.toLowerCase())}
                                                                    onChange={this.setForm}
                                                                    defaultValue={this.state.formType_option}
                                                                    options={data_source_option}
                                                                    placeholder="Choose Data Source"
                                                                    classNamePrefix='select-control'
                                                                    formatGroupLabel={formatGroupLabel}
                                                                    components={{ Control: customSelectDatasource }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <DynamicDatasourceForm
                                                            key={this.state.formResetKey}
                                                            config={datasourceConfig}
                                                            selectedDatasource={this.state.formType}
                                                            onSubmit={this.handleFormSubmit}
                                                            onTestConnection={this.handleTestConnection}
                                                            isTestingConnection={this.state.isTestingConnection}
                                                            testConnectionSuccess={this.state.testConnectionSuccess}
                                                            testConnectionResponse={this.state.testConnectionResponse}
                                                            onContinueSchemaSelection={this.handleContinueSchemaSelection}
                                                            initialFormData={this.state.testConnectionFormData}
                                                            existingIntegrations={this.props.existingIntegrations || []}
                                                            ip_address={this.state.ip_address}
                                                            isEditMode={false}
                                                        />
                                                    </div>
                                                )}

                                                {this.state.showTestConnectionInfo && this.state.testConnectionSuccess !== null && this.state.testConnectionFormData && (
                                                    <div className="qd-configure-integration-info">
                                                        <div className="qd-configure-integration-info__content" id="test_connection_info">
                                                            <div className="qd-configure-integration-info__list">
                                                                <div className="qd-configure-integration-info__item">
                                                                    <label className='qd-configure-integration-info__label'>Type</label>
                                                                    <span className="qd-configure-integration-info__value">
                                                                        <i>
                                                                            <Database size={16} color="#A4A7AE" />
                                                                        </i>
                                                                        <span>{this.getDatasourceLabel(this.state.formType)}</span>
                                                                    </span>
                                                                </div>
                                                                {this.state.testConnectionFormData.datasource_name && (
                                                                    <div className="qd-configure-integration-info__item">
                                                                        <label className='qd-configure-integration-info__label'>Datasource Name</label>
                                                                        <span className="qd-configure-integration-info__value">
                                                                            <i>
                                                                                <Database size={16} color="#A4A7AE" />
                                                                            </i>
                                                                            <RcTooltip
                                                                                placement="top"
                                                                                overlay={<span>{this.state.testConnectionFormData.datasource_name}</span>}
                                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                            >
                                                                                <span>{this.state.testConnectionFormData.datasource_name}</span>
                                                                            </RcTooltip>
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            {/* Dynamically render fields from datasourceConfig.json */}
                                                            {this.renderIntegrationInfoFields()}
                                                            {/* Render Auth Method and Credential fields together */}
                                                            {this.renderCredentialFields()}
                                                            <hr className='tw-block tw-my-3' />
                                                            <div className="qd-configure-integration-info__action">
                                                                {/* Show error message if connection failed */}
                                                                {this.state.testConnectionError ? (
                                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                                        <button className="btn btn-sm btn-circle tw-border-[#FCA5A5] tw-bg-[#FEF2F2] tw-text-[#DC2626] tw-mr-3 !tw-px-2 hover:tw-text-[#DC2626] hover:!tw-shadow-none">
                                                                            {this.state.testConnectionError}
                                                                        </button>
                                                                        <button className="btn btn-sm btn-outline btn-circle btn-grey !tw-px-2" onClick={this.editDatasourceDetails}>Edit</button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="tw-flex tw-items-center tw-justify-end tw-gap-3">
                                                                        {getDatasourceStatus(this.state.ex_edit_integration_details?.auto_config_status || this.props.ex_integration_details?.auto_config_status || 'completed')}
                                                                        <button className="tw-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-text-xs tw-pl-2 tw-pr-3 tw-py-[5px] tw-text-[#414651] dark:tw-text-[#B2B5BE] tw-font-medium hover:tw-text-[#414651] dark:hover:tw-text-[#B2B5BE] dark:tw-text-[#B2B5BE] hover:tw-border-[#D5D7DA] dark:hover:tw-border-[#2B2B40] dark:tw-border-[#2B2B40] hover:tw-bg-[#F4F5F5] dark:hover:tw-bg-[#2B2B40]" disabled={true} onClick={this.editDatasourceDetails}>
                                                                            <i className='tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-mr-1'><SquarePen size={12} color="#A4A7AE" /></i>
                                                                            Edit
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {this.state.showSchemaConfigInfo && (
                                                <>
                                                    <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">{/* Add this class for inactive state - vertical-stepper__heading--inactive */}
                                                        <span className="vs-heading__circle">4</span>
                                                        <div className="vs-heading__title-wrap">
                                                            <div className="vs-heading__title">Schema & Mode Selection</div>
                                                            {/* <p className='m-0'>Choose your schema scope and configuration mode</p> */}
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={`vertical-stepper__content`}
                                                    >
                                                        <div id="qd-configure-integration-form-selection"
                                                            // className={` ${
                                                            //     this.state.showSchemaConfigInfo === null ? "" : "d-none"
                                                            // }`}
                                                            className={` ${this.state.manualNextClicked === true ? "d-none" : ""
                                                                }`}

                                                        >
                                                            <div
                                                                className={`tw-border tw-border-solid tw-rounded-xl tw-p-4 tw-mb-4 transition-card ${this.state.selected ? "border-primary shadow-sm" : "tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]"
                                                                    }`}
                                                            >
                                                                {/* Top Card Body */}
                                                                <div className={`d-flex ${this.state.selected ? "tw-pb-4" : ""}`}>
                                                                    <Form.Check
                                                                        custom
                                                                        name='schema_mode_selection'
                                                                        type={'radio'}
                                                                        id={`allSchemas`}
                                                                        value="allSchemas"
                                                                        className="md:tw-mr-3"
                                                                        checked={this.state.selected}
                                                                        onChange={this.handleSchemaModeSelection}
                                                                    />
                                                                    <div>
                                                                        <h5 className="tw-mb-1 tw-font-[400] tw-text-black dark:tw-text-[#B2B5BE]">
                                                                            <i className='tw-me-1'>
                                                                                <Layers2 size={16} color="#A4A7AE" />
                                                                            </i>
                                                                            All Schemas
                                                                        </h5>
                                                                        <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">Process all available schemas automatically</p>
                                                                    </div>
                                                                </div>

                                                                {/* Expandable Section */}

                                                                <div className={`integration-collapse-content ${this.state.selected ? "open tw-ps-5 md:tw-ps-8" : ""}`}>
                                                                    {this.state.specificSelect === false ? <div className='md:tw-pe-8 tw-py-4 tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                                        <Form.Label>Configuration Mode <span className="text-danger">*</span></Form.Label>
                                                                        <div className='custom-control custom-radio xl:tw-flex pl-0'>
                                                                            <label className="d-flex align-items-center tw-mr-8 tw-mb-0">
                                                                                <input
                                                                                    type="radio"
                                                                                    name="mode"
                                                                                    value="autoconfig"
                                                                                    className="mr-2"
                                                                                    checked={this.state.configurationMode === 'autoconfig'}
                                                                                    onChange={this.handleConfigurationModeChange}
                                                                                />
                                                                                Autoconfig <span className='tw-text-[#535862] dark:tw-text-[#787B86] tw-ms-1'>(Recommended)</span>
                                                                            </label>
                                                                            <label className={`d-flex align-items-center tw-mb-0 ${this.state.selected ? 'text-muted' : ''}`}>
                                                                                <input
                                                                                    type="radio"
                                                                                    className="mr-2"
                                                                                    disabled={true}
                                                                                />
                                                                                Manual Config <span className='tw-ms-1 tw-hidden sm:tw-inline-block'>(Not available for All Schemas)</span>
                                                                            </label>
                                                                        </div>

                                                                    </div> : ""}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={`tw-border tw-border-solid tw-rounded-xl tw-p-4 transition-card ${this.state.specificSelect ? "border-primary shadow-sm" : "tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]"

                                                                    }`

                                                                }
                                                            >
                                                                {/* Top Card Body */}
                                                                <div className={`d-flex ${this.state.specificSelect ? "tw-pb-4" : ""}`}>
                                                                    <Form.Check
                                                                        custom
                                                                        type={'radio'}
                                                                        id={`specificSchemas`}
                                                                        name='schema_mode_selection'
                                                                        value="specificSchemas"
                                                                        className="md:tw-mr-3"
                                                                        checked={this.state.specificSelect}
                                                                        onChange={this.handleSchemaModeSelection}
                                                                    />
                                                                    <div>
                                                                        <h5 className="tw-mb-1 tw-font-[400] tw-text-black dark:tw-text-[#B2B5BE]">
                                                                            <i className='tw-me-1'>
                                                                                <FolderOpen size={16} color="#A4A7AE" />
                                                                            </i>
                                                                            Specified Schemas
                                                                        </h5>
                                                                        <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">{`Select specific ${this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "buckets" : "schemas"} from your ${this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "filesystem" : "database"}`}</p>
                                                                    </div>
                                                                </div>

                                                                {/* Expandable Section */}
                                                                <div className={`integration-collapse-content ${this.state.specificSelect ? "open tw-ps-5 md:tw-ps-8" : ""}`}>
                                                                    {this.state.specificSelect ?
                                                                        <div className='md:tw-pe-8 tw-py-4 tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                                            <button className={this.state.selectedSchemas.length > 0 && this.state.testConnectionResponse?.schemas?.length > 0 ? "btn !tw-border-[#ABEFC6] tw-bg-[#F6FEF9] tw-text-black btn-block tw-mb-4 hover:!tw-shadow-none dark:!tw-border-[#1B5E3C] dark:tw-bg-[#0E2A1C] dark:tw-text-white" : "btn tw-bg-[#FAFAFA] tw-border tw-border-solid tw-border-[#D5D7DA] tw-text-[#484848] hover:tw-bg-[#F5F5F5] hover:tw-border-[#E9EAEC] btn-block tw-mb-4 hover:!tw-shadow-none dark:!tw-bg-[#2B2B40] dark:!tw-border-[#3A3A55] dark:!tw-text-white"} onClick={this.handleShowSchemeModal}>
                                                                                <i className='tw-mr-1'>
                                                                                    <FolderTree size={16} color="#A4A7AE" />
                                                                                </i>
                                                                                {this.state.selectedSchemas.length > 0 && this.state.testConnectionResponse?.schemas?.length > 0 ? "Selected Schema (" + this.state.selectedSchemas.length + ")" : "Fetch Available Schemas"}
                                                                            </button>
                                                                            <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                                                                <div>
                                                                                    <Form.Label className='tw-block'>Schema Selection <span className="text-danger">*</span></Form.Label>
                                                                                    <div className='custom-control custom-radio xl:tw-flex pl-0'>
                                                                                        <label className="d-flex align-items-center tw-mr-8 tw-mb-0">
                                                                                            <input
                                                                                                type="radio"
                                                                                                name="mode"
                                                                                                value="autoconfig"
                                                                                                className="mr-2"
                                                                                                checked={this.state.configurationMode === 'autoconfig'}
                                                                                                onChange={this.handleConfigurationModeChange}
                                                                                            />
                                                                                            Autoconfig
                                                                                        </label>
                                                                                        <label className="d-flex align-items-center text-muted tw-mb-0">
                                                                                            <input
                                                                                                type="radio"
                                                                                                name="mode"
                                                                                                value="manual"
                                                                                                className="mr-2"
                                                                                                checked={this.state.configurationMode === 'manual'}
                                                                                                onChange={this.handleConfigurationModeChange}
                                                                                            />
                                                                                            Manual Config
                                                                                        </label>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div> : ""}
                                                                </div>
                                                            </div>
                                                            {this.state.configurationMode === 'manual' && (
                                                                <div className='tw-flex tw-items-center tw-justify-end tw-my-4'>
                                                                    <button
                                                                        name="specifiedSchemasNext"
                                                                        onClick={this.handleSchemaModeSelectionNext}
                                                                        className='btn btn-outline-primary tw-mt-3 sm:tw-mt-0 tw-inline-flex tw-items-center'>
                                                                        Continue Manual Configuration
                                                                        <i className='tw-ms-1'>
                                                                            <svg
                                                                                width="20"
                                                                                height="20"
                                                                                viewBox="0 0 20 20"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <mask
                                                                                    id="mask0_26824_209148"
                                                                                    style={{ maskType: "alpha" }}
                                                                                    maskUnits="userSpaceOnUse"
                                                                                    x="0"
                                                                                    y="0"
                                                                                    width="20"
                                                                                    height="20"
                                                                                >
                                                                                    <rect width="20" height="20" fill="#D9D9D9" />
                                                                                </mask>

                                                                                <g mask="url(#mask0_26824_209148)">
                                                                                    <path
                                                                                        d="M11.6673 15L10.5007 13.7917L13.459 10.8333H3.33398V9.16667H13.459L10.5007 6.20833L11.6673 5L16.6673 10L11.6673 15Z"
                                                                                        fill="currentColor"
                                                                                    />
                                                                                </g>
                                                                            </svg>
                                                                        </i>
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {this.state.showSchemaConfigInfo && this.state.configurationMode === 'manual' && this.state.testConnectionResponse && this.state.selectedSchemas.length > 0 && this.state.manualNextClicked === true && (
                                                            <div className="qd-configure-integration-info" id="qd-configure-integration-info-manual-schema">
                                                                <div className="qd-configure-integration-info__content">
                                                                    <div className="qd-configure-integration-info__list !tw-grid-cols-2">
                                                                        <div className="qd-configure-integration-info__item">
                                                                            <label className='qd-configure-integration-info__label'>
                                                                                {this.state.schemaModeSelection === 'allSchemas' ? 'All Schemas' : 'Specified Schemas'}
                                                                            </label>
                                                                            <span className="qd-configure-integration-info__value">
                                                                                {this.state.schemaModeSelection === 'allSchemas' ? (
                                                                                    <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>Process all available schemas automatically</span>
                                                                                ) : (
                                                                                    <>
                                                                                        {this.state.selectedSchemas.length > 0 ? (
                                                                                            this.state.selectedSchemas.map((schema, index) => (
                                                                                                <span key={index} className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#C7D7FE] dark:tw-border-[#2B2B40] tw-bg-[#EEF4FF] dark:tw-bg-[#161622] tw-text-[#3538CD] dark:tw-text-[#53B1FD] tw-text-xs tw-font-medium tw-flex tw-items-center'>
                                                                                                    <i className="tw-me-[2px]">
                                                                                                        <FolderTree className="d-block tw-text-[#175CD3] dark:tw-text-[#53B1FD]" size={12} color="currentColor" />
                                                                                                    </i>
                                                                                                    {schema}
                                                                                                </span>
                                                                                            ))
                                                                                        ) : (
                                                                                            <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>No schemas selected</span>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                        <div className="qd-configure-integration-info__item">
                                                                            <label className='qd-configure-integration-info__label'>Configuration Mode</label>
                                                                            <span className="qd-configure-integration-info__value">
                                                                                <Form.Check
                                                                                    disabled={true}
                                                                                    custom
                                                                                    type={'radio'}
                                                                                    id={`configMode_${this.state.configurationMode}`}
                                                                                    label={this.state.configurationMode === 'autoconfig' ? 'Autoconfig' : 'Manual Config'}
                                                                                    checked={true}
                                                                                    className="mr-4"
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <hr class="tw-block tw-my-3"></hr>
                                                                    <div className="qd-configure-integration-info__action">
                                                                        <div className='tw-flex tw-items-center tw-justify-end tw-gap-3'>
                                                                            {getDatasourceStatus(this.state.ex_edit_integration_details?.auto_config_status || this.props.ex_integration_details?.auto_config_status || 'completed')}
                                                                            <button className="tw-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-text-xs tw-pl-2 tw-pr-3 tw-py-[5px] tw-text-[#414651] dark:tw-text-[#B2B5BE] tw-font-medium hover:tw-text-[#414651] dark:hover:tw-text-[#B2B5BE] dark:tw-text-[#B2B5BE] hover:tw-border-[#D5D7DA] dark:hover:tw-border-[#2B2B40] dark:tw-border-[#2B2B40] hover:tw-bg-[#F4F5F5] dark:hover:tw-bg-[#2B2B40]" disabled={true} onClick={this.editSchemaAndModeSelection}>
                                                                                <i className='tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-mr-1'><SquarePen size={12} color="#A4A7AE" /></i>
                                                                                Edit
                                                                            </button>
                                                                            {/* <button className="btn btn-sm btn-circle tw-border-[#ABEFC6] tw-bg-[#ECFDF3] tw-text-[#067647] tw-mr-3 !tw-px-2 hover:tw-text-[#067647] hover:!tw-shadow-none">Completed</button>
                                                                    <button className="btn btn-sm btn-outline btn-circle btn-grey !tw-px-2" onClick={this.editSchemaAndModeSelection}>Edit</button> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                            {this.state.selectedSchemas.length > 0 && this.state.testConnectionSuccess && this.state.configurationMode === 'manual' && this.state.showSchemaConfigInfo && this.state.manualNextClicked && (
                                                <>
                                                    <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">{/* Add this class for inactive state - vertical-stepper__heading--inactive */}
                                                        <span className="vs-heading__circle">5</span>
                                                        <div className="vs-heading__title-wrap">
                                                            <div className="vs-heading__title">Manual Configuration Details</div>
                                                            {/* <p className='m-0'>Configure datasets and partitions for your selected schemas</p> */}
                                                        </div>
                                                    </div>
                                                    <div className="vertical-stepper__content">
                                                        {this.state.integrationConfigurations.map((config, index) => (
                                                            <div key={config.id} className='tw-border-2 tw-border-solid tw-border-[#9BCBFF] tw-px-4 tw-rounded-xl tw-mb-4' style={this.state.integrationValidationErrors?.[config.id] ? { borderColor: '#FDA29B' } : undefined}>
                                                                <div className='tw-flex tw-items-center tw-justify-between tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                                    <div className='tw-flex tw-items-center tw-gap-2'>
                                                                        <h5 className='tw-font-medium tw-text-black dark:tw-text-[#B2B5BE] tw-m-0'>Integration configurations {index + 1}</h5>
                                                                        <div className='tw-p-[6px] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-bg-[#2F6BD6]/10'>
                                                                            <Pencil size={20} color="#A4A7AE" />
                                                                        </div>
                                                                    </div>
                                                                    <div className='tw-flex tw-items-center tw-gap-2'>
                                                                        <Form.Control
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="integration_name"
                                                                            value="Integration configurations 1"
                                                                        />
                                                                        <div className='tw-p-[6px] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-bg-[#2F6BD6]/10'>
                                                                            <Check size={20} color="#17B26A" />
                                                                        </div>
                                                                    </div>
                                                                    <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemoveIntegration(config.id)}>
                                                                        <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                                    </button>
                                                                </div>
                                                                <div className='tw-py-4'>
                                                                    <div class="row">
                                                                        <div className="col-md-6 !tw-border-0">
                                                                            <Form.Label>{this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "Select Bucket" : "Select Schema"}<span className='text-primary'>*</span></Form.Label>
                                                                            <Select
                                                                                id={`select_schema_${config.id}`}
                                                                                options={(() => {
                                                                                    const schemasWithAllDatasets = this.getSchemasWithAllDatasetsIntegration(config.id);
                                                                                    // Also exclude schemas claimed as All Datasets in other configs within this form
                                                                                    const usedInOtherConfigs = new Set(
                                                                                        this.state.integrationConfigurations
                                                                                            .filter(c => c.id !== config.id && c.datasetScope === 'allDatasets' && c.schema)
                                                                                            .map(c => c.schema)
                                                                                    );
                                                                                    const sourceSchemas = this.state.schemaModeSelection === 'allSchemas'
                                                                                        ? (this.state.testConnectionResponse?.schemas || [])
                                                                                        : this.state.selectedSchemas;
                                                                                    return sourceSchemas
                                                                                        .filter(s => !schemasWithAllDatasets.has(s) && !usedInOtherConfigs.has(s))
                                                                                        .map(schema => ({ label: schema, value: schema }));
                                                                                })()}
                                                                                placeholder="Select Schema"
                                                                                value={config.schema ? { label: config.schema, value: config.schema } : null}
                                                                                onChange={(selectedOption) => this.handleSchemaSelectForConfig(config.id, selectedOption)}
                                                                                classNamePrefix='select-control'
                                                                                components={{ Control: customSelectSchema }}
                                                                            />
                                                                            {this.state.integrationValidationErrors[config.id]?.schema && (
                                                                                <div className="error-text mt-1">{this.state.integrationValidationErrors[config.id].schema}</div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <hr className='tw-my-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]' />
                                                                    {this.state.formType !== 'azure_blob' && this.state.formType !== 's3' && this.state.formType !== 'azure_data_lake_gen2' && (
                                                                        <div class="row">
                                                                            <Form.Group className="col-md-6 !tw-border-0">
                                                                                <Form.Label>Dataset Scope</Form.Label>
                                                                                <div>
                                                                                    <div className="custom-control custom-radio custom-control-inline mt-1">
                                                                                        <input
                                                                                            type="radio"
                                                                                            id={`allDataset_${config.id}`}
                                                                                            name={`datasetGroup_${config.id}`}
                                                                                            value="allDatasets"
                                                                                            checked={config.datasetScope === "allDatasets"}
                                                                                            onChange={() => this.handleDatasetScopeChange(config.id, 'allDatasets')}
                                                                                            className="custom-control-input"
                                                                                        />
                                                                                        <Form.Label className="custom-control-label" htmlFor={`allDataset_${config.id}`}>
                                                                                            All Datasets
                                                                                        </Form.Label>
                                                                                    </div>

                                                                                    <div className="custom-control custom-radio custom-control-inline mt-1">
                                                                                        <input
                                                                                            type="radio"
                                                                                            id={`specifiedDataset_${config.id}`}
                                                                                            name={`datasetGroup_${config.id}`}
                                                                                            value="specifiedDatasets"
                                                                                            checked={config.datasetScope === "specifiedDatasets"}
                                                                                            onChange={() => this.handleDatasetScopeChange(config.id, 'specifiedDatasets')}
                                                                                            className="custom-control-input"
                                                                                        />
                                                                                        <Form.Label className="custom-control-label" htmlFor={`specifiedDataset_${config.id}`}>
                                                                                            Specified Datasets
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </div>

                                                                            </Form.Group>
                                                                        </div>
                                                                    )}
                                                                    <div className="tw-mb-4 tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                                                                        <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                                                            <div>
                                                                                <h5 className='tw-text-sm tw-font-medium tw-text-[#334DB7] dark:tw-text-[#A5B4FC] tw-m-0'>
                                                                                    Add Incremental Data Identification
                                                                                    {config.datasetScope === 'specifiedDatasets' && <span className='text-danger'> *</span>}
                                                                                    {config.datasetScope === 'allDatasets' && <span className='tw-text-[#6B7280]'> (Optional)</span>}
                                                                                </h5>
                                                                                <p className='tw-text-xs tw-text-[#546AC3] dark:tw-text-[#8A99D6] tw-m-0'>
                                                                                    {config.datasetScope === 'specifiedDatasets' ? 'Required for specified datasets' : 'Configure incremental loading (Optional)'}
                                                                                </p>
                                                                            </div>
                                                                            <button type="button" className="btn tw-mt-3 sm:tw-mt-0 tw-font-semibold tw-border-0 tw-bg-[#E6E9F6] tw-text-[#334DB7] tw-whitespace-nowrap hover:tw-bg-[#D2D7EF] hover:tw-text-[#334DB7] dark:tw-bg-[#1F2D5A] dark:tw-text-[#A5B4FC] hover:dark:tw-bg-[#2A3C75] hover:dark:tw-text-[#A5B4FC]" onClick={() => this.handleAddIncrementalData(config.id)}>
                                                                                <Plus size={18} color="currentColor" className='mr-1 tw-text-[#8A99D6] dark:tw-text-[#A5B4FC]' />Add Row
                                                                            </button>
                                                                        </div>
                                                                        <div className={`integration-collapse-content ${config.incrementalData.length > 0 ? "open" : ""}`}>
                                                                            {config.incrementalData.map((incrementalItem, incrementalIndex) => (
                                                                                <div key={incrementalItem.id} className="dataset-partition-card" style={this.state.integrationValidationErrors?.[config.id]?.datasets?.[incrementalItem.id] ? { border: '2px solid #FDA29B' } : undefined}>
                                                                                    <div className='dp-card__head'>
                                                                                        <span class="dp-card__label">Incremental Data {incrementalIndex + 1}</span>
                                                                                        <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemoveIncrementalData(config.id, incrementalItem.id)}>
                                                                                            <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                                                        </button>
                                                                                    </div>
                                                                                    <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                                                                                    <div class="dp-card__content">
                                                                                        <div class="form-row">
                                                                                            <div class="form-group col-md-6 col-lg-4">
                                                                                                <label>
                                                                                                    Dataset Name <span class="text-danger">*</span>
                                                                                                    <span class="tooltip">
                                                                                                        <i><img class="ml-1" width="16px" src="icon_info_circle" alt="" /></i>
                                                                                                    </span>
                                                                                                </label>
                                                                                                <div class="icon-input-group">
                                                                                                    <i>
                                                                                                        <Layers size={18} color="#A4A7AE" />
                                                                                                    </i>
                                                                                                    <Form.Control
                                                                                                        type="text"
                                                                                                        className={(!incrementalItem.datasetName || incrementalItem.datasetName.trim() === '') ? "form-control is-invalid" : (this.isDatasetAssignedToAnotherIntegration(config, incrementalItem) || this.state.integrationValidationErrors[config.id]?.datasets?.[incrementalItem.id]) ? "form-control is-invalid" : "form-control"}
                                                                                                        name="dataset_name"
                                                                                                        placeholder="Dataset Name"
                                                                                                        value={incrementalItem.datasetName}
                                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'datasetName', e.target.value)}
                                                                                                    />
                                                                                                </div>
                                                                                                {(!incrementalItem.datasetName || incrementalItem.datasetName.trim() === '') && (
                                                                                                    <div class="error-text">Dataset Name is required field</div>
                                                                                                )}
                                                                                                {incrementalItem.datasetName && incrementalItem.datasetName.trim() !== '' && this.isDatasetAssignedToAnotherIntegration(config, incrementalItem) && (
                                                                                                    <div class="error-text">Dataset Name "{incrementalItem.datasetName}" is already associated with another integration in this schema</div>
                                                                                                )}
                                                                                                {this.state.integrationValidationErrors[config.id]?.datasets?.[incrementalItem.id] && (
                                                                                                    <div class="error-text">{this.state.integrationValidationErrors[config.id].datasets[incrementalItem.id]}</div>
                                                                                                )}
                                                                                                <Form.Text className="text-muted">
                                                                                                    <Form.Check
                                                                                                        custom
                                                                                                        type="checkbox"
                                                                                                        label="Exact match only"
                                                                                                        id={`exact-match_${config.id}_${incrementalItem.id}`}
                                                                                                        checked={incrementalItem.exactMatch}
                                                                                                        onChange={(e) => this.handleExactMatchChange(config.id, incrementalItem.id, e.target.checked)}
                                                                                                    />
                                                                                                </Form.Text>
                                                                                            </div>
                                                                                            <div class="form-group col-md-6 col-lg-4">
                                                                                                <label>Incremental Data Identifier {config.datasetScope !== 'specifiedDatasets' && <span className="text-danger">*</span>}</label>
                                                                                                <div class="icon-input-group">
                                                                                                    <i>
                                                                                                        <HardDrive size={18} color="#A4A7AE" />
                                                                                                    </i>
                                                                                                    <Form.Control
                                                                                                        type="text"
                                                                                                        className={(config.datasetScope !== 'specifiedDatasets' && (!incrementalItem.identifier || incrementalItem.identifier.trim() === '')) ? "form-control is-invalid" : "form-control"}
                                                                                                        name="incremental_identifier"
                                                                                                        placeholder="Incremental data identifier"
                                                                                                        value={incrementalItem.identifier}
                                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'identifier', e.target.value)}
                                                                                                    />
                                                                                                </div>
                                                                                                {(config.datasetScope !== 'specifiedDatasets' && (!incrementalItem.identifier || incrementalItem.identifier.trim() === '')) && (
                                                                                                    <div className="error-text">Incremental Data Identifier is required field</div>
                                                                                                )}
                                                                                            </div>
                                                                                            <div class="form-group col-md-6 col-lg-4">
                                                                                                <div className="custom-control custom-checkbox mb-2">
                                                                                                    <Form.Control
                                                                                                        id={`start_index_check_box_${config.id}_${incrementalItem.id}`}
                                                                                                        type="checkbox"
                                                                                                        checked={incrementalItem.startingIndexCheckbox}
                                                                                                        className="custom-control-input"
                                                                                                        onChange={(e) => this.handleStartingIndexCheckbox(config.id, incrementalItem.id, e.target.checked)}
                                                                                                    />
                                                                                                    <Form.Label className="custom-control-label" htmlFor={`start_index_check_box_${config.id}_${incrementalItem.id}`}>
                                                                                                        Starting Index (Optional)
                                                                                                    </Form.Label>
                                                                                                </div>
                                                                                                <div>
                                                                                                    <div className="custom-control custom-radio">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            className="custom-control-input"
                                                                                                            id={`radio_by_value_${config.id}_${incrementalItem.id}`}
                                                                                                            name={`start_index_${config.id}_${incrementalItem.id}`}
                                                                                                            value="incremental data identifier"
                                                                                                            checked={incrementalItem.startingIndexType === 'incremental data identifier'}
                                                                                                            disabled={!incrementalItem.startingIndexCheckbox}
                                                                                                            onChange={() => this.handleStartingIndexTypeChange(config.id, incrementalItem.id, 'incremental data identifier')}
                                                                                                        />
                                                                                                        <label className="custom-control-label" htmlFor={`radio_by_value_${config.id}_${incrementalItem.id}`}>
                                                                                                            By Value
                                                                                                        </label>
                                                                                                    </div>
                                                                                                    <div className="custom-control custom-radio">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            className="custom-control-input"
                                                                                                            id={`radio_by_query_${config.id}_${incrementalItem.id}`}
                                                                                                            name={`start_index_${config.id}_${incrementalItem.id}`}
                                                                                                            value="custom query"
                                                                                                            checked={incrementalItem.startingIndexType === 'custom query'}
                                                                                                            disabled={!incrementalItem.startingIndexCheckbox}
                                                                                                            onChange={() => this.handleStartingIndexTypeChange(config.id, incrementalItem.id, 'custom query')}
                                                                                                        />
                                                                                                        <label className="custom-control-label" htmlFor={`radio_by_query_${config.id}_${incrementalItem.id}`}>
                                                                                                            By Query
                                                                                                        </label>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            {incrementalItem.startingIndexCheckbox && incrementalItem.startingIndexType === 'incremental data identifier' && (
                                                                                                <Form.Group className="col-md-6 col-lg-4">
                                                                                                    <Form.Label>Starting Index Value</Form.Label>
                                                                                                    <Form.Control
                                                                                                        type="text"
                                                                                                        className={(!incrementalItem.startingIndexValue || incrementalItem.startingIndexValue.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                                        name="start_index_value"
                                                                                                        placeholder="Starting Index Value"
                                                                                                        value={incrementalItem.startingIndexValue}
                                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'startingIndexValue', e.target.value)}
                                                                                                    />
                                                                                                    {(!incrementalItem.startingIndexValue || incrementalItem.startingIndexValue.trim() === '') && (
                                                                                                        <div class="error-text">Starting Index Value is required field</div>
                                                                                                    )}
                                                                                                </Form.Group>
                                                                                            )}
                                                                                            {incrementalItem.startingIndexCheckbox && incrementalItem.startingIndexType === 'custom query' && (
                                                                                                <Form.Group className="col-md-12 col-lg-8">
                                                                                                    <Form.Label>Starting Index Query</Form.Label>
                                                                                                    <Form.Control
                                                                                                        as="textarea"
                                                                                                        rows={2}
                                                                                                        name="start_index_query"
                                                                                                        className={(!incrementalItem.startingIndexQuery || incrementalItem.startingIndexQuery.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                                        placeholder="Starting Index Query"
                                                                                                        value={incrementalItem.startingIndexQuery}
                                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'startingIndexQuery', e.target.value)}
                                                                                                    />
                                                                                                    {(!incrementalItem.startingIndexQuery || incrementalItem.startingIndexQuery.trim() === '') && (
                                                                                                        <div class="error-text">Starting Index query is required field</div>
                                                                                                    )}
                                                                                                    <Form.Text className="text-muted"><strong className="mr-1">Note:</strong>This query will be used for Starting Index.</Form.Text>
                                                                                                </Form.Group>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                    <div className="tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                                                                        <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                                                            <div>
                                                                                <h5 className='tw-text-sm tw-font-medium tw-text-[#334DB7] dark:tw-text-[#A5B4FC] tw-m-0'>Add Partitions</h5>
                                                                                <p className='tw-text-xs tw-text-[#546AC3] dark:tw-text-[#8A99D6] tw-m-0'>Configure partioning dataset.</p>
                                                                            </div>
                                                                            <button type="button" className="btn tw-mt-3 sm:tw-mt-0 tw-font-semibold tw-border-0 tw-bg-[#E6E9F6] tw-text-[#334DB7] tw-whitespace-nowrap hover:tw-bg-[#D2D7EF] hover:tw-text-[#334DB7] dark:tw-bg-[#1F2D5A] dark:tw-text-[#A5B4FC] hover:dark:tw-bg-[#2A3C75] hover:dark:tw-text-[#A5B4FC]" onClick={() => this.handleAddPartitionToConfig(config.id)}>
                                                                                <Plus size={18} color="currentColor" className='mr-1 tw-text-[#8A99D6] dark:tw-text-[#A5B4FC]' />Add Row
                                                                            </button>
                                                                        </div>
                                                                        <div className={`integration-collapse-content ${config.partitions.length > 0 ? "open" : ""}`}>
                                                                            {config.partitions.map((partition, partitionIndex) => (
                                                                                <div key={partition.id} class="dataset-partition-card">
                                                                                    <div className='dp-card__head'>
                                                                                        <span class="dp-card__label">Partition {partitionIndex + 1}</span>
                                                                                        <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemovePartition(config.id, partition.id)}>
                                                                                            <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                                                        </button>
                                                                                    </div>
                                                                                    <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                                                                                    <div class="dp-card__content">
                                                                                        <div class="form-row">
                                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                                <Form.Label>{config.datasetScope === 'allDatasets' ? 'Dataset Name' : 'Select Dataset'}</Form.Label>
                                                                                                {config.datasetScope === 'allDatasets' ? (
                                                                                                    <Form.Control
                                                                                                        type="text"
                                                                                                        className={(!partition.datasetName || partition.datasetName.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                                        name="dataset_name"
                                                                                                        placeholder="Dataset Name"
                                                                                                        value={partition.datasetName || (this.state.testConnectionFormData && this.state.testConnectionFormData.datasource_name) || ''}
                                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'datasetName', e.target.value)}
                                                                                                    />
                                                                                                ) : null}
                                                                                                {config.datasetScope === 'specifiedDatasets' ? (
                                                                                                    <Select
                                                                                                        name="dataset_name"
                                                                                                        classNamePrefix={(!partition.datasetName || partition.datasetName.trim() === '') ? 'select-control is-invalid' : 'select-control'}
                                                                                                        options={
                                                                                                                this.getDatasetsForPartitionOptions(config, partition)
                                                                                                        }
                                                                                                        placeholder={
                                                                                                            (config.incrementalData || []).length === 0
                                                                                                                ? ""
                                                                                                                : "Dataset"
                                                                                                        }
                                                                                                        isDisabled={(config.incrementalData || []).length === 0}
                                                                                                        value={partition.datasetName ? { label: partition.datasetName, value: partition.datasetName } : null}
                                                                                                        onChange={(selectedOption) => this.handlePartitionFieldChange(config.id, partition.id, 'datasetName', selectedOption?.value || '')}
                                                                                                        components={{ Control: customSelectDataset }}
                                                                                                    />
                                                                                                ) : null}
                                                                                                {(!partition.datasetName || partition.datasetName.trim() === '') && (
                                                                                                    <div className="error-text">Dataset Name is required field</div>
                                                                                                )}
                                                                                            </Form.Group>
                                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                                <Form.Label>Partition Name</Form.Label>
                                                                                                <div class="icon-input-group">
                                                                                                    <i>
                                                                                                        <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                            <g clip-path="url(#clip0_26832_241553)">
                                                                                                                <path d="M1.33464 10.668C1.70249 10.669 1.9993 10.9681 1.9987 11.3359L6.66927 13.4596C6.68835 13.8731 6.80116 14.2621 6.98763 14.6055C7.02875 14.6812 7.07374 14.7545 7.12175 14.8255C7.23043 14.9864 7.35652 15.1343 7.49675 15.2676C7.38779 15.2391 7.28089 15.2023 7.17774 15.1556L7.17709 15.1549L1.44336 12.5482L1.43946 12.5469C1.20812 12.4398 1.01206 12.2683 0.875003 12.0534C0.737984 11.8384 0.66544 11.5883 0.666019 11.3333C0.66693 10.9651 0.966453 10.6671 1.33464 10.668Z" fill="#A4A7AE" />
                                                                                                                <path d="M1.33464 7.33464C1.70249 7.33571 1.9993 7.63478 1.9987 8.0026L7.66602 10.5794V11.2552C7.46838 11.4137 7.29376 11.5999 7.14779 11.8079L1.44336 9.21484L1.43946 9.21354C1.20812 9.10648 1.01206 8.93497 0.875003 8.72005C0.737984 8.50507 0.66544 8.25493 0.666019 8C0.66693 7.63181 0.966453 7.33373 1.33464 7.33464Z" fill="#A4A7AE" />
                                                                                                                <path d="M7.99935 0.667969C8.28574 0.667969 8.56887 0.729456 8.82943 0.848307L8.82878 0.848958L14.5553 3.45508C14.789 3.55966 14.9877 3.72879 15.1276 3.94336C15.2687 4.15983 15.3437 4.41286 15.3438 4.67122C15.3437 4.92969 15.2687 5.1832 15.1276 5.39974C14.9878 5.6142 14.7883 5.7828 14.5547 5.88737L14.5553 5.88867L12.6335 6.76172C12.3535 6.83762 12.0921 6.95782 11.8568 7.11458L10.8177 7.58659C10.5786 7.11122 10.1211 6.76654 9.57487 6.68685L14.0104 4.67122L14.0033 4.66862L8.2767 2.06185L8.27604 2.0612C8.18921 2.0216 8.09479 2.0013 7.99935 2.0013C7.90391 2.0013 7.80949 2.0216 7.72266 2.0612L7.72201 2.06185L2.00196 4.66471L7.72917 7.27474C7.81398 7.31342 7.90619 7.33368 7.99935 7.33464C7.7901 7.6132 7.66602 7.95941 7.66602 8.33464V8.63867C7.4973 8.60958 7.33235 8.55969 7.17578 8.48828L1.45638 5.88151C1.22317 5.77693 1.02447 5.6074 0.884769 5.39323C0.743577 5.17666 0.668655 4.92324 0.668623 4.66471C0.668654 4.40628 0.743669 4.15337 0.884769 3.93685C1.02453 3.72248 1.22295 3.55252 1.45638 3.44792L7.16927 0.848958C7.42983 0.730108 7.71297 0.66797 7.99935 0.667969Z" fill="#A4A7AE" />
                                                                                                                <path d="M13.9994 9.33464C13.9994 8.96645 13.7009 8.66797 13.3327 8.66797C12.9645 8.66797 12.666 8.96645 12.666 9.33464C12.666 9.70283 12.9645 10.0013 13.3327 10.0013C13.7009 10.0013 13.9994 9.70283 13.9994 9.33464ZM8.66602 13.3346C8.66602 13.7028 8.9645 14.0013 9.33269 14.0013C9.70088 14.0013 9.99936 13.7028 9.99936 13.3346C9.99936 12.9664 9.70088 12.668 9.33269 12.668C8.9645 12.668 8.66602 12.9664 8.66602 13.3346ZM14.666 9.33464C14.666 9.9609 14.2341 10.4858 13.652 10.6289C13.5832 11.4051 13.2451 12.1364 12.6898 12.6917C12.1344 13.2471 11.4031 13.5852 10.627 13.654C10.4838 14.2361 9.95895 14.668 9.33269 14.668C8.59631 14.668 7.99936 14.071 7.99936 13.3346C7.99936 12.7134 8.42428 12.1913 8.99936 12.0433V8.33464C8.99936 8.15054 9.14859 8.0013 9.33269 8.0013C9.51678 8.0013 9.66602 8.15054 9.66602 8.33464V12.0433C10.1292 12.1625 10.4947 12.5244 10.6195 12.9854C11.2212 12.9203 11.7864 12.6524 12.2184 12.2204C12.6505 11.7884 12.9183 11.2232 12.9834 10.6214C12.4165 10.4679 11.9994 9.95013 11.9994 9.33464C11.9994 8.59826 12.5963 8.0013 13.3327 8.0013C14.0691 8.0013 14.666 8.59826 14.666 9.33464Z" fill="#A4A7AE" />
                                                                                                            </g>
                                                                                                            <defs>
                                                                                                                <clipPath id="clip0_26832_241553">
                                                                                                                    <rect width="16" height="16" fill="white" />
                                                                                                                </clipPath>
                                                                                                            </defs>
                                                                                                        </svg>
                                                                                                    </i>
                                                                                                    <Form.Control
                                                                                                        type="text"
                                                                                                        className={(!partition.partitionName || partition.partitionName.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                                        name="partition_name"
                                                                                                        placeholder="Partition Name"
                                                                                                        value={partition.partitionName}
                                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'partitionName', e.target.value)}
                                                                                                    />
                                                                                                </div>
                                                                                                {(!partition.partitionName || partition.partitionName.trim() === '') && (
                                                                                                    <div className="error-text">Partition Name is required field</div>
                                                                                                )}
                                                                                            </Form.Group>
                                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                                <Form.Label className='d-block'>Partition By</Form.Label>
                                                                                                <div className="custom-control custom-radio custom-control-inline mt-1">
                                                                                                    <Form.Control
                                                                                                        type="radio"
                                                                                                        className="custom-control-input"
                                                                                                        id={`partitionByColumn_${config.id}_${partition.id}`}
                                                                                                        name={`partitionBy_${config.id}_${partition.id}`}
                                                                                                        value="Column"
                                                                                                        checked={partition.partitionBy === 'Column' || partition.partitionBy === undefined}
                                                                                                        onChange={() => this.handlePartitionByChange(config.id, partition.id, 'Column')}
                                                                                                    />
                                                                                                    <Form.Label className="custom-control-label" htmlFor={`partitionByColumn_${config.id}_${partition.id}`}>
                                                                                                        Column
                                                                                                    </Form.Label>
                                                                                                </div>
                                                                                                <div className="custom-control custom-radio custom-control-inline mt-1">
                                                                                                    <Form.Control
                                                                                                        type="radio"
                                                                                                        className="custom-control-input"
                                                                                                        id={`partitionByCustom_${config.id}_${partition.id}`}
                                                                                                        name={`partitionBy_${config.id}_${partition.id}`}
                                                                                                        value="Custom Query"
                                                                                                        checked={partition.partitionBy === 'Custom Query'}
                                                                                                        onChange={() => this.handlePartitionByChange(config.id, partition.id, 'Custom Query')}
                                                                                                    />
                                                                                                    <Form.Label className="custom-control-label" htmlFor={`partitionByCustom_${config.id}_${partition.id}`}>
                                                                                                        Custom Query
                                                                                                    </Form.Label>
                                                                                                </div>
                                                                                            </Form.Group>
                                                                                            {(partition.partitionBy === 'Column' || partition.partitionBy === undefined) && (
                                                                                                <Form.Group className="col-md-6 col-lg-4">
                                                                                                    <Form.Label>Partition Identifier</Form.Label>
                                                                                                    <div class="icon-input-group">
                                                                                                        <i>
                                                                                                            <TextSearch size={18} color="#A4A7AE" />
                                                                                                        </i>
                                                                                                        <Form.Control
                                                                                                            type="text"
                                                                                                            className={(!partition.partitionIdentifier || partition.partitionIdentifier.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                                            name="partition_identifier"
                                                                                                            placeholder="Partition Identifier"
                                                                                                            value={partition.partitionIdentifier}
                                                                                                            onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'partitionIdentifier', e.target.value)}
                                                                                                        />
                                                                                                    </div>
                                                                                                    {(!partition.partitionIdentifier || partition.partitionIdentifier.trim() === '') && (
                                                                                                        <div className="error-text">Partition Identifier is required field</div>
                                                                                                    )}
                                                                                                </Form.Group>
                                                                                            )}
                                                                                            {partition.partitionBy === 'Custom Query' && (
                                                                                                <Form.Group className="col-md-12 col-lg-8">
                                                                                                    <Form.Label>Custom Query</Form.Label>
                                                                                                    <Form.Control
                                                                                                        as="textarea"
                                                                                                        rows={2}
                                                                                                        name="custom_query"
                                                                                                        className={(!partition.customQuery || partition.customQuery.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                                        placeholder="Enter your custom query here..."
                                                                                                        value={partition.customQuery}
                                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'customQuery', e.target.value)}
                                                                                                    />
                                                                                                    {(!partition.customQuery || partition.customQuery.trim() === '') && (
                                                                                                        <div className="error-text">Custom Query is required field</div>
                                                                                                    )}
                                                                                                    <Form.Text className="text-muted"><strong className="mr-1">Note:</strong>This query will be used to partition and monitor the Dataset.</Form.Text>
                                                                                                </Form.Group>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                        <button type="button" className="btn tw-font-semibold tw-border tw-border-solid tw-border-[#B0BAE3] tw-bg-transparent tw-text-[#334DB7] tw-mb-4 hover:tw-bg-[#E6E9F6] hover:tw-text-[#334DB7] dark:tw-border-[#2B2B40] dark:tw-text-[#A5B4FC] hover:dark:tw-bg-[#1F2D5A] hover:dark:tw-text-[#A5B4FC]" onClick={this.handleAddIntegration}>
                                                            <Plus size={18} color="currentColor" className='mr-1' />Add Integrations
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                            <div className="vertical-stepper__heading !tw-pt-4 sm:!tw-pt-8">
                                                <div className={"d-flex align-items-center tw-pl-1"}>
                                                    <Form.Check
                                                        custom
                                                        type={'checkbox'}
                                                        id={`storeData`}
                                                        className="tw-mr-2 md:tw-mr-4"
                                                        checked={true}
                                                        readOnly
                                                        aria-readonly="true"
                                                    />
                                                    <div>
                                                        <h5 className="tw-mb-1 tw-font-[400] tw-text-black dark:tw-text-[#B2B5BE]">Store Data Issues and Errors</h5>
                                                        <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">Log and store processing errors for debugging and monitoring</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-right border-top tw-py-3 tw-pe-4 sm:tw-pe-6 mt-auto">
                                        <button
                                            className="btn btn-outline btn-grey tw-mr-3"
                                            onClick={() => this.props.setPage(false)}
                                            disabled={this.state.isCreatingDatasource}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={this.handleCreateDatasource}
                                            disabled={!this.isCreateDatasourceEnabled()}
                                        >
                                            {this.state.isCreatingDatasource ? (
                                                <div className="tw-flex tw-items-center tw-justify-center">
                                                    <div className="tw-w-[14px] tw-h-[14px] tw-border tw-border-solid tw-rounded-full tw-border-white tw-border-t-transparent tw-animate-spin"></div>
                                                    <span className='tw-ml-2'>Creating...</span>
                                                </div>
                                            ) : (
                                                <>
                                                    <Check size={18} color="currentColor" className='mr-1' />Create Datasource
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="portlet-body tw-h-full">
                                    <div id="add-datasource_help" class="qd-helpGuide tw-h-full">
                                        <div class="qd-helpGuide__content">
                                            <h4 class="qd-helpGuide__title">Steps to enable access from your storage to Qualdo™: </h4>
                                            <ol class="qd-helpGuide__info">
                                                {this.renderHelpContent()}
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderTest()}
                <Modal show={this.state.showSchemeModal} size="md" centered onHide={this.handleCloseSchemeModal}>
                    <Modal.Header closeButton>
                        <div className='tw-flex tw-items-center tw-gap-4'>
                            <div className='tw-flex tw-items-center tw-justify-center tw-p-[10px] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/20 tw-bg-white dark:tw-bg-white/10 tw-rounded-[10px]'>
                                <FolderTree size={20} color="currentColor" className="tw-text-[#414651] dark:tw-text-white" />
                            </div>
                            <div>
                                <h5 className="modal-title !tw-mb-[2px] tw-font-semibold !tw-text-gray-900 dark:!tw-text-white">Available Schemas</h5>
                                <div className='tw-flex tw-items-center tw-gap-2 tw-gap-2'>
                                    <div className='tw-px-2 tw-py-[2px] tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-medium tw-text-[#175CD3] dark:!tw-text-white tw-border tw-border-solid tw-border-[#B2DDFF] dark:!tw-border-white/30 dark:!tw-bg-white/10 tw-rounded-[6px] tw-uppercase' onClick={this.handleRefreshSchemas}>
                                        <i className='tw-mr-1'>
                                            <svg className='tw-block' width="14" height="14" viewBox="0 0 147 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_1563_1485)">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M134.806 60.0962L118.336 69.5862L134.806 78.9962C135.791 79.5655 136.654 80.3232 137.346 81.226C138.038 82.1289 138.546 83.1592 138.84 84.2582C139.134 85.3572 139.208 86.5033 139.059 87.6311C138.91 88.7589 138.541 89.8463 137.971 90.8312C137.402 91.8161 136.644 92.6793 135.741 93.3713C134.839 94.0634 133.808 94.5709 132.709 94.8648C131.61 95.1587 130.464 95.2333 129.336 95.0842C128.209 94.9352 127.121 94.5655 126.136 93.9962L96.6262 76.9962C95.2737 76.2137 94.1576 75.0807 93.3955 73.7166C92.6334 72.3526 92.2536 70.8081 92.2962 69.2462C92.3193 68.5695 92.4234 67.8981 92.6062 67.2462C93.2103 65.06 94.646 63.1972 96.6062 62.0562L126.116 45.1162C127.105 44.5445 128.198 44.1736 129.33 44.0245C130.463 43.8755 131.614 43.9513 132.718 44.2476C133.821 44.5439 134.855 45.0548 135.761 45.7513C136.667 46.4477 137.426 47.3159 137.996 48.3062C138.568 49.2879 138.94 50.3734 139.089 51.4999C139.239 52.6263 139.163 53.7712 138.866 54.868C138.569 55.9649 138.057 56.9919 137.361 57.8894C136.664 58.7869 135.795 59.537 134.806 60.0962ZM119.216 106.096L89.7162 89.1262C88.3964 88.3687 86.9013 87.9699 85.3796 87.9692C83.8579 87.9686 82.3625 88.3661 81.042 89.1224C79.7215 89.8787 78.6219 90.9674 77.8525 92.2803C77.0831 93.5932 76.6707 95.0845 76.6562 96.6062V130.506C76.7327 132.759 77.6812 134.893 79.3016 136.46C80.922 138.026 83.0875 138.901 85.3412 138.901C87.5949 138.901 89.7605 138.026 91.3809 136.46C93.0013 134.893 93.9498 132.759 94.0262 130.506V111.506L110.536 120.996C111.521 121.566 112.609 121.936 113.737 122.086C114.865 122.236 116.011 122.162 117.111 121.868C118.21 121.575 119.241 121.068 120.144 120.376C121.048 119.684 121.806 118.821 122.376 117.836C122.946 116.851 123.317 115.764 123.466 114.636C123.616 113.508 123.542 112.361 123.248 111.262C122.955 110.162 122.448 109.131 121.756 108.228C121.064 107.324 120.201 106.566 119.216 105.996V106.096ZM85.2162 72.9362L72.9162 85.0862C72.4954 85.4774 71.9501 85.7076 71.3762 85.7362H67.7662C67.1937 85.7018 66.6502 85.4724 66.2262 85.0862L53.9962 72.8962C53.6136 72.4787 53.3875 71.9416 53.3562 71.3762V67.7762C53.3892 67.2082 53.615 66.6685 53.9962 66.2462L66.2262 54.0562C66.6512 53.6729 67.1948 53.447 67.7662 53.4162H71.3762C71.9486 53.4429 72.4935 53.6693 72.9162 54.0562L85.1762 66.2462C85.5545 66.6695 85.7767 67.2093 85.8062 67.7762V71.3762C85.7785 71.9405 85.5559 72.4778 85.1762 72.8962L85.2162 72.9362ZM75.4162 69.5562C75.369 68.9732 75.1258 68.4234 74.7262 67.9962L71.1762 64.4862C70.7508 64.1036 70.2075 63.8778 69.6362 63.8462H69.5062C68.9375 63.876 68.3968 64.1022 67.9762 64.4862L64.4262 67.9962C64.0451 68.4256 63.8228 68.9727 63.7962 69.5462V69.6762C63.8214 70.2411 64.0444 70.7791 64.4262 71.1962L67.9962 74.6962C68.4177 75.0788 68.9579 75.3048 69.5262 75.3362H69.6562C70.2275 75.3046 70.7708 75.0788 71.1962 74.6962L74.7462 71.1662C75.1297 70.7483 75.359 70.2121 75.3962 69.6462L75.4162 69.5562ZM19.9262 33.0762L49.4362 49.9962C50.7575 50.7533 52.2539 51.1517 53.7768 51.1516C55.2996 51.1516C56.796 50.7532 58.1173 49.9961C59.4386 49.2389 60.5388 48.1492 61.3087 46.8353C62.0786 45.5214 62.4915 44.029 62.5062 42.5062V8.63619C62.4298 6.38379 61.4813 4.24919 59.8609 2.68284C58.2405 1.1165 56.0749 0.240938 53.8212 0.240938C51.5675 0.240938 49.402 1.1165 47.7816 2.68284C46.1612 4.24919 45.2127 6.38379 45.1362 8.63619V27.6362L28.6062 18.1362C27.6213 17.5663 26.5338 17.1959 25.4057 17.0462C24.2777 16.8966 23.1312 16.9706 22.0318 17.264C20.9323 17.5575 19.9014 18.0646 18.998 18.7564C18.0945 19.4483 17.3361 20.3113 16.7662 21.2962C16.1963 22.2811 15.8259 23.3686 15.6763 24.4967C15.5266 25.6247 15.6006 26.7712 15.8941 27.8706C16.1875 28.9701 16.6946 30.001 17.3864 30.9044C18.0783 31.8079 18.9413 32.5663 19.9262 33.1362V33.0762ZM84.6862 51.1562C86.4288 51.294 88.1722 50.9 89.6862 50.0262L119.186 33.0262C120.171 32.4563 121.034 31.6979 121.726 30.7944C122.418 29.891 122.925 28.8601 123.218 27.7606C123.512 26.6612 123.586 25.5147 123.436 24.3867C123.287 23.2586 122.916 22.1711 122.346 21.1862C121.776 20.2013 121.018 19.3383 120.114 18.6464C119.211 17.9546 118.18 17.4475 117.081 17.154C114.86 16.5614 112.495 16.8752 110.506 18.0262L93.9962 27.6062V8.60619C93.9198 6.35379 92.9713 4.21919 91.3509 2.65284C89.7305 1.0865 87.5649 0.210938 85.3112 0.210938C83.0575 0.210938 80.892 1.0865 79.2716 2.65284C77.6512 4.21919 76.7026 6.35379 76.6262 8.60619V42.5062C76.6235 44.701 77.4542 46.8149 78.9504 48.4207C80.4466 50.0264 82.4967 51.0041 84.6862 51.1562ZM54.4762 87.9962C52.7333 87.8546 50.9888 88.2488 49.4762 89.1262L19.9262 106.056C17.9371 107.207 16.4867 109.101 15.8941 111.322C15.3015 113.542 15.6152 115.907 16.7662 117.896C17.9173 119.885 19.8113 121.336 22.0318 121.928C24.2522 122.521 26.6171 122.207 28.6062 121.056L45.1362 111.566V130.566C45.2127 132.819 46.1612 134.953 47.7816 136.52C49.402 138.086 51.5675 138.961 53.8212 138.961C56.0749 138.961 58.2405 138.086 59.8609 136.52C61.4813 134.953 62.4298 132.819 62.5062 130.566V96.6062C62.5017 94.4225 61.6715 92.3212 60.1821 90.7243C58.6926 89.1273 56.6543 88.1527 54.4762 87.9962ZM46.4762 72.1262C47.0459 70.2529 46.96 68.2415 46.2328 66.4235C45.5057 64.6056 44.1806 63.0898 42.4762 62.1262L12.9962 45.1362C11.0053 43.9958 8.64409 43.6891 6.42786 44.283C4.21163 44.8768 2.32019 46.3231 1.16621 48.3062C0.594906 49.2876 0.223871 50.3726 0.0745668 51.4983C-0.074737 52.6241 0.000654668 53.7682 0.296381 54.8647C0.592107 55.9611 1.1023 56.988 1.79744 57.886C2.49258 58.7839 3.35887 59.5352 4.34621 60.0962L20.8162 69.5862L4.34621 78.9962C3.3613 79.5642 2.4979 80.3206 1.80531 81.2222C1.11272 82.1238 0.604499 83.1531 0.309673 84.2511C0.0148467 85.3492 -0.0608148 86.4946 0.0870081 87.6218C0.234831 88.7491 0.603243 89.8363 1.17121 90.8212C1.73918 91.8061 2.49558 92.6695 3.39722 93.3621C4.29886 94.0547 5.32809 94.5629 6.42615 94.8577C7.5242 95.1526 8.66957 95.2282 9.79686 95.0804C10.9242 94.9326 12.0113 94.5642 12.9962 93.9962L42.4762 76.9962C44.3746 75.9363 45.8005 74.196 46.4662 72.1262H46.4762ZM139.626 15.9062H138.296V17.5362H139.616C140.226 17.5362 140.616 17.2562 140.616 16.7362C140.616 16.2162 140.256 15.9062 139.616 15.9062H139.626ZM136.686 14.4062H139.686C141.306 14.4062 142.386 15.2962 142.386 16.6762C142.391 17.0603 142.294 17.4389 142.104 17.7729C141.914 18.1068 141.639 18.3841 141.306 18.5762L142.476 20.2562V20.5962H140.786L139.616 18.9962H138.296V20.5962H136.676L136.686 14.4062ZM144.986 17.6262C145.035 16.8692 144.926 16.1103 144.666 15.3976C144.406 14.6849 144.001 14.034 143.476 13.4859C142.952 12.9379 142.319 12.5047 141.619 12.2139C140.918 11.923 140.165 11.7808 139.406 11.7962C136.096 11.7962 133.896 14.1862 133.896 17.6262C133.896 20.9062 136.096 23.4462 139.406 23.4462C140.165 23.4644 140.919 23.3245 141.621 23.0354C142.323 22.7463 142.957 22.3143 143.483 21.7669C144.008 21.2195 144.414 20.5687 144.675 19.8558C144.936 19.1429 145.045 18.3836 144.996 17.6262H144.986ZM146.366 17.6262C146.366 21.5162 143.766 24.7662 139.366 24.7662C134.966 24.7662 132.476 21.4862 132.476 17.6262C132.476 13.7662 135.046 10.4862 139.366 10.4862C143.686 10.4862 146.356 13.7262 146.356 17.6262H146.366Z" fill="#29B5E8"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1563_1485">
                                                        <rect width="146.36" height="139.16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </i>
                                        Snowflake
                                    </div>
                                    <strong className='tw-text-sm tw-text-[#535862] dark:!tw-text-white !tw-font-medium tw-ms-1'>{this.state.testConnectionFormData?.database || 'N/A'}</strong>
                                </div>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.schemeModalLoading ? (
                            <div className='tw-py-[60px] tw-text-center'>
                                <i className='tw-p-4 tw-rounded-full tw-bg-[linear-gradient(180deg,#FAFAFA,#E9EAEB)] tw-inline-flex tw-items-center tw-justify-center tw-mb-4'>
                                    <div className="tw-w-[32px] tw-h-[32px] tw-border-4 tw-border-solid tw-rounded-full tw-border-[#D1E9FF] tw-border-t-[#0021A5] tw-animate-spin"></div>
                                </i>
                                <div>
                                    <h5 className='tw-text-base tw-font-medium tw-text-[#181D27] dark:tw-text-[#B2B5BE] tw-mt-0 tw-mb-1'>Fetching Schemas</h5>
                                    <p className='tw-text-sm tw-text-[#535862] dark:tw-text-[#787B86] tw-my-0'>Connecting to Snowflake...</p>
                                </div>
                            </div>
                        ) : (
                            <><div className='tw-rounded-lg tw-border tw-border-solid tw-border-[#ABEFC6] tw-bg-[#F6FEF9] tw-py-2 tw-px-3 tw-mb-3'>
                                <div className="d-flex align-items-center tw-gap-[10px]">
                                    <i><CircleCheck size={18} color="#17B26A" /></i>
                                    <div>
                                        <span className="tw-block tw-text-sm tw-text-[#067647] tw-font-medium">
                                            Successfully fetched{" "}
                                            {this.state.testConnectionResponse?.schemas?.length || 0} schemas
                                        </span>

                                        <span className='tw-block tw-text-xs tw-text-[#079455]'>Select the schemas you want to work with. You can select multiple schemas.</span>
                                    </div>
                                </div>
                            </div>

                                <div className='tw-p-3 tw-rounded-xl tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FAFAFA] dark:tw-bg-[#161622]'>
                                    <div className='d-flex align-items-center justify-content-between tw-mb-3'>
                                        <div className="qd-search-bar has-btn-close tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-rounded-lg tw-flex-1 tw-me-3">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <button id="button-addon4" type="button" className="btn">
                                                        <svg className='d-block' width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z" stroke="#A4A7AE" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <input
                                                    type="search"
                                                    placeholder="Search"
                                                    className="form-control h-100"
                                                    value={this.state.schemaSearchText}
                                                    onChange={(e) => this.setState({ schemaSearchText: e.target.value })}
                                                />
                                            </div>
                                            {/* {this.state.saveWatchListSearchText && <button className="btn btn-clear" title="clear" onClick={() => this.setState({ saveWatchListSearchText: '' })}><i className="icon-close"></i></button>} */}
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline btn-grey !tw-px-2 !tw-py-1 !tw-rounded-lg tw-whitespace-nowrap hover:!tw-shadow-none"
                                            onClick={this.handleSelectAllSchemas}
                                        >
                                            {this.state.selectedSchemas.length === (this.state.testConnectionResponse?.schemas || []).length && this.state.testConnectionResponse?.schemas?.length > 0
                                                ? 'Deselect All'
                                                : 'Select All'}
                                        </button>
                                    </div>
                                    <div className='tw-rounded-lg tw-border tw-border-solid tw-border-black/10 tw-bg-white dark:tw-bg-[#1E1E2D] tw-p-2'>
                                        {(() => {
                                            const filteredSchemas = this.state.testConnectionResponse?.schemas?.filter(schema =>
                                                schema.toLowerCase().includes(this.state.schemaSearchText.toLowerCase())
                                            ) || [];

                                            return filteredSchemas.length > 0 ? (
                                                filteredSchemas.map((schema, index) => (
                                                    <div className='tw-mb-[2px]' key={index}>
                                                        <div className='custom-control custom-checkbox custom-control-inline d-flex tw-px-2 tw-py-1 tw-m-0 tw-cursor-pointer tw-rounded-lg hover:tw-bg-[#F5F5F5] dark:hover:tw-bg-[#2B2B40]'>
                                                            <label className="d-flex align-items-center tw-mr-8 tw-mb-0 tw-font-medium">
                                                                <input
                                                                    type="checkbox"
                                                                    name="schema"
                                                                    className="mr-2"
                                                                    checked={this.state.selectedSchemas.includes(schema)}
                                                                    onChange={() => this.handleSchemaSelect(schema)}
                                                                />
                                                                <span className='d-flex align-items-center'>
                                                                    <i><FolderTree size={16} color="#A4A7AE" className='tw-me-2' /></i>
                                                                    {schema}
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className='tw-text-center tw-py-3 tw-text-[#535862] dark:tw-text-[#787B86]'>
                                                    No Schemas Found
                                                </div>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer className='justify-content-between tw-p-5'>
                        <div>
                            <p className={`tw-text-sm tw-m-0 ${this.state.selectedSchemas.length > 0 ? 'tw-text-[#079455]' : 'tw-text-[#535862] dark:tw-text-[#787B86]'}`}>
                                {this.state.selectedSchemas.length > 0
                                    ? `${this.state.selectedSchemas.length} schema${this.state.selectedSchemas.length > 1 ? 's' : ''} selected`
                                    : 'Please select at least one schema'}
                            </p>
                        </div>
                        <div className='m-0'>
                            <button type="button" className="btn btn-outline btn-grey tw-me-2" onClick={this.handleCloseSchemeModal}>Cancel</button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={this.handleCloseSchemeModal}
                                disabled={this.state.selectedSchemas.length === 0}
                            >
                                <i><Check size={20} color="currentColor" className='mr-1' /></i> Confirm Selection ({this.state.selectedSchemas.length})
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
    getEditIntegrationContent(data_source_option) {
        // console.log("geteditintegration is called")
        const { schemaModeSelection, selectedSchemas, configurationMode, integrationConfigurations } = this.state;
        // console.log('Edit integration render debug:', {
        //     configurationMode,
        //     integrationConfigurationsLength: integrationConfigurations.length,
        //     integrationConfigurations,
        //     schemaModeSelection,
        //     selectedSchemas,
        //     showSchemaConfigInfo: this.state.showSchemaConfigInfo,
        //     showTestConnectionInfo: this.state.showTestConnectionInfo,
        //     manualNextClicked: this.state.manualNextClicked
        // });
        return (
            <>
                <div className="portlet portlet-2col" id="edit_ds_model">
                    <div className="portlet-body d-none">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="portlet-body" id="add-datasource">
                                    <div className="form-row">
                                        <div className="form-group col-md-6 hello">
                                            <label>Choose a Datasource type </label>
                                            <Select
                                                id="choose_datasource_type_add"
                                                filterOption={({ label }, query) => label.toLowerCase().includes(query.toLowerCase())}
                                                onChange={this.setForm}
                                                defaultValue={this.state.formType_option}
                                                options={data_source_option}
                                                placeholder="Choose Data Source"
                                                classNamePrefix='select-control'
                                                formatGroupLabel={formatGroupLabel}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='portlet-body'>
                        <div className="row">
                            <div class="col-md-12">
                                <div className="d-flex flex-column h-100">
                                    <div class="qd-configure-integration-steps">
                                        <div className="vertical-stepper vertical-stepper-sm w-100 border-0">
                                            <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">
                                                <span className="vs-heading__circle">1</span>
                                                <div className="vs-heading__title">Datasource Details</div>
                                            </div>
                                            <div className="vertical-stepper__content">
                                                {!this.state.showTestConnectionInfo && (
                                                    <div >
                                                        {/* className={this.state.testConnectionSuccess === null ? "" : "d-none"} */}
                                                        <div class="form-row">
                                                            <div class="form-group col-lg-6">
                                                                <label>Choose a Datasource type <span className='text-primary'>*</span></label>
                                                                <Select
                                                                    id="choose_datasource_type_add"
                                                                    filterOption={({ label }, query) => label.toLowerCase().includes(query.toLowerCase())}
                                                                    onChange={this.setForm}
                                                                    defaultValue={this.state.formType_option}
                                                                    options={data_source_option}
                                                                    placeholder="Choose Data Source"
                                                                    classNamePrefix='select-control'
                                                                    formatGroupLabel={formatGroupLabel}
                                                                    components={{ Control: customSelectDatasource }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <DynamicDatasourceForm
                                                            key={this.state.formResetKey}
                                                            config={datasourceConfig}
                                                            selectedDatasource={this.state.formType}
                                                            onSubmit={this.handleFormSubmit}
                                                            onTestConnection={this.handleTestConnection}
                                                            isTestingConnection={this.state.isTestingConnection}
                                                            testConnectionSuccess={this.state.testConnectionSuccess}
                                                            testConnectionResponse={this.state.testConnectionResponse}
                                                            onContinueSchemaSelection={this.handleContinueSchemaSelection}
                                                            initialFormData={this.state.testConnectionFormData}
                                                            existingIntegrations={this.props.existingIntegrations || []}
                                                            currentIntegrationName={this.state.testConnectionFormData?.integration_name}
                                                            ip_address={this.state.ip_address}
                                                            isEditMode={true}
                                                        />
                                                    </div>
                                                )}

                                                {this.state.showTestConnectionInfo && this.state.testConnectionSuccess !== null && this.state.testConnectionFormData && (
                                                    <div className="qd-configure-integration-info">
                                                        <div className="qd-configure-integration-info__content" id="test_connection_info">
                                                            <div className="qd-configure-integration-info__list">
                                                                <div className="qd-configure-integration-info__item">
                                                                    <label className='qd-configure-integration-info__label'>Type</label>
                                                                    <span className="qd-configure-integration-info__value">
                                                                        <i>
                                                                            <Database size={16} color="#A4A7AE" />
                                                                        </i>
                                                                        <span>{this.getDatasourceLabel(this.state.formType)}</span>
                                                                    </span>
                                                                </div>
                                                                {this.state.testConnectionFormData.datasource_name && (
                                                                    <div className="qd-configure-integration-info__item">
                                                                        <label className='qd-configure-integration-info__label'>Datasource Name</label>
                                                                        <span className="qd-configure-integration-info__value">
                                                                            <i>
                                                                                <Database size={16} color="#A4A7AE" />
                                                                            </i>
                                                                            <RcTooltip
                                                                                placement="top"
                                                                                overlay={<span>{this.state.testConnectionFormData.datasource_name}</span>}
                                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                            >
                                                                                <span>{this.state.testConnectionFormData.datasource_name}</span>
                                                                            </RcTooltip>
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            {/* Dynamically render fields from datasourceConfig.json */}
                                                            {this.renderIntegrationInfoFields()}
                                                            {/* Render Auth Method and Credential fields together */}
                                                            {this.renderCredentialFields()}
                                                            <hr className='tw-block tw-my-3' />
                                                            <div className="qd-configure-integration-info__action">
                                                                {/* Show error message if connection failed */}
                                                                {this.state.testConnectionError ? (
                                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                                        <button className="btn btn-sm btn-circle tw-border-[#FCA5A5] tw-bg-[#FEF2F2] tw-text-[#DC2626] tw-mr-3 !tw-px-2 hover:tw-text-[#DC2626] hover:!tw-shadow-none">
                                                                            {this.state.testConnectionError}
                                                                        </button>
                                                                        <button className="btn btn-sm btn-outline btn-circle btn-grey !tw-px-2" onClick={this.editDatasourceDetails}>Edit</button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="tw-flex tw-items-center tw-justify-end tw-gap-3">
                                                                        {getDatasourceStatus(this.state.ex_edit_integration_details?.auto_config_status || this.props.ex_integration_details?.auto_config_status || 'completed')}
                                                                        {/* <button className="tw-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-text-xs tw-pl-2 tw-pr-3 tw-py-[5px] tw-text-[#414651] dark:tw-text-[#B2B5BE] tw-font-medium hover:tw-text-[#414651] dark:hover:tw-text-[#B2B5BE] dark:tw-text-[#B2B5BE] hover:tw-border-[#D5D7DA] dark:hover:tw-border-[#2B2B40] dark:tw-border-[#2B2B40] hover:tw-bg-[#F4F5F5] dark:hover:tw-bg-[#2B2B40]" disabled={true}>
                                                                            <i className='tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-mr-1'><SquarePen size={12} color="#A4A7AE" /></i>
                                                                            Edit
                                                                        </button> */}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {this.state.showSchemaConfigInfo && (
                                                <>
                                                    <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">{/* Add this class for inactive state - vertical-stepper__heading--inactive */}
                                                        <span className="vs-heading__circle">2</span>
                                                        <div className="vs-heading__title-wrap">
                                                        <div className="vs-heading__title">{this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "Bucket & Mode Selection" : "Schema & Mode Selection"}</div>
                                                            {/* <p className='m-0'>Choose your schema scope and configuration mode</p> */}
                                                        </div>
                                                    </div>
                                                    <div className="vertical-stepper__content">
                                                        <div className="qd-configure-integration-info">
                                                            <div className="qd-configure-integration-info__content">
                                                                <div className="qd-configure-integration-info__list !tw-grid-cols-1">
                                                                    <div className="qd-configure-integration-info__item">
                                                                        <label className='qd-configure-integration-info__label'>
                                                                        {`${this.state.schemaModeSelection === "allSchemas" ? "All" : "Specified"} ${this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "Buckets" : "Schemas"}`}                                                                        </label>
                                                                        <span className="qd-configure-integration-info__value">
                                                                            {schemaModeSelection === 'allSchemas' ? (
                                                                                <span className='tw-text-[#535862]'>{`Process ${this.state.schemaModeSelection === "allSchemas" ? "all available" : "specified"} ${this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "buckets" : "schemas"} automatically`}</span>
                                                                            ) : (
                                                                                <>
                                                                                    {selectedSchemas.length > 0 ? (
                                                                                        selectedSchemas.map((schema, index) => (
                                                                                            <span key={index} className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#C7D7FE] dark:tw-border-[#2B2B40] tw-bg-[#EEF4FF] dark:tw-bg-[#161622] tw-text-[#3538CD] dark:tw-text-[#53B1FD] tw-text-xs tw-font-medium tw-flex tw-items-center tw-me-2'>
                                                                                                <i className="tw-me-[2px]">
                                                                                                    <FolderTree className="d-block tw-text-[#175CD3] dark:tw-text-[#53B1FD]" size={12} color="currentColor" />
                                                                                                </i>
                                                                                                {schema}
                                                                                            </span>
                                                                                        ))
                                                                                    ) : (
                                                                                        <span className='tw-text-[#535862]'>No schemas selected</span>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <hr className='tw-block tw-my-3' />
                                                                <div className="qd-configure-integration-info__list">
                                                                    <div className="qd-configure-integration-info__item">
                                                                        <label className='qd-configure-integration-info__label'>Configuration Mode</label>
                                                                        <span className="qd-configure-integration-info__value">
                                                                            <Form.Check
                                                                                custom
                                                                                type={'radio'}
                                                                                id={`configMode_${configurationMode}`}
                                                                                label={configurationMode === 'autoconfig' ? 'Autoconfig' : 'Manual Config'}
                                                                                checked={true}
                                                                                className="mr-4"
                                                                                disabled
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            {configurationMode === 'manual' && this.state.manualNextClicked && (
                                                <>
                                                    <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">
                                                        <span className="vs-heading__circle">3</span>
                                                        <div className="vs-heading__title-wrap">
                                                            <div className="vs-heading__title">Manual Configuration Details</div>
                                                        </div>
                                                    </div>
                                                    <div className="vertical-stepper__content">
                                                        {integrationConfigurations.length > 0 ? integrationConfigurations.map((config, idx) => (
                                                            <div key={config.id} className='tw-border-2 tw-border-solid tw-border-[#9BCBFF] tw-px-4 tw-rounded-xl tw-mb-4' style={this.state.integrationValidationErrors?.[config.id] ? { borderColor: '#FDA29B' } : undefined}>
                                                                <div className='d-flex align-items-center justify-content-between tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB]'>
                                                                    <div className='tw-flex tw-items-center tw-gap-2'>
                                                                        {(this.state.editingIntegrationId === config.id || (!config.integrationName || config.integrationName.trim() === '')) ? (
                                                                            <>
                                                                                <div>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        autoFocus
                                                                                        className={
                                                                                            (!config.integrationName || config.integrationName.trim() === '' || this.isDuplicateIntegrationName(config.integrationName, config.id)) 
                                                                                                ? "tw-max-w-sm tw-font-medium tw-text-black dark:tw-text-[#B2B5BE] is-invalid" 
                                                                                                : "tw-max-w-sm tw-font-medium tw-text-black dark:tw-text-[#B2B5BE]"
                                                                                        }
                                                                                        name="integration_name"
                                                                                        value={config.integrationName || ''}
                                                                                        placeholder="Enter Integration Name"
                                                                                        onChange={(e) => this.handleIntegrationNameChange(config.id, e.target.value)}
                                                                                        onKeyDown={(e) => {
                                                                                            if (e.key === 'Enter') {
                                                                                                e.preventDefault();
                                                                                                this.handleSaveIntegrationName(config.id);
                                                                                            }
                                                                                        }}
                                                                                        onBlur={() => this.handleSaveIntegrationName(config.id)}
                                                                                        required
                                                                                    />
                                                                                    {this.isDuplicateIntegrationName(config.integrationName, config.id) && (
                                                                                        <div className="invalid-feedback d-block">
                                                                                            Integration with this name already exists.
                                                                                        </div>
                                                                                    )}
                                                                                    {(!config.integrationName || config.integrationName.trim() === '') && (
                                                                                        <div className="invalid-feedback d-block">
                                                                                            Integration Name is required.
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <FontAwesomeIcon icon={faDatabase} className='tw-mr-2' />
                                                                                <h5 className='tw-font-medium tw-text-black tw-m-0'>
                                                                                    {config.integrationName || `Integration configurations ${idx + 1}`}
                                                                                </h5>
                                                                                <div className={`tw-p-[6px] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-bg-[#2F6BD6]/10 ${(this.state.editingIntegrationId && (() => { const eCfg = this.state.integrationConfigurations.find(c => c.id === this.state.editingIntegrationId); return eCfg && (!eCfg.integrationName || eCfg.integrationName.trim() === '' || this.isDuplicateIntegrationName(eCfg.integrationName, eCfg.id)); })()) ? 'tw-opacity-50 tw-cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => {
                                                                                    const eCfg = this.state.integrationConfigurations.find(c => c.id === this.state.editingIntegrationId);
                                                                                    const isEditingInvalid = eCfg && (!eCfg.integrationName || eCfg.integrationName.trim() === '' || this.isDuplicateIntegrationName(eCfg.integrationName, eCfg.id));
                                                                                    if (!isEditingInvalid) {
                                                                                        this.handleEditIntegrationName(config.id, config.integrationName || `Integration configurations ${idx + 1}`);
                                                                                    }
                                                                                }}>
                                                                                    <Pencil size={20} color="#A4A7AE" />
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    {/* <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemoveIntegration(config.id)}>
                                                                        <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                                    </button> */}
                                                                </div>
                                                                <div className='tw-py-4'>
                                                                    <div className="qd-configure-integration-info__list !tw-grid-cols-1 sm:!tw-grid-cols-2">
                                                                        <div className="qd-configure-integration-info__item">
                                                                            <label className='qd-configure-integration-info__label'>{this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "Selected Bucket" : "Selected Schema"}</label>
                                                                            <span className="qd-configure-integration-info__value">
                                                                                {config.schema ? (
                                                                                    <span className='tw-flex tw-flex-wrap tw-items-center tw-gap-2'>
                                                                                        <span className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#C7D7FE] dark:tw-border-[#2B2B40] tw-bg-[#EEF4FF] dark:tw-bg-[#161622] tw-text-[#3538CD] dark:tw-text-[#53B1FD] tw-text-xs tw-font-medium tw-flex tw-items-center'>
                                                                                            <i className="tw-me-[2px]">
                                                                                                <FolderTree className="d-block tw-text-[#175CD3] dark:tw-text-[#53B1FD]" size={12} color="currentColor" />
                                                                                            </i>
                                                                                            {config.schema}
                                                                                        </span>
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className='tw-text-[#535862]'>{`No ${this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "bucket" : "schema"} selected`}</span>
                                                                                )}
                                                                            </span>
                                                                        </div>
            {(this.state.formType === 'azure_blob' || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2') && (
                                <div className="qd-configure-integration-info__item">
                                    <label className='qd-configure-integration-info__label'>Subpath</label>
                                    <span className="qd-configure-integration-info__value">
                                        {config.sub_path
                                            ? <span className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#D0D5DD] tw-bg-[#F9FAFB] tw-text-[#344054] tw-text-xs tw-font-medium tw-inline-flex tw-items-center'>{config.sub_path}</span>
                                            : <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>No subpath</span>
                                        }
                                    </span>
                                </div>
                            )}
                                                                        {this.state.formType !== 'azure_blob' && this.state.formType !== 's3' && this.state.formType !== 'azure_data_lake_gen2' && (
                                                                        <div className="qd-configure-integration-info__item">
                                                                            <label className='qd-configure-integration-info__label'>Dataset Scope</label>
                                                                            <span className="qd-configure-integration-info__value">
                                                                                <Form.Check
                                                                                    custom
                                                                                    type={'radio'}
                                                                                    id={`integrationDatasetScope_${config.id || idx}`}
                                                                                    label={config.datasetScope === 'allDatasets' ? 'All Datasets' : 'Specified Datasets'}
                                                                                    checked={true}
                                                                                    className="mr-4"
                                                                                    disabled
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                        )}
                                                                    </div>
                                                                    {this.state.formType === "azure_blob" || this.state.formType ==="s3" || this.state.formType === "azure_data_lake_gen2" ? "" :(
                                                                    <hr className='tw-my-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB]' />
                                                                    )}
                                                                    {this.state.formType === "azure_blob" || this.state.formType ==="s3" || this.state.formType === "azure_data_lake_gen2" ? "":(
                                                                    <div className="tw-mb-4 tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622] tw-mt-3">
                                                                        <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                                                            <div>
                                                                                <h6 className="tw-text-sm tw-font-medium tw-text-[#334DB7] dark:tw-text-[#A5B4FC] tw-m-0">Incremental Data Identifications</h6>
                                                                                <p className='tw-text-xs tw-text-[#546AC3] tw-m-0'>
                                                                                    {config.datasetScope === 'specifiedDatasets' ? 'Required for specified datasets' : 'Configure incremental loading (Optional)'}
                                                                                </p>
                                                                            </div>
                                                                            <button type="button" className="btn tw-mt-3 sm:tw-mt-0 tw-font-semibold tw-border-0 tw-bg-[#E6E9F6] tw-text-[#334DB7] tw-whitespace-nowrap hover:tw-bg-[#D2D7EF] hover:tw-text-[#334DB7]" onClick={() => this.handleAddIncrementalData(config.id)}>
                                                                                <Plus size={18} color="#8A99D6" className='mr-1' />Add Row
                                                                            </button>
                                                                        </div>
                                                                        <div className={`integration-collapse-content ${(config.incrementalData || []).length > 0 ? "open" : ""}`}>
                                                                            {(config.incrementalData || []).map((item, itemIndex) => (
                                                                                <div key={item.id || itemIndex} className="dataset-partition-card" style={this.state.integrationValidationErrors?.[config.id]?.datasets?.[item.id] ? { border: '2px solid #FDA29B' } : undefined}>
                                                                                    <div className='dp-card__head'>
                                                                                        <span className="dp-card__label">Incremental Data {itemIndex + 1}</span>
                                                                                        {(config.datasetScope === 'allDatasets' || (config.incrementalData || []).length > 1) && (
                                                                                            <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.openConfirmRemove({ type: 'incremental', configId: config.id, itemId: item.id, label: item.datasetName || `Incremental Data ${itemIndex + 1}` })}>
                                                                                                <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                    <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] tw-m-0' />
                                                                                    <div className="dp-card__content">
                                                                                        <div className="form-row">
                                                                                            <div className="form-group col-md-6 col-lg-4">
                                                                                                <label>Dataset Name <span className="text-danger">*</span></label>
                                                                                                <div className="icon-input-group">
                                                                                                    <i><Layers size={18} color="#A4A7AE" /></i>
                                                                                                    <input type="text" 
                                                                                                        className={(!item.datasetName || item.datasetName.trim() === '') ? "form-control is-invalid" : (this.isDatasetAssignedToAnotherIntegration(config, item) || this.state.integrationValidationErrors[config.id]?.datasets?.[item.id]) ? "form-control is-invalid" : "form-control"}
                                                                                                        value={item.datasetName || ''} 
                                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, item.id, 'datasetName', e.target.value)} 
                                                                                                    />
                                                                                                </div>
                                                                                                {(!item.datasetName || item.datasetName.trim() === '') && (
                                                                                                    <div className="error-text">Dataset Name is required field</div>
                                                                                                )}
                                                                                                {item.datasetName && item.datasetName.trim() !== '' && this.isDatasetAssignedToAnotherIntegration(config, item) && (
                                                                                                    <div className="error-text">Dataset Name "{item.datasetName}" is already associated with another integration in this schema</div>
                                                                                                )}
                                                                                                {this.state.integrationValidationErrors[config.id]?.datasets?.[item.id] && (
                                                                                                    <div className="error-text">{this.state.integrationValidationErrors[config.id].datasets[item.id]}</div>
                                                                                                )}
                                                                                                <Form.Text className="text-muted">
                                                                                                    <Form.Check
                                                                                                        custom
                                                                                                        type="checkbox"
                                                                                                        label="Exact match only"
                                                                                                        id={`exact-match_${config.id}_${item.id}`}
                                                                                                        checked={item.exactMatch}
                                                                                                        onChange={(e) => this.handleExactMatchChange(config.id, item.id, e.target.checked)}
                                                                                                    />
                                                                                                </Form.Text>
                                                                                            </div>
                                                                                            <div className="form-group col-md-6 col-lg-4">
                                                                                                <label>Incremental Data Identifier {config.datasetScope !== 'specifiedDatasets' && <span className="text-danger">*</span>}</label>
                                                                                                <div className="icon-input-group">
                                                                                                    <i><HardDrive size={18} color="#A4A7AE" /></i>
                                                                                                    <input type="text" 
                                                                                                        className={(config.datasetScope !== 'specifiedDatasets' && (!item.identifier || item.identifier.trim() === '')) ? "form-control is-invalid" : "form-control"}
                                                                                                        value={item.identifier || ''} 
                                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, item.id, 'identifier', e.target.value)} 
                                                                                                    />
                                                                                                </div>
                                                                                                {(config.datasetScope !== 'specifiedDatasets' && (!item.identifier || item.identifier.trim() === '')) && (
                                                                                                    <div className="error-text">Incremental Data Identifier is required field</div>
                                                                                                )}
                                                                                            </div>
                                                                                            <div className="form-group col-md-6 col-lg-4">
                                                                                                <div className="custom-control custom-checkbox mb-2">
                                                                                                    <input
                                                                                                        id={`start_index_check_box_${config.id}_${item.id}`}
                                                                                                        type="checkbox"
                                                                                                        checked={!!item.startingIndexCheckbox}
                                                                                                        className="custom-control-input"
                                                                                                        onChange={(e) => this.handleStartingIndexCheckbox(config.id, item.id, e.target.checked)}
                                                                                                    />
                                                                                                    <label className="custom-control-label" htmlFor={`start_index_check_box_${config.id}_${item.id}`}>
                                                                                                        Starting Index (Optional)
                                                                                                    </label>
                                                                                                </div>
                                                                                                <div>
                                                                                                    <div className="custom-control custom-radio">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            className="custom-control-input"
                                                                                                            id={`radio_by_value_${config.id}_${item.id}`}
                                                                                                            name={`start_index_${config.id}_${item.id}`}
                                                                                                            value="incremental data identifier"
                                                                                                            checked={(item.startingIndexType || 'incremental data identifier') === 'incremental data identifier'}
                                                                                                            disabled={!item.startingIndexCheckbox}
                                                                                                            onChange={() => this.handleStartingIndexTypeChange(config.id, item.id, 'incremental data identifier')}
                                                                                                        />
                                                                                                        <label className="custom-control-label" htmlFor={`radio_by_value_${config.id}_${item.id}`}>
                                                                                                            By Value
                                                                                                        </label>
                                                                                                    </div>
                                                                                                    <div className="custom-control custom-radio">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            className="custom-control-input"
                                                                                                            id={`radio_by_query_${config.id}_${item.id}`}
                                                                                                            name={`start_index_${config.id}_${item.id}`}
                                                                                                            value="custom query"
                                                                                                            checked={item.startingIndexType === 'custom query'}
                                                                                                            disabled={!item.startingIndexCheckbox}
                                                                                                            onChange={() => this.handleStartingIndexTypeChange(config.id, item.id, 'custom query')}
                                                                                                        />
                                                                                                        <label className="custom-control-label" htmlFor={`radio_by_query_${config.id}_${item.id}`}>
                                                                                                            By Query
                                                                                                        </label>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            {item.startingIndexCheckbox && (item.startingIndexType || 'incremental data identifier') === 'incremental data identifier' && (
                                                                                                <div className="form-group col-md-6 col-lg-4">
                                                                                                    <label>Starting Index Value</label>
                                                                                                    <input type="text" 
                                                                                                        className={(!item.startingIndexValue || item.startingIndexValue.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                                        value={item.startingIndexValue || ''} 
                                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, item.id, 'startingIndexValue', e.target.value)} 
                                                                                                    />
                                                                                                    {(!item.startingIndexValue || item.startingIndexValue.trim() === '') && (
                                                                                                        <div className="error-text">Starting Index Value is required field</div>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}
                                                                                            {item.startingIndexCheckbox && item.startingIndexType === 'custom query' && (
                                                                                                <div className="form-group col-md-12 col-lg-8">
                                                                                                    <label>Starting Index Query</label>
                                                                                                    <input type="text" 
                                                                                                        className={(!item.startingIndexQuery || item.startingIndexQuery.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                                        value={item.startingIndexQuery || ''} 
                                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, item.id, 'startingIndexQuery', e.target.value)} 
                                                                                                    />
                                                                                                    {(!item.startingIndexQuery || item.startingIndexQuery.trim() === '') && (
                                                                                                        <div className="error-text">Starting Index query is required field</div>
                                                                                                    )}
                                                                                                    <Form.Text className="text-muted"><strong className="mr-1">Note:</strong>This query will be used for Starting Index.</Form.Text>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                    ) }
                                                                    {this.state.formType === "azure_blob" || this.state.formType ==="s3" || this.state.formType === "azure_data_lake_gen2" ? "" : (
                                                                    <div className="tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                                                                        <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                                                            <div>
                                                                                <h6 className="tw-text-sm tw-font-medium tw-text-[#334DB7] dark:tw-text-[#A5B4FC] tw-m-0">Partitions</h6>
                                                                                <p className='tw-text-xs tw-text-[#546AC3] tw-m-0'>Configure partitioning dataset.</p>
                                                                            </div>
                                                                            <button type="button" className="btn tw-mt-3 sm:tw-mt-0 tw-font-semibold tw-border-0 tw-bg-[#E6E9F6] tw-text-[#334DB7] tw-whitespace-nowrap hover:tw-bg-[#D2D7EF] hover:tw-text-[#334DB7]" onClick={() => this.handleAddPartitionToConfig(config.id)}>
                                                                                <Plus size={18} color="#8A99D6" className='mr-1' />Add Row
                                                                            </button>
                                                                        </div>
                                                                        <div className={`integration-collapse-content ${(config.partitions || []).length > 0 ? "open" : ""}`}>
                                                                            {(config.partitions || []).map((partition, partitionIndex) => (
                                                                                <div key={partition.id || partitionIndex} className="dataset-partition-card" style={this.state.integrationValidationErrors?.[config.id]?.partitions?.[partition.id] ? { border: '2px solid #FDA29B' } : undefined}>
                                                                                    <div className='dp-card__head'>
                                                                                        <span className="dp-card__label">Partition {partitionIndex + 1}</span>
                                                                                        <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.openConfirmRemove({ type: 'partition', configId: config.id, itemId: partition.id, label: partition.partitionName || `Partition ${partitionIndex + 1}` })}>
                                                                                            <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                                                        </button>
                                                                                    </div>
                                                                                    <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] tw-m-0' />
                                                                                    <div className="dp-card__content">
                                                                                        <div className="form-row">
                                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                                <Form.Label>{config.datasetScope === 'allDatasets' ? 'Dataset Name' : 'Select Dataset'}</Form.Label>
                                                                                                {config.datasetScope === 'allDatasets' ? (
                                                                                                    <Form.Control
                                                                                                        type="text"
                                                                                                        className={(!partition.datasetName || partition.datasetName.trim() === '' || this.state.integrationValidationErrors?.[config.id]?.partitions?.[partition.id]) ? "form-control is-invalid" : "form-control"}
                                                                                                        name="dataset_name"
                                                                                                        placeholder="Dataset Name"
                                                                                                        value={partition.datasetName || ''}
                                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'datasetName', e.target.value)}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <Select
                                                                                                        name="dataset_name"
                                                                                                        classNamePrefix={(!partition.datasetName || partition.datasetName.trim() === '' || this.state.integrationValidationErrors?.[config.id]?.partitions?.[partition.id]) ? 'select-control is-invalid' : 'select-control'}
                                                                                                        options={this.getDatasetsForPartitionOptions(config, partition)}
                                                                                                        placeholder={(config.incrementalData || []).length === 0 ? "" : "Dataset"}
                                                                                                        isDisabled={(config.incrementalData || []).length === 0}
                                                                                                        value={partition.datasetName ? { label: partition.datasetName, value: partition.datasetName } : null}
                                                                                                        styles={{
                                                                                                            control: (base, state) => ({
                                                                                                                ...base,
                                                                                                                borderColor: this.state.integrationValidationErrors?.[config.id]?.partitions?.[partition.id]
                                                                                                                    ? '#FDA29B'
                                                                                                                    : base.borderColor,
                                                                                                                '&:hover': {
                                                                                                                    ...base['&:hover'],
                                                                                                                    borderColor: this.state.integrationValidationErrors?.[config.id]?.partitions?.[partition.id]
                                                                                                                        ? '#FDA29B'
                                                                                                                        : base['&:hover']?.borderColor
                                                                                                                }
                                                                                                            })
                                                                                                        }}
                                                                                                        onChange={(selectedOption) => this.handlePartitionFieldChange(config.id, partition.id, 'datasetName', selectedOption?.value || '')}
                                                                                                        components={{ Control: customSelectDataset }}
                                                                                                    />
                                                                                                )}
                                                                                                {(!partition.datasetName || partition.datasetName.trim() === '') && (
                                                                                                    <div className="error-text">Dataset Name is required field</div>
                                                                                                )}
                                                                                                {this.state.integrationValidationErrors?.[config.id]?.partitions?.[partition.id] && (
                                                                                                    <div className="error-text">{this.state.integrationValidationErrors[config.id].partitions[partition.id]}</div>
                                                                                                )}
                                                                                            </Form.Group>
                                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                                <Form.Label>Partition Name</Form.Label>
                                                                                                    <Form.Control
                                                                                                    type="text"
                                                                                                        className={(!partition.partitionName || partition.partitionName.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                                    name="partition_name"
                                                                                                    placeholder="Partition Name"
                                                                                                    value={partition.partitionName || ''}
                                                                                                    onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'partitionName', e.target.value)}
                                                                                                />
                                                                                                {(!partition.partitionName || partition.partitionName.trim() === '') && (
                                                                                                    <div className="error-text">Partition Name is required field</div>
                                                                                                )}
                                                                                            </Form.Group>
                                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                                <Form.Label className='d-block'>Partition By</Form.Label>
                                                                                                <select className="form-control" value={partition.partitionBy || 'Column'} onChange={(e) => this.handlePartitionByChange(config.id, partition.id, e.target.value)}>
                                                                                                    <option value="Column">Column</option>
                                                                                                    <option value="Custom Query">Custom Query</option>
                                                                                                </select>
                                                                                            </Form.Group>
                                                                                            {(partition.partitionBy === 'Column' || partition.partitionBy === undefined) && (
                                                                                                <Form.Group className="col-md-6 col-lg-4">
                                                                                                    <Form.Label>Partition Identifier</Form.Label>
                                                                                                    <Form.Control
                                                                                                        type="text"
                                                                                                        className={(!partition.partitionIdentifier || partition.partitionIdentifier.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                                        name="partition_identifier"
                                                                                                        placeholder="Partition Identifier"
                                                                                                        value={partition.partitionIdentifier || ''}
                                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'partitionIdentifier', e.target.value)}
                                                                                                    />
                                                                                                    {(!partition.partitionIdentifier || partition.partitionIdentifier.trim() === '') && (
                                                                                                        <div className="error-text">Partition Identifier is required field</div>
                                                                                                    )}
                                                                                                </Form.Group>
                                                                                            )}
                                                                                            {partition.partitionBy === 'Custom Query' && (
                                                                                                <Form.Group className="col-md-12 col-lg-8">
                                                                                                    <Form.Label>Custom Query</Form.Label>
                                                                                                    <Form.Control
                                                                                                        as="textarea"
                                                                                                        rows={2}
                                                                                                        name="custom_query"
                                                                                                        className={(!partition.customQuery || partition.customQuery.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                                        placeholder="Enter your custom query here..."
                                                                                                        value={partition.customQuery || ''}
                                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'customQuery', e.target.value)}
                                                                                                    />
                                                                                                    {(!partition.customQuery || partition.customQuery.trim() === '') && (
                                                                                                        <div className="error-text">Custom Query is required field</div>
                                                                                                    )}
                                                                                                </Form.Group>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                    ) }
                                                                </div>
                                                            </div>
                                                        )) : (
                                                            <div className='tw-rounded-lg tw-border tw-border-dashed tw-border-[#D5D7DA] tw-bg-[#F8FAFC] tw-p-4 tw-text-[#535862]'>
                                                                No manual configuration details are available yet. Add a configuration to continue.
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                            <div className="vertical-stepper__heading !tw-pt-4 sm:!tw-pt-8">
                                                <div className={"d-flex align-items-center tw-pl-1"}>
                                                    <Form.Check
                                                        custom
                                                        type={'checkbox'}
                                                        id={`storeData`}
                                                        className="tw-mr-2 md:tw-mr-4"
                                                        checked={true}
                                                        readOnly
                                                        aria-readonly="true"
                                                    />
                                                    <div>
                                                        <h5 className="tw-mb-1 tw-font-[400] tw-text-black dark:tw-text-[#B2B5BE]">Store Data Issues and Errors</h5>
                                                        <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">Log and store processing errors for debugging and monitoring</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-right border-top tw-py-3 tw-pe-4 sm:tw-pe-6 mt-auto d-none">
                                        <button
                                            className="btn btn-outline btn-grey tw-mr-3"
                                            onClick={() => this.props.closeModal ? this.props.closeModal() : this.props.setPage(false)}
                                            disabled={this.state.isCreatingDatasource}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={this.handleSaveIntegration}
                                            disabled={!this.isCreateDatasourceEnabled()}
                                        >
                                            {this.state.isCreatingDatasource ? (
                                                <div className="tw-flex tw-items-center tw-justify-center">
                                                    <div className="tw-w-[14px] tw-h-[14px] tw-border tw-border-solid tw-rounded-full tw-border-white tw-border-t-transparent tw-animate-spin"></div>
                                                    <span className='tw-ml-2'>Saving...</span>
                                                </div>
                                            ) : (
                                                <>
                                                    <Check size={18} color="currentColor" className='mr-1' />Save Integration
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-md-4">
                                <div className="portlet-body tw-h-full">
                                    <div id="add-datasource_help" class="qd-helpGuide tw-h-full">
                                        <div class="qd-helpGuide__content">
                                            {/* <div class="connector-badge">
                                                <i class="connector-icon">
                                                    <svg width="20" height="20" viewBox="0 0 147 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_1563_1485)">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M134.806 60.0962L118.336 69.5862L134.806 78.9962C135.791 79.5655 136.654 80.3232 137.346 81.226C138.038 82.1289 138.546 83.1592 138.84 84.2582C139.134 85.3572 139.208 86.5033 139.059 87.6311C138.91 88.7589 138.541 89.8463 137.971 90.8312C137.402 91.8161 136.644 92.6793 135.741 93.3713C134.839 94.0634 133.808 94.5709 132.709 94.8648C131.61 95.1587 130.464 95.2333 129.336 95.0842C128.209 94.9352 127.121 94.5655 126.136 93.9962L96.6262 76.9962C95.2737 76.2137 94.1576 75.0807 93.3955 73.7166C92.6334 72.3526 92.2536 70.8081 92.2962 69.2462C92.3193 68.5695 92.4234 67.8981 92.6062 67.2462C93.2103 65.06 94.646 63.1972 96.6062 62.0562L126.116 45.1162C127.105 44.5445 128.198 44.1736 129.33 44.0245C130.463 43.8755 131.614 43.9513 132.718 44.2476C133.821 44.5439 134.855 45.0548 135.761 45.7513C136.667 46.4477 137.426 47.3159 137.996 48.3062C138.568 49.2879 138.94 50.3734 139.089 51.4999C139.239 52.6263 139.163 53.7712 138.866 54.868C138.569 55.9649 138.057 56.9919 137.361 57.8894C136.664 58.7869 135.795 59.537 134.806 60.0962ZM119.216 106.096L89.7162 89.1262C88.3964 88.3687 86.9013 87.9699 85.3796 87.9692C83.8579 87.9686 82.3625 88.3661 81.042 89.1224C79.7215 89.8787 78.6219 90.9674 77.8525 92.2803C77.0831 93.5932 76.6707 95.0845 76.6562 96.6062V130.506C76.7327 132.759 77.6812 134.893 79.3016 136.46C80.922 138.026 83.0875 138.901 85.3412 138.901C87.5949 138.901 89.7605 138.026 91.3809 136.46C93.0013 134.893 93.9498 132.759 94.0262 130.506V111.506L110.536 120.996C111.521 121.566 112.609 121.936 113.737 122.086C114.865 122.236 116.011 122.162 117.111 121.868C118.21 121.575 119.241 121.068 120.144 120.376C121.048 119.684 121.806 118.821 122.376 117.836C122.946 116.851 123.317 115.764 123.466 114.636C123.616 113.508 123.542 112.361 123.248 111.262C122.955 110.162 122.448 109.131 121.756 108.228C121.064 107.324 120.201 106.566 119.216 105.996V106.096ZM85.2162 72.9362L72.9162 85.0862C72.4954 85.4774 71.9501 85.7076 71.3762 85.7362H67.7662C67.1937 85.7018 66.6502 85.4724 66.2262 85.0862L53.9962 72.8962C53.6136 72.4787 53.3875 71.9416 53.3562 71.3762V67.7762C53.3892 67.2082 53.615 66.6685 53.9962 66.2462L66.2262 54.0562C66.6512 53.6729 67.1948 53.447 67.7662 53.4162H71.3762C71.9486 53.4429 72.4935 53.6693 72.9162 54.0562L85.1762 66.2462C85.5545 66.6695 85.7767 67.2093 85.8062 67.7762V71.3762C85.7785 71.9405 85.5559 72.4778 85.1762 72.8962L85.2162 72.9362ZM75.4162 69.5562C75.369 68.9732 75.1258 68.4234 74.7262 67.9962L71.1762 64.4862C70.7508 64.1036 70.2075 63.8778 69.6362 63.8462H69.5062C68.9375 63.876 68.3968 64.1022 67.9762 64.4862L64.4262 67.9962C64.0451 68.4256 63.8228 68.9727 63.7962 69.5462V69.6762C63.8214 70.2411 64.0444 70.7791 64.4262 71.1962L67.9962 74.6962C68.4177 75.0788 68.9579 75.3048 69.5262 75.3362H69.6562C70.2275 75.3046 70.7708 75.0788 71.1962 74.6962L74.7462 71.1662C75.1297 70.7483 75.359 70.2121 75.3962 69.6462L75.4162 69.5562ZM19.9262 33.0762L49.4362 49.9962C50.7575 50.7533 52.2539 51.1517 53.7768 51.1516C55.2996 51.1516 56.796 50.7532 58.1173 49.9961C59.4386 49.2389 60.5388 48.1492 61.3087 46.8353C62.0786 45.5214 62.4915 44.029 62.5062 42.5062V8.63619C62.4298 6.38379 61.4813 4.24919 59.8609 2.68284C58.2405 1.1165 56.0749 0.240938 53.8212 0.240938C51.5675 0.240938 49.402 1.1165 47.7816 2.68284C46.1612 4.24919 45.2127 6.38379 45.1362 8.63619V27.6362L28.6062 18.1362C27.6213 17.5663 26.5338 17.1959 25.4057 17.0462C24.2777 16.8966 23.1312 16.9706 22.0318 17.264C20.9323 17.5575 19.9014 18.0646 18.998 18.7564C18.0945 19.4483 17.3361 20.3113 16.7662 21.2962C16.1963 22.2811 15.8259 23.3686 15.6763 24.4967C15.5266 25.6247 15.6006 26.7712 15.8941 27.8706C16.1875 28.9701 16.6946 30.001 17.3864 30.9044C18.0783 31.8079 18.9413 32.5663 19.9262 33.1362V33.0762ZM84.6862 51.1562C86.4288 51.294 88.1722 50.9 89.6862 50.0262L119.186 33.0262C120.171 32.4563 121.034 31.6979 121.726 30.7944C122.418 29.891 122.925 28.8601 123.218 27.7606C123.512 26.6612 123.586 25.5147 123.436 24.3867C123.287 23.2586 122.916 22.1711 122.346 21.1862C121.776 20.2013 121.018 19.3383 120.114 18.6464C119.211 17.9546 118.18 17.4475 117.081 17.154C114.86 16.5614 112.495 16.8752 110.506 18.0262L93.9962 27.6062V8.60619C93.9198 6.35379 92.9713 4.21919 91.3509 2.65284C89.7305 1.0865 87.5649 0.210938 85.3112 0.210938C83.0575 0.210938 80.892 1.0865 79.2716 2.65284C77.6512 4.21919 76.7026 6.35379 76.6262 8.60619V42.5062C76.6235 44.701 77.4542 46.8149 78.9504 48.4207C80.4466 50.0264 82.4967 51.0041 84.6862 51.1562ZM54.4762 87.9962C52.7333 87.8546 50.9888 88.2488 49.4762 89.1262L19.9262 106.056C17.9371 107.207 16.4867 109.101 15.8941 111.322C15.3015 113.542 15.6152 115.907 16.7662 117.896C17.9173 119.885 19.8113 121.336 22.0318 121.928C24.2522 122.521 26.6171 122.207 28.6062 121.056L45.1362 111.566V130.566C45.2127 132.819 46.1612 134.953 47.7816 136.52C49.402 138.086 51.5675 138.961 53.8212 138.961C56.0749 138.961 58.2405 138.086 59.8609 136.52C61.4813 134.953 62.4298 132.819 62.5062 130.566V96.6062C62.5017 94.4225 61.6715 92.3212 60.1821 90.7243C58.6926 89.1273 56.6543 88.1527 54.4762 87.9962ZM46.4762 72.1262C47.0459 70.2529 46.96 68.2415 46.2328 66.4235C45.5057 64.6056 44.1806 63.0898 42.4762 62.1262L12.9962 45.1362C11.0053 43.9958 8.64409 43.6891 6.42786 44.283C4.21163 44.8768 2.32019 46.3231 1.16621 48.3062C0.594906 49.2876 0.223871 50.3726 0.0745668 51.4983C-0.074737 52.6241 0.000654668 53.7682 0.296381 54.8647C0.592107 55.9611 1.1023 56.988 1.79744 57.886C2.49258 58.7839 3.35887 59.5352 4.34621 60.0962L20.8162 69.5862L4.34621 78.9962C3.3613 79.5642 2.4979 80.3206 1.80531 81.2222C1.11272 82.1238 0.604499 83.1531 0.309673 84.2511C0.0148467 85.3492 -0.0608148 86.4946 0.0870081 87.6218C0.234831 88.7491 0.603243 89.8363 1.17121 90.8212C1.73918 91.8061 2.49558 92.6695 3.39722 93.3621C4.29886 94.0547 5.32809 94.5629 6.42615 94.8577C7.5242 95.1526 8.66957 95.2282 9.79686 95.0804C10.9242 94.9326 12.0113 94.5642 12.9962 93.9962L42.4762 76.9962C44.3746 75.9363 45.8005 74.196 46.4662 72.1262H46.4762ZM139.626 15.9062H138.296V17.5362H139.616C140.226 17.5362 140.616 17.2562 140.616 16.7362C140.616 16.2162 140.256 15.9062 139.616 15.9062H139.626ZM136.686 14.4062H139.686C141.306 14.4062 142.386 15.2962 142.386 16.6762C142.391 17.0603 142.294 17.4389 142.104 17.7729C141.914 18.1068 141.639 18.3841 141.306 18.5762L142.476 20.2562V20.5962H140.786L139.616 18.9962H138.296V20.5962H136.676L136.686 14.4062ZM144.986 17.6262C145.035 16.8692 144.926 16.1103 144.666 15.3976C144.406 14.6849 144.001 14.034 143.476 13.4859C142.952 12.9379 142.319 12.5047 141.619 12.2139C140.918 11.923 140.165 11.7808 139.406 11.7962C136.096 11.7962 133.896 14.1862 133.896 17.6262C133.896 20.9062 136.096 23.4462 139.406 23.4462C140.165 23.4644 140.919 23.3245 141.621 23.0354C142.323 22.7463 142.957 22.3143 143.483 21.7669C144.008 21.2195 144.414 20.5687 144.675 19.8558C144.936 19.1429 145.045 18.3836 144.996 17.6262H144.986ZM146.366 17.6262C146.366 21.5162 143.766 24.7662 139.366 24.7662C134.966 24.7662 132.476 21.4862 132.476 17.6262C132.476 13.7662 135.046 10.4862 139.366 10.4862C143.686 10.4862 146.356 13.7262 146.356 17.6262H146.366Z" fill="#29B5E8"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0_1563_1485">
                                                        <rect width="146.36" height="139.16" fill="white"/>
                                                        </clipPath>
                                                        </defs>
                                                    </svg>
                                                </i>
                                                <span class="connector-label">Snowflake</span>
                                            </div>
                                            <div class="connector-badge">
                                                <div class="tw-flex tw-items-center tw-gap-2">
                                                    <div class="tw-w-5 tw-h-5 tw-rounded tw-bg-[#d6d6d6] tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                    <div class="tw-h-4 tw-w-20 tw-bg-[#d6d6d6] tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="tw-h-6 tw-w-4/6 tw-bg-[#d6d6d6] tw-mb-3 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-full tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-5/6 tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-4/6 tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-3/6 tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                            </div> 
                                            {/* <h4 class="qd-helpGuide__title">Steps to enable access from your storage to Qualdo™: </h4>
                                            <ol class="qd-helpGuide__info">
                                                {this.renderHelpContent()}
                                            </ol> 
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                {this.renderTest()}
                <Modal show={this.state.showSchemeModal} size="md" centered onHide={this.handleCloseSchemeModal}>
                    <Modal.Header closeButton>
                        <div className='tw-flex tw-items-center tw-gap-4'>
                            <div className='tw-flex tw-items-center tw-justify-center tw-p-[10px] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/20 tw-bg-white dark:tw-bg-white/10 tw-rounded-[10px]'>
                                <FolderTree size={20} color="currentColor" className="tw-text-[#414651] dark:tw-text-white" />
                            </div>
                            <div>
                                <h5 className="modal-title !tw-mb-[2px] tw-font-semibold !tw-text-gray-900 dark:!tw-text-white">Available Schemas</h5>
                                <div className='tw-flex tw-items-center tw-gap-2 tw-gap-2'>
                                    <div className='tw-px-2 tw-py-[2px] tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-medium tw-text-[#175CD3] dark:!tw-text-white tw-border tw-border-solid tw-border-[#B2DDFF] dark:!tw-border-white/30 dark:!tw-bg-white/10 tw-rounded-[6px] tw-uppercase' onClick={this.handleRefreshSchemas}>
                                        <i className='tw-mr-1'>
                                            <svg className='tw-block' width="14" height="14" viewBox="0 0 147 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_1563_1485)">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M134.806 60.0962L118.336 69.5862L134.806 78.9962C135.791 79.5655 136.654 80.3232 137.346 81.226C138.038 82.1289 138.546 83.1592 138.84 84.2582C139.134 85.3572 139.208 86.5033 139.059 87.6311C138.91 88.7589 138.541 89.8463 137.971 90.8312C137.402 91.8161 136.644 92.6793 135.741 93.3713C134.839 94.0634 133.808 94.5709 132.709 94.8648C131.61 95.1587 130.464 95.2333 129.336 95.0842C128.209 94.9352 127.121 94.5655 126.136 93.9962L96.6262 76.9962C95.2737 76.2137 94.1576 75.0807 93.3955 73.7166C92.6334 72.3526 92.2536 70.8081 92.2962 69.2462C92.3193 68.5695 92.4234 67.8981 92.6062 67.2462C93.2103 65.06 94.646 63.1972 96.6062 62.0562L126.116 45.1162C127.105 44.5445 128.198 44.1736 129.33 44.0245C130.463 43.8755 131.614 43.9513 132.718 44.2476C133.821 44.5439 134.855 45.0548 135.761 45.7513C136.667 46.4477 137.426 47.3159 137.996 48.3062C138.568 49.2879 138.94 50.3734 139.089 51.4999C139.239 52.6263 139.163 53.7712 138.866 54.868C138.569 55.9649 138.057 56.9919 137.361 57.8894C136.664 58.7869 135.795 59.537 134.806 60.0962ZM119.216 106.096L89.7162 89.1262C88.3964 88.3687 86.9013 87.9699 85.3796 87.9692C83.8579 87.9686 82.3625 88.3661 81.042 89.1224C79.7215 89.8787 78.6219 90.9674 77.8525 92.2803C77.0831 93.5932 76.6707 95.0845 76.6562 96.6062V130.506C76.7327 132.759 77.6812 134.893 79.3016 136.46C80.922 138.026 83.0875 138.901 85.3412 138.901C87.5949 138.901 89.7605 138.026 91.3809 136.46C93.0013 134.893 93.9498 132.759 94.0262 130.506V111.506L110.536 120.996C111.521 121.566 112.609 121.936 113.737 122.086C114.865 122.236 116.011 122.162 117.111 121.868C118.21 121.575 119.241 121.068 120.144 120.376C121.048 119.684 121.806 118.821 122.376 117.836C122.946 116.851 123.317 115.764 123.466 114.636C123.616 113.508 123.542 112.361 123.248 111.262C122.955 110.162 122.448 109.131 121.756 108.228C121.064 107.324 120.201 106.566 119.216 105.996V106.096ZM85.2162 72.9362L72.9162 85.0862C72.4954 85.4774 71.9501 85.7076 71.3762 85.7362H67.7662C67.1937 85.7018 66.6502 85.4724 66.2262 85.0862L53.9962 72.8962C53.6136 72.4787 53.3875 71.9416 53.3562 71.3762V67.7762C53.3892 67.2082 53.615 66.6685 53.9962 66.2462L66.2262 54.0562C66.6512 53.6729 67.1948 53.447 67.7662 53.4162H71.3762C71.9486 53.4429 72.4935 53.6693 72.9162 54.0562L85.1762 66.2462C85.5545 66.6695 85.7767 67.2093 85.8062 67.7762V71.3762C85.7785 71.9405 85.5559 72.4778 85.1762 72.8962L85.2162 72.9362ZM75.4162 69.5562C75.369 68.9732 75.1258 68.4234 74.7262 67.9962L71.1762 64.4862C70.7508 64.1036 70.2075 63.8778 69.6362 63.8462H69.5062C68.9375 63.876 68.3968 64.1022 67.9762 64.4862L64.4262 67.9962C64.0451 68.4256 63.8228 68.9727 63.7962 69.5462V69.6762C63.8214 70.2411 64.0444 70.7791 64.4262 71.1962L67.9962 74.6962C68.4177 75.0788 68.9579 75.3048 69.5262 75.3362H69.6562C70.2275 75.3046 70.7708 75.0788 71.1962 74.6962L74.7462 71.1662C75.1297 70.7483 75.359 70.2121 75.3962 69.6462L75.4162 69.5562ZM19.9262 33.0762L49.4362 49.9962C50.7575 50.7533 52.2539 51.1517 53.7768 51.1516C55.2996 51.1516 56.796 50.7532 58.1173 49.9961C59.4386 49.2389 60.5388 48.1492 61.3087 46.8353C62.0786 45.5214 62.4915 44.029 62.5062 42.5062V8.63619C62.4298 6.38379 61.4813 4.24919 59.8609 2.68284C58.2405 1.1165 56.0749 0.240938 53.8212 0.240938C51.5675 0.240938 49.402 1.1165 47.7816 2.68284C46.1612 4.24919 45.2127 6.38379 45.1362 8.63619V27.6362L28.6062 18.1362C27.6213 17.5663 26.5338 17.1959 25.4057 17.0462C24.2777 16.8966 23.1312 16.9706 22.0318 17.264C20.9323 17.5575 19.9014 18.0646 18.998 18.7564C18.0945 19.4483 17.3361 20.3113 16.7662 21.2962C16.1963 22.2811 15.8259 23.3686 15.6763 24.4967C15.5266 25.6247 15.6006 26.7712 15.8941 27.8706C16.1875 28.9701 16.6946 30.001 17.3864 30.9044C18.0783 31.8079 18.9413 32.5663 19.9262 33.1362V33.0762ZM84.6862 51.1562C86.4288 51.294 88.1722 50.9 89.6862 50.0262L119.186 33.0262C120.171 32.4563 121.034 31.6979 121.726 30.7944C122.418 29.891 122.925 28.8601 123.218 27.7606C123.512 26.6612 123.586 25.5147 123.436 24.3867C123.287 23.2586 122.916 22.1711 122.346 21.1862C121.776 20.2013 121.018 19.3383 120.114 18.6464C119.211 17.9546 118.18 17.4475 117.081 17.154C114.86 16.5614 112.495 16.8752 110.506 18.0262L93.9962 27.6062V8.60619C93.9198 6.35379 92.9713 4.21919 91.3509 2.65284C89.7305 1.0865 87.5649 0.210938 85.3112 0.210938C83.0575 0.210938 80.892 1.0865 79.2716 2.65284C77.6512 4.21919 76.7026 6.35379 76.6262 8.60619V42.5062C76.6235 44.701 77.4542 46.8149 78.9504 48.4207C80.4466 50.0264 82.4967 51.0041 84.6862 51.1562ZM54.4762 87.9962C52.7333 87.8546 50.9888 88.2488 49.4762 89.1262L19.9262 106.056C17.9371 107.207 16.4867 109.101 15.8941 111.322C15.3015 113.542 15.6152 115.907 16.7662 117.896C17.9173 119.885 19.8113 121.336 22.0318 121.928C24.2522 122.521 26.6171 122.207 28.6062 121.056L45.1362 111.566V130.566C45.2127 132.819 46.1612 134.953 47.7816 136.52C49.402 138.086 51.5675 138.961 53.8212 138.961C56.0749 138.961 58.2405 138.086 59.8609 136.52C61.4813 134.953 62.4298 132.819 62.5062 130.566V96.6062C62.5017 94.4225 61.6715 92.3212 60.1821 90.7243C58.6926 89.1273 56.6543 88.1527 54.4762 87.9962ZM46.4762 72.1262C47.0459 70.2529 46.96 68.2415 46.2328 66.4235C45.5057 64.6056 44.1806 63.0898 42.4762 62.1262L12.9962 45.1362C11.0053 43.9958 8.64409 43.6891 6.42786 44.283C4.21163 44.8768 2.32019 46.3231 1.16621 48.3062C0.594906 49.2876 0.223871 50.3726 0.0745668 51.4983C-0.074737 52.6241 0.000654668 53.7682 0.296381 54.8647C0.592107 55.9611 1.1023 56.988 1.79744 57.886C2.49258 58.7839 3.35887 59.5352 4.34621 60.0962L20.8162 69.5862L4.34621 78.9962C3.3613 79.5642 2.4979 80.3206 1.80531 81.2222C1.11272 82.1238 0.604499 83.1531 0.309673 84.2511C0.0148467 85.3492 -0.0608148 86.4946 0.0870081 87.6218C0.234831 88.7491 0.603243 89.8363 1.17121 90.8212C1.73918 91.8061 2.49558 92.6695 3.39722 93.3621C4.29886 94.0547 5.32809 94.5629 6.42615 94.8577C7.5242 95.1526 8.66957 95.2282 9.79686 95.0804C10.9242 94.9326 12.0113 94.5642 12.9962 93.9962L42.4762 76.9962C44.3746 75.9363 45.8005 74.196 46.4662 72.1262H46.4762ZM139.626 15.9062H138.296V17.5362H139.616C140.226 17.5362 140.616 17.2562 140.616 16.7362C140.616 16.2162 140.256 15.9062 139.616 15.9062H139.626ZM136.686 14.4062H139.686C141.306 14.4062 142.386 15.2962 142.386 16.6762C142.391 17.0603 142.294 17.4389 142.104 17.7729C141.914 18.1068 141.639 18.3841 141.306 18.5762L142.476 20.2562V20.5962H140.786L139.616 18.9962H138.296V20.5962H136.676L136.686 14.4062ZM144.986 17.6262C145.035 16.8692 144.926 16.1103 144.666 15.3976C144.406 14.6849 144.001 14.034 143.476 13.4859C142.952 12.9379 142.319 12.5047 141.619 12.2139C140.918 11.923 140.165 11.7808 139.406 11.7962C136.096 11.7962 133.896 14.1862 133.896 17.6262C133.896 20.9062 136.096 23.4462 139.406 23.4462C140.165 23.4644 140.919 23.3245 141.621 23.0354C142.323 22.7463 142.957 22.3143 143.483 21.7669C144.008 21.2195 144.414 20.5687 144.675 19.8558C144.936 19.1429 145.045 18.3836 144.996 17.6262H144.986ZM146.366 17.6262C146.366 21.5162 143.766 24.7662 139.366 24.7662C134.966 24.7662 132.476 21.4862 132.476 17.6262C132.476 13.7662 135.046 10.4862 139.366 10.4862C143.686 10.4862 146.356 13.7262 146.356 17.6262H146.366Z" fill="#29B5E8" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1563_1485">
                                                        <rect width="146.36" height="139.16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </i>
                                        Snowflake
                                    </div>
                                    <strong className='tw-text-sm tw-text-[#535862] dark:!tw-text-white !tw-font-medium tw-ms-1'>{this.state.testConnectionFormData?.database || 'N/A'}</strong>
                                </div>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.schemeModalLoading ? (
                            <div className='tw-py-[60px] tw-text-center'>
                                <i className='tw-p-4 tw-rounded-full tw-bg-[linear-gradient(180deg,#FAFAFA,#E9EAEB)] tw-inline-flex tw-items-center tw-justify-center tw-mb-4'>
                                    <div className="tw-w-[32px] tw-h-[32px] tw-border-4 tw-border-solid tw-rounded-full tw-border-[#D1E9FF] tw-border-t-[#0021A5] tw-animate-spin"></div>
                                </i>
                                <div>
                                    <h5 className='tw-text-base tw-font-medium tw-text-[#181D27] dark:tw-text-[#B2B5BE] tw-mt-0 tw-mb-1'>Fetching Schemas</h5>
                                    <p className='tw-text-sm tw-text-[#535862] dark:tw-text-[#787B86] tw-my-0'>Connecting to Snowflake...</p>
                                </div>
                            </div>
                        ) : (
                            <><div className='tw-rounded-lg tw-border tw-border-solid tw-border-[#ABEFC6] tw-bg-[#F6FEF9] tw-py-2 tw-px-3 tw-mb-3'>
                                <div className="d-flex align-items-center tw-gap-[10px]">
                                    <i><CircleCheck size={18} color="#17B26A" /></i>
                                    <div>
                                        <span className="tw-block tw-text-sm tw-text-[#067647] tw-font-medium">
                                            Successfully fetched{" "}
                                            {this.state.testConnectionResponse?.schemas?.length || 0} schemas
                                        </span>

                                        <span className='tw-block tw-text-xs tw-text-[#079455]'>Select the schemas you want to work with. You can select multiple schemas.</span>
                                    </div>
                                </div>
                            </div>

                                <div className='tw-p-3 tw-rounded-xl tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FAFAFA] dark:tw-bg-[#161622]'>
                                    <div className='d-flex align-items-center justify-content-between tw-mb-3'>
                                        <div className="qd-search-bar has-btn-close tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-rounded-lg tw-flex-1 tw-me-3">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <button id="button-addon4" type="button" className="btn">
                                                        <svg className='d-block' width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z" stroke="#A4A7AE" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <input
                                                    type="search"
                                                    placeholder="Search"
                                                    className="form-control h-100"
                                                    value={this.state.schemaSearchText}
                                                    onChange={(e) => this.setState({ schemaSearchText: e.target.value })}
                                                />
                                            </div>
                                            {/* {this.state.saveWatchListSearchText && <button className="btn btn-clear" title="clear" onClick={() => this.setState({ saveWatchListSearchText: '' })}><i className="icon-close"></i></button>} */}
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline btn-grey !tw-px-2 !tw-py-1 !tw-rounded-lg tw-whitespace-nowrap hover:!tw-shadow-none"
                                            onClick={this.handleSelectAllSchemas}
                                        >
                                            {this.state.selectedSchemas.length === (this.state.testConnectionResponse?.schemas || []).length && this.state.testConnectionResponse?.schemas?.length > 0
                                                ? 'Deselect All'
                                                : 'Select All'}
                                        </button>
                                    </div>
                                    <div className='tw-rounded-lg tw-border tw-border-solid tw-border-black/10 tw-bg-white dark:tw-bg-[#1E1E2D] tw-p-2'>
                                        {(() => {
                                            const filteredSchemas = this.state.testConnectionResponse?.schemas?.filter(schema =>
                                                schema.toLowerCase().includes(this.state.schemaSearchText.toLowerCase())
                                            ) || [];

                                            return filteredSchemas.length > 0 ? (
                                                filteredSchemas.map((schema, index) => (
                                                    <div className='tw-mb-[2px]' key={index}>
                                                        <div className='custom-control custom-checkbox custom-control-inline d-flex tw-px-2 tw-py-1 tw-m-0 tw-cursor-pointer tw-rounded-lg hover:tw-bg-[#F5F5F5] dark:hover:tw-bg-[#2B2B40]'>
                                                            <label className="d-flex align-items-center tw-mr-8 tw-mb-0 tw-font-medium">
                                                                <input
                                                                    type="checkbox"
                                                                    name="schema"
                                                                    className="mr-2"
                                                                    checked={this.state.selectedSchemas.includes(schema)}
                                                                    onChange={() => this.handleSchemaSelect(schema)}
                                                                />
                                                                <span className='d-flex align-items-center'>
                                                                    <i><FolderTree size={16} color="#A4A7AE" className='tw-me-2' /></i>
                                                                    {schema}
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className='tw-text-center tw-py-3 tw-text-[#535862] dark:tw-text-[#787B86]'>
                                                    No Schemas Found
                                                </div>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer className='justify-content-between tw-p-5'>
                        <div>
                            <p className={`tw-text-sm tw-m-0 ${this.state.selectedSchemas.length > 0 ? 'tw-text-[#079455]' : 'tw-text-[#535862] dark:tw-text-[#787B86]'}`}>
                                {this.state.selectedSchemas.length > 0
                                    ? `${this.state.selectedSchemas.length} schema${this.state.selectedSchemas.length > 1 ? 's' : ''} selected`
                                    : 'Please select at least one schema'}
                            </p>
                        </div>
                        <div className='m-0'>
                            <button type="button" className="btn btn-outline btn-grey tw-me-2" onClick={this.handleCloseSchemeModal}>Cancel</button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={this.handleCloseSchemeModal}
                                disabled={this.state.selectedSchemas.length === 0}
                            >
                                <i><Check size={20} color="currentColor" className='mr-1' /></i> Confirm Selection ({this.state.selectedSchemas.length})
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* Remove confirmation modal for edit mode */}
                {this.state.confirmRemoveModal && (() => {
                    const { type, configId, label } = this.state.confirmRemoveModal;
                    const removalConfig = integrationConfigurations.find(config => config.id === configId);
                    const typeLabels = {
                        integration: 'Integration',
                        partition: 'Partition',
                    };
                    const warningMessages = {
                        integration: 'Deleting this Integration is permanent and cannot be undone. All associated Integration resources will also be deleted. Kindly ensure that no resources (e.g., databases) are currently in use before proceeding.',
                        incremental: removalConfig?.datasetScope === 'allDatasets'
                            ? 'Deleting this incremental data is permanent and cannot be undone.'
                            : 'Deleting this Dataset is permanent and cannot be undone. All partitions associated with this dataset will also be deleted.',
                        partition: 'Deleting this partition is permanent and cannot be undone.',
                    };
                    const typeLabel = type === 'incremental'
                        ? 'Dataset'
                        : (typeLabels[type] || 'Item');
                    const modalTitle = type === 'incremental' && removalConfig?.datasetScope === 'allDatasets'
                        ? 'Remove Incremental Data'
                        : `Remove ${typeLabel}`;
                    return (
                        <Modal show={true} centered onHide={this.closeConfirmRemove}>
                            <Modal.Header closeButton className="d-none" />
                            <Modal.Body>
                                <div className="modal__alert">
                                    <div className="modal_alert-icon">
                                        <i className="text-danger">
                                            <Trash2 size={28} color="currentColor" />
                                        </i>
                                    </div>
                                    <div className="confirmation-alert_text">
                                        <h4>{modalTitle}</h4>
                                        <p>
                                            Please confirm the name of the {typeLabel.toLowerCase()} to remove:{' '}
                                            <strong>{label}</strong>
                                        </p>
                                    </div>
                                    <div className="confirmation-alert_form">
                                        <Form.Group controlId="remove-confirmation-name" className="mx-auto" style={{width: '85%'}}>
                                            <Form.Control
                                                type="text"
                                                placeholder={`Enter ${typeLabel.toLowerCase()} name to confirm`}
                                                className="mb-3 text-center pl-3 font-weight-medium"
                                                value={this.state.confirmRemoveName}
                                                onChange={(event) => this.setState({ confirmRemoveName: event.target.value })}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="alert alert-danger text-left">
                                        <i className="text-danger mr-2">
                                            <TriangleAlert size={18} color="currentColor" />
                                        </i>
                                        {warningMessages[type] || 'This action cannot be undone.'}
                                    </div>
                                    <div className="modal_alert-btn-group">
                                        <button
                                            type="button"
                                            onClick={this.closeConfirmRemove}
                                            className="btn btn-outline btn-grey btn-circle mr-2"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            onClick={this.confirmRemove}
                                            disabled={this.state.confirmRemoveName !== label}
                                            className="btn btn-danger btn-circle mr-2"
                                        >
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    );
                })()}
            </>
        );
    }

    getViewIntegrationContent(data_source_option) {
        // eslint-disable-next-line
        const integrationDetails = this.state.ex_edit_integration_details;
        const formData = this.state.testConnectionFormData || {};
        const integrationConfigs = this.state.integrationConfigurations || [];
        const selectedSchemas = this.state.selectedSchemas || [];
        const schemaModeSelection = this.state.schemaModeSelection || 'allSchemas';
        const configurationMode = this.state.configurationMode || 'autoconfig';
        const isVersionRefreshType = ['file_version', 'folder_version'].includes(
            (formData.refreshType || '').toLowerCase()
        );

        // Helper to render schema chips
        const renderSchemaChips = (schemas) => (
            schemas.map((schema, idx) => (
                <span key={idx} className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#C7D7FE] tw-bg-[#EEF4FF] tw-text-[#3538CD] tw-text-xs tw-font-medium tw-flex tw-items-center'>
                    <i className="tw-me-[2px]">
                        <FolderTree className="d-block" size={12} color="#175CD3" />
                    </i>
                    {schema}
                </span>
            ))
        );

        // Helper to render partitions
        const renderPartitions = (partitions) => (
            partitions.map((partition, idx) => (
                <div key={idx} className="dataset-partition-card">
                    <div className='dp-card__head'>
                        <span className="dp-card__label">{`Partition ${idx + 1}`}</span>
                    </div>
                    <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                    <div className="dp-card__content">
                        <div className="qd-configure-integration-info__list !tw-grid-cols-1 sm:!tw-grid-cols-2">
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Select Dataset</label>
                                <span className="qd-configure-integration-info__value">
                                    <i><Layers size={20} color="#A4A7AE" /></i>
                                    <RcTooltip placement="top" overlay={<span>{partition.datasetName}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{partition.datasetName}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Partition Name</label>
                                <span className="qd-configure-integration-info__value">
                                    <RcTooltip placement="top" overlay={<span>{partition.partitionName}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{partition.partitionName}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Partition By</label>
                                <span className="qd-configure-integration-info__value">
                                    <RcTooltip placement="top" overlay={<span>{partition.partitionBy}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{partition.partitionBy}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>
                                    {partition.partitionBy === 'Custom Query' ? 'Custom Query' : 'Partition Identifier'}
                                </label>
                                <span className="qd-configure-integration-info__value">
                                    <i><TextSearch size={20} color="#A4A7AE" /></i>
                                    <RcTooltip
                                        placement="top"
                                        overlay={<span>{partition.partitionBy === 'Custom Query' ? partition.customQuery : partition.partitionIdentifier}</span>}
                                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                    >
                                        <span>{partition.partitionBy === 'Custom Query' ? partition.customQuery : partition.partitionIdentifier}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            ))
        );

        // Helper to render incremental data
        const renderIncrementalData = (incrementalData) => (
            incrementalData.map((item, idx) => (
                <div key={idx} className="dataset-partition-card">
                    <div className='dp-card__head'>
                        <span className="dp-card__label">{`Incremental Data Identification ${idx + 1}`}</span>
                    </div>
                    <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                    <div className="dp-card__content">
                        <div className="qd-configure-integration-info__list !tw-grid-cols-1 sm:!tw-grid-cols-2">
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Dataset Name</label>
                                <span className="qd-configure-integration-info__value">
                                    <i><Layers size={20} color="#A4A7AE" /></i>
                                    <RcTooltip placement="top" overlay={<span>{item.datasetName}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{item.datasetName}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Incremental Data Identifier</label>
                                <span className="qd-configure-integration-info__value">
                                    <i><HardDrive size={20} color="#A4A7AE" /></i>
                                    <RcTooltip placement="top" overlay={<span>{item.identifier}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{item.identifier}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                        {item.exactMatch && (
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Exact Match</label>
                                <span className="qd-configure-integration-info__value">
                                    <RcTooltip placement="top" overlay={<span>Yes</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>Yes</span>
                                    </RcTooltip>
                                </span>
                            </div>
                        )}
                        {item.startingIndexCheckbox && (
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Starting Index Type</label>
                                <span className="qd-configure-integration-info__value">
                                    <RcTooltip placement="top" overlay={<span>{item.startingIndexType === 'incremental data identifier' ? 'Incremental Data Identifier' : 'Custom Query'}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{item.startingIndexType === 'incremental data identifier' ? 'Incremental Data Identifier' : 'Custom Query'}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                        )}
                        {item.startingIndexCheckbox && item.startingIndexType === 'incremental data identifier' && (
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Starting Index Value</label>
                                <span className="qd-configure-integration-info__value">
                                    <RcTooltip placement="top" overlay={<span>{item.startingIndexValue}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{item.startingIndexValue}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                        )}
                        {item.startingIndexCheckbox && item.startingIndexType === 'custom query' && (
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Starting Index Query</label>
                                <span className="qd-configure-integration-info__value">
                                    <RcTooltip placement="top" overlay={<span>{item.startingIndexQuery}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{item.startingIndexQuery}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                        )}
                        </div>
                    </div>
                </div>
            ))
        );

        // Resolve host field across all integration types
        const hostValue = formData.host_url || formData.host || formData.account_name || formData.server || formData.project_id || formData.bucket_name || '';
        // Resolve database/catalog field across all integration types
        const databaseValue = formData.database_name || formData.database || formData.dataset_id || formData.filesystem_name || formData.catalog || '';
        // Resolve auth user field across all integration types
        const authUser = formData.username || formData.user_name || formData.access_key_id || formData.client_id || '';

        return (
            <div className="portlet portlet-2col" id="view_integration_model">
                <div className="d-flex flex-column h-100">
                    <div className="qd-configure-integration-steps">
                        <div className="vertical-stepper vertical-stepper-sm w-100 border-0">

                            {/* Step 1: Integration Details */}
                            <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">
                                <span className="vs-heading__circle">1</span>
                                <div className="vs-heading__title">Datasource Details</div>
                            </div>
                            <div className="vertical-stepper__content">
                                <div className="qd-configure-integration-info">
                                    <div className="qd-configure-integration-info__content">
                                        <div className="qd-configure-integration-info__list">
                                            <div className="qd-configure-integration-info__item">
                                                <label className='qd-configure-integration-info__label'>Type</label>
                                                <span className="qd-configure-integration-info__value">
                                                    <i><Database size={16} color="#A4A7AE" /></i>
                                                    <span>{this.getDatasourceLabel(this.state.formType)}</span>
                                                </span>
                                            </div>
                                            <div className="qd-configure-integration-info__item">
                                                <label className='qd-configure-integration-info__label'>Datasource Name</label>
                                                <span className="qd-configure-integration-info__value">
                                                    <i><Database size={16} color="#A4A7AE" /></i>
                                                    <RcTooltip placement="top" overlay={<span>{formData.datasource_name || integrationDetails?.integration_name}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                        <span>{formData.datasource_name || integrationDetails?.integration_name}</span>
                                                    </RcTooltip>
                                                </span>
                                            </div>
                                            {/* File connectors: show file settings and connector credentials */}
                                            {this.state.formType === 'azure_blob' || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2' ? (
                                                <>
                                                    {this.state.formType === 'azure_blob' && this.state.formType === 'azure_data_lake_gen2' (
                                                    <div className="qd-configure-integration-info__item">
                                                        <label className='qd-configure-integration-info__label'>Storage Name</label>
                                                        <span className="qd-configure-integration-info__value">
                                                            <i><HardDrive size={16} color="#A4A7AE" /></i>
                                                            <RcTooltip placement="top" overlay={<span>{formData.storage_name}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                                <span>{formData.storage_name || '—'}</span>
                                                            </RcTooltip>
                                                        </span>
                                                    </div>
                                                    )}
                                                    {formData.fileType && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>File Type</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <i><Layers size={16} color="#A4A7AE" /></i>
                                                                <span>{formData.fileType}</span>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {formData.refreshType && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Refresh Type</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <i><Layers2 size={16} color="#A4A7AE" /></i>
                                                                <span>{formData.refreshType}</span>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {isVersionRefreshType && formData.versionFormat && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Refresh Format</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <i><Layers3 size={16} color="#A4A7AE" /></i>
                                                                <span>{formData.versionFormat}</span>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {isVersionRefreshType && formData.versionFormat === 'custom' && formData.versionFormatRegex && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Custom Refresh Format</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <i><TextSearch size={16} color="#A4A7AE" /></i>
                                                                <RcTooltip placement="top" overlay={<span>{formData.versionFormatRegex}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                                    <span>{formData.versionFormatRegex}</span>
                                                                </RcTooltip>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {isVersionRefreshType && formData.versionOccurence && formData.versionOccurence !== 'default' && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Refresh Format Occurrence</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <i><TextSearch size={16} color="#A4A7AE" /></i>
                                                                <span>{formData.versionOccurence}</span>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {formData.sub_path && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Sub Path</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <i><FolderOpen size={16} color="#A4A7AE" /></i>
                                                                <span>{formData.sub_path}</span>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {this.state.formType === 's3' && formData.accessKey && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Access Key</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <i><LockKeyhole size={16} color="#A4A7AE" /></i>
                                                                {this.state.showSecret?.['view_s3_access_key'] ? (
                                                                    <RcTooltip placement="top" overlay={<span>{formData.accessKey}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                                        <span>{formData.accessKey}</span>
                                                                    </RcTooltip>
                                                                ) : (
                                                                    <span>••••••••</span>
                                                                )}
                                                                <i className='cursor-pointer' onClick={() => this.toggleSecretVisibility('view_s3_access_key')}>
                                                                    {this.state.showSecret?.['view_s3_access_key'] ? <EyeOff size={16} color="#A4A7AE" /> : <Eye size={16} color="#A4A7AE" />}
                                                                </i>
                                                            </span>
                                                        </div>
                                                    )}
                                                    <div className="qd-configure-integration-info__item">
                                                        <label className='qd-configure-integration-info__label'>{this.state.formType === 's3' ? 'Secret Access Key' : 'Blob Secret'}</label>
                                                        <span className="qd-configure-integration-info__value">
                                                            <i><LockKeyhole size={16} color="#A4A7AE" /></i>
                                                            {this.state.showSecret?.[this.state.formType === 's3' ? 'view_s3_secret' : 'view_blob_secret'] ? (
                                                                <RcTooltip placement="top" overlay={<span>{this.state.formType === 's3' ? formData.secretAccessKey : (formData.blob_secret || integrationDetails?.auth_config?.secret_key || '')}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                                    <span>{this.state.formType === 's3' ? formData.secretAccessKey : (formData.blob_secret || integrationDetails?.auth_config?.secret_key || '')}</span>
                                                                </RcTooltip>
                                                            ) : (
                                                                <span>••••••••</span>
                                                            )}
                                                            <i className='cursor-pointer' onClick={() => this.toggleSecretVisibility(this.state.formType === 's3' ? 'view_s3_secret' : 'view_blob_secret')}>
                                                                {this.state.showSecret?.[this.state.formType === 's3' ? 'view_s3_secret' : 'view_blob_secret'] ? <EyeOff size={16} color="#A4A7AE" /> : <Eye size={16} color="#A4A7AE" />}
                                                            </i>
                                                        </span>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    {hostValue && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Host</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <i><HardDrive size={16} color="#A4A7AE" /></i>
                                                                <RcTooltip placement="top" overlay={<span>{hostValue}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                                    <span>{hostValue}</span>
                                                                </RcTooltip>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {databaseValue && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Database</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <i><Database size={16} color="#A4A7AE" /></i>
                                                                <RcTooltip placement="top" overlay={<span>{databaseValue}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                                    <span>{databaseValue}</span>
                                                                </RcTooltip>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {authUser && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Auth</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <i><LockKeyhole size={16} color="#A4A7AE" /></i>
                                                                <RcTooltip placement="top" overlay={<span>{authUser}/{this.state.showSecret?.['view_auth_password'] ? (formData.password || integrationDetails?.auth_config?.password || '') : "••••••••"}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                                    <span>{authUser}/{this.state.showSecret?.['view_auth_password'] ? (formData.password || integrationDetails?.auth_config?.password || '') : "••••••••"}</span>
                                                                </RcTooltip>
                                                                <i className='cursor-pointer' onClick={() => this.toggleSecretVisibility('view_auth_password')}>
                                                                    {this.state.showSecret?.['view_auth_password'] ? <EyeOff size={16} color="#A4A7AE" /> : <Eye size={16} color="#A4A7AE" />}
                                                                </i>
                                                            </span>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                            <div className="qd-configure-integration-info__item">
                                                <label className='qd-configure-integration-info__label'>Status</label>
                                                <span className="qd-configure-integration-info__value">
                                                    <span>{getDatasourceStatus(this.state.ex_edit_integration_details?.auto_config_status || this.props.ex_integration_details?.auto_config_status || 'completed')}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Step 2: Schema & Mode Selection */}
                            <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">
                                <span className="vs-heading__circle">2</span>
                                <div className="vs-heading__title-wrap">
                                    <div className="vs-heading__title">
                                        {this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "Bucket & Mode Selection" : "Schema & Mode Selection"}
                                    </div>
                                </div>
                            </div>
                            <div className="vertical-stepper__content">
                                <div className="qd-configure-integration-info">
                                    <div className="qd-configure-integration-info__content">
                                        <div className="qd-configure-integration-info__list !tw-grid-cols-1">
                                            <div className="qd-configure-integration-info__item">
                                                <label className='qd-configure-integration-info__label'>
                                                    {`${schemaModeSelection === 'allSchemas' ? 'All' : 'Specified'} ${this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "Buckets" : "Schemas"}`}
                                                </label>
                                                <span className="qd-configure-integration-info__value">
                                                    {schemaModeSelection === 'allSchemas'
                                                        ? <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>{`Process all available ${this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "buckets" : "schemas"} automatically`}</span>
                                                        : <div className='tw-flex tw-flex-wrap tw-gap-1'>{renderSchemaChips(selectedSchemas)}</div>
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <hr className='tw-block tw-my-3' />
                                        <div className="qd-configure-integration-info__list">
                                            <div className="qd-configure-integration-info__item">
                                                <label className='qd-configure-integration-info__label'>Configuration Mode</label>
                                                <span className="qd-configure-integration-info__value">
                                                    <Form.Check
                                                        custom
                                                        type={'radio'}
                                                        id={`integrationConfigMode_${configurationMode}`}
                                                        label={configurationMode === 'autoconfig' ? 'Autoconfig' : 'Manual Config'}
                                                        checked={true}
                                                        className="mr-4"
                                                        disabled
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Step 3: Manual Configuration Details */}
                            {configurationMode === 'manual' && integrationConfigs.length > 0 && (
                                <>
                                    <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">
                                        <span className="vs-heading__circle">3</span>
                                        <div className="vs-heading__title-wrap">
                                            <div className="vs-heading__title">Manual Configuration Details</div>
                                        </div>
                                    </div>
                                    <div className="vertical-stepper__content">
                                        {integrationConfigs.map((config, idx) => (
                                            <div key={config.id || idx} className='tw-border-2 tw-border-solid tw-border-[#9BCBFF] tw-px-4 tw-rounded-xl tw-mb-4' style={this.state.integrationValidationErrors?.[config.id] ? { borderColor: '#FDA29B' } : undefined}>
                                                <div className='d-flex align-items-center justify-content-between tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                    <div className='tw-flex tw-items-center tw-gap-2'>
                                                        <FontAwesomeIcon icon={faDatabase} />
                                                        <h5 className='tw-font-medium tw-text-black tw-m-0'>{config.integrationName || `Integration ${idx + 1}`}</h5>
                                                    </div>
                                                </div>
                                                <div className="tw-py-4">
                                                    <div className="qd-configure-integration-info__list !tw-grid-cols-1 sm:!tw-grid-cols-2">
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>
                                                                {this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? "Selected Bucket" : "Selected Schema"}
                                                            </label>
                                                            <span className="qd-configure-integration-info__value">
                                                                {(config.schema || config.schema_name || config.bucket)
                                                                    ? renderSchemaChips([config.schema || config.schema_name || config.bucket])
                                                                    : <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>No {this.state.formType === "azure_blob" || this.state.formType === "s3" || this.state.formType === "azure_data_lake_gen2" ? 'bucket' : 'schema'} selected</span>
                                                                }
                                                            </span>
                                                        </div>
            {(this.state.formType === 'azure_blob' || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2') && (
                                <div className="qd-configure-integration-info__item">
                                    <label className='qd-configure-integration-info__label'>Subpath</label>
                                    <span className="qd-configure-integration-info__value">
                                        {config.sub_path
                                            ? <span className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#D0D5DD] tw-bg-[#F9FAFB] tw-text-[#344054] tw-text-xs tw-font-medium tw-inline-flex tw-items-center'>{config.sub_path}</span>
                                            : <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>No subpath</span>
                                        }
                                    </span>
                                </div>
                            )}
                                                        {this.state.formType !== 'azure_blob' && this.state.formType !== 's3' && this.state.formType !== 'azure_data_lake_gen2' && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Dataset Scope</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <Form.Check
                                                                    custom
                                                                    type={'radio'}
                                                                    id={`integrationDatasetScope_${config.id || idx}`}
                                                                    label={config.datasetScope === 'allDatasets' ? 'All Datasets' : 'Specified Datasets'}
                                                                    checked={true}
                                                                    className="mr-4"
                                                                    disabled
                                                                />
                                                            </span>
                                                        </div>
                                                        )}
                                                    </div>
                                                    {config.incrementalData && config.incrementalData.length > 0 && (
                                                        <div className="tw-mb-4 tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622] tw-mt-3">
                                                            <h6 className="tw-text-sm tw-font-medium tw-text-[#334DB7] tw-m-0">Incremental Data Identifications</h6>
                                                            <div className="integration-collapse-content open">
                                                                {renderIncrementalData(config.incrementalData)}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {config.partitions && config.partitions.length > 0 && (
                                                        <>
                                                            <hr className='tw-my-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]' />
                                                            <div className="tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                                                                <h6 className="tw-text-sm tw-font-medium tw-text-[#334DB7] tw-m-0">Partitions</h6>
                                                                <div className="integration-collapse-content open">
                                                                    {renderPartitions(config.partitions)}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        {/* Store Data Issues and Errors */}
                        <div className="vertical-stepper__heading tw-pt-4 sm:!tw-pt-8">
                            <div className={"d-flex align-items-center tw-pl-1"}>
                                <Form.Check
                                    custom
                                    type={'checkbox'}
                                    id={`storeData`}
                                    className="tw-mr-2 md:tw-mr-4"
                                    checked={true}
                                    readOnly
                                    aria-readonly="true"
                                />
                                <div>
                                    <h5 className="tw-mb-1 tw-font-[400] tw-text-black">Store Data Issues and Errors</h5>
                                    <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">Log and store processing errors for debugging and monitoring</p>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    render() {
        const data_source_option = this.state.data_source_options;
        let editLoad = false;

        if (this.props.src_page === "edit_integration" && this.state.ex_edit_integration_details === null) {
            editLoad = true;
            this.getIntegrationDetailById(this.props.ex_integration_details["integration_id"], this.props.ex_integration_details["env_id"]);
        }

        return (
            editLoad ?
                <Load />
                :
                <>
                    {
                        this.props.ex_integration_details !== undefined && this.props.view === true ?
                            this.getViewIntegrationContent(data_source_option) :
                        this.props.ex_integration_details !== undefined ?
                            this.getEditIntegrationContent(data_source_option) :
                            this.getAddIntegrationContent(data_source_option)
                    }
                </>
        );
    }
}
export default Integration;
